/**
 * Generated by orval v6.29.0 🍺
 * Do not edit manually.
 * Cloudsaver.Customers.Host.Api
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from 'react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query'
import type {
  Account,
  AccountConnectedStatus,
  ApiAccessKeyResult,
  AppFeatures,
  AwsCWMetricsConfig,
  AwsMarketplaceOffer,
  AwsMarketplaceSubscription,
  AwsResourceSyncBlacklist,
  AzureConnectivityInfo,
  AzureMarketplaceOffer,
  AzureMarketplaceSubscription,
  AzureSubscriptionInfo,
  BulkAssignMspUsers,
  BulkAssignSupportCompanies,
  BulkAssignSupportUsers,
  BulkRemoveMspUsers,
  BulkUserRoleChange,
  CWMetricsConfigData,
  Card,
  CloudProviderConnectionStatus,
  Company,
  CompanyAccount,
  CompanyAddress,
  CompanyApp,
  CompanyApps,
  CompanyCloudProvider,
  CompanyCloudProviderRequest,
  CompanyConfiguration,
  CompanyCreditUsage,
  CompanyDailyCreditSnapshot,
  CompanyFeature,
  CompanyInfo,
  CompanyRelationshipBundle,
  CompanyRoleListItem,
  CompanyStandardTag,
  CompanyStat,
  CompanyStatQueryResult,
  CompanyStatsQuery,
  CompanySubscriptionType,
  CompanyTypeRequest,
  CompanyUser,
  CompanyUserRole,
  CreateAwsMarketplacePrivateOfferRequest,
  CreditRates,
  CreditSummary,
  CreditTransaction,
  CustomerFeedbackRequest,
  CustomerSubsidyRequest,
  CustomerSubsidyViewModel,
  DashboardConfig,
  DashboardUserSettings,
  DataAccessDefinitionBundle,
  DeleteAccountDeleteMasterAccountParams,
  DeleteAccountDeleteSecondaryAccountParams,
  DeleteCompanyDeleteCompanyParams,
  DeleteCspMktStagePrivateAwsSubscriptionParams,
  DeleteDashboardParams,
  DeleteOrganizationDeleteOrganizationParams,
  DeleteRbacDeleteRoleParams,
  DeleteUserDeleteUserParams,
  EffectivePermissions,
  EmailVerified,
  EstimateRequest,
  ExternalApiKey,
  FrontEndError,
  GcpBillingAccount,
  GcpConnectivityInfo,
  GcpProjectInfo,
  GetAccountCheckIfIsMasterAccountParams,
  GetAccountDisconnectMasterAccountParams,
  GetAccountDisconnectSecondaryAccountParams,
  GetAccountGetAccountByAWSIdParams,
  GetAccountGetAccountConnectionStatusInternalParams,
  GetAccountGetAccountConnectionStatusParams,
  GetAccountGetAccountParams,
  GetAccountGetAccountsByAwsOUIdParams,
  GetAccountGetAccountsByOUParams,
  GetCWMetricsConfigGetCWMetricsConfigDataParams,
  GetCWMetricsConfigGetCWMetricsConfigFiltersParams,
  GetCWMetricsConfigGetCWMetricsConfigParams,
  GetCWMetricsConfigGetCwMetricFiltersOrDefault200One,
  GetCWMetricsConfigGetCwMetricFiltersOrDefault200Three,
  GetCWMetricsConfigGetCwMetricFiltersOrDefault200Two,
  GetCWMetricsConfigGetCwMetricFiltersOrDefaultParams,
  GetCloudIntelligenceGetCustomerCompanyParams,
  GetCloudIntelligenceGetCustomerSubsidyRequestByIdParams,
  GetCloudIntelligenceGetCustomersByUserParams,
  GetCompanyCheckCloudProviderConnectivityParams,
  GetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotParams,
  GetCompanyGetAccountCompanyParams,
  GetCompanyGetAzureConnectionInfoInternalParams,
  GetCompanyGetAzureConnectionInfoParams,
  GetCompanyGetCloudConnectionsParams,
  GetCompanyGetCompanyAppsParams,
  GetCompanyGetCompanyBySystemNameParams,
  GetCompanyGetCompanyCloudProvidersInternalParams,
  GetCompanyGetCompanyInternalParams,
  GetCompanyGetCompanyParams,
  GetCompanyGetCompanyStandardTagsParams,
  GetCompanyGetGcpBillingAccountsParams,
  GetCompanyGetGcpConnectionInfoParams,
  GetCompanyGetGcpServiceAccountInfoParams,
  GetCompanyRelationshipGetDataAccessBeneficiariesParams,
  GetCompanyRelationshipGetDataAccessDefinitionsParams,
  GetCreditsAddCreditsParams,
  GetCreditsCheckCreditCountParams,
  GetCreditsGetCreditSummaryParams,
  GetCreditsGetCreditTransactionsForPeriodParams,
  GetCreditsGetCreditsSpentForPeriodParams,
  GetCreditsIsSpendLimitedParams,
  GetCreditsTryClaimCreditsParams,
  GetCspMktGetAwsSubscriptionByIdParams,
  GetCspMktGetAwsSubscriptionParams,
  GetCspMktGetStagedAzureSubscriptionParams,
  GetDashboardGetByKeyParams,
  GetDashboardGetMyPreferencesParams,
  GetDashboardGetUserPreferencesParams,
  GetDashboardGetUsersByDashboardIdParams,
  GetDashboardParams,
  GetExternalApiKeyGetApiKeyParams,
  GetIntegrationGetIntegrationsParams,
  GetInvoiceDownloadInvoiceParams,
  GetMspCompensationCategoryGetMspCompensationCategoryParams,
  GetMspCompensationGetMspCompensationParams,
  GetMspCompensationLineItemGetMspCompensationLineItemParams,
  GetMspCompensationLineItemGetMspCompensationLineItemsByCategoryParams,
  GetMspConfigGetMspConfigByCompanyParams,
  GetMspConfigGetMspConfigByHostParams,
  GetMspConfigGetMspConfigByIdParams,
  GetMspConfigGetMspConfigByMspCompanyIdParams,
  GetMspConfigGetMspConfigForCompanyParams,
  GetMspGetMspByCompanyIdParams,
  GetMspGetMspChildCompanySubscriptionParams,
  GetMspGetMspSubscriptionTypeParams,
  GetMspGetMspUserCompaniesParams,
  GetMspGetMspsForCompanyParams,
  GetOrCreateApiClientUserRequest,
  GetOrCreateApiClientUserResponse,
  GetOrganizationGetChildOrganizationsParams,
  GetOrganizationGetOrganizationByAWSIdParams,
  GetOrganizationGetOrganizationParams,
  GetOrganizationGetOrganizationsParams,
  GetPaymentGetPendingPaymentMethodParams,
  GetRbacGetCompanyRolePermissionsParams,
  GetRbacGetRoleParams,
  GetRbacGetRolePermissionsParams,
  GetRbacGetRolesByCompanyParams,
  GetRbacGetRolesByUserIdParams,
  GetRbacGetUserAccessRulesParams,
  GetRbacGetUserRolesByUserIdParams,
  GetResourcesGetResourceSyncBlacklistParams,
  GetStagedCompanyGetByIdParams,
  GetStagedCompanyGetConnectionStatusParams,
  GetSubscriptionGetAppAccessByCompanyParams,
  GetSubscriptionGetCreditRatesParams,
  GetSubscriptionGetSubscriptionOptionsParams,
  GetSupportGetSupportedCompaniesParams,
  GetUserAzLoginParams,
  GetUserBearerLoginParams,
  GetUserGetCompanyTypesByUser200OneItem,
  GetUserGetCompanyTypesByUser200ThreeItem,
  GetUserGetCompanyTypesByUser200TwoItem,
  GetUserGetCompanyTypesByUserParams,
  GetUserGetSupportUserCompaniesParams,
  GetUserGetUserByExternalIdParams,
  GetUserGetUserByIdParams,
  GetUserGetUserCompaniesParams,
  GetUserHasAcceptedTOSParams,
  GetUserLoginCallbackParams,
  GetUserLoginParams,
  GetUserQueryUserActivityParams,
  IQueryExpr,
  Int32StringKeyValuePair,
  Integration,
  InvoiceDetail,
  Msp,
  MspCompensation,
  MspCompensationCategory,
  MspCompensationLineItem,
  MspConfig,
  MspCreditPackage,
  MspSubscriptionType,
  NewCompanyCloudProvider,
  Organization,
  PaymentSource,
  PendingPaymentMethodInfo,
  PendingPaymentMethodSecret,
  Permission,
  PostAccountConnectSecondaryAccountParams,
  PostAccountGetOrCreateLinkedParams,
  PostAccountGetOrCreateMasterParams,
  PostAccountSyncLinkedParams,
  PostAccountSyncMasterParams,
  PostAccountUpdateAccountParams,
  PostCWMetricsConfigSaveCWMetricsConfigFiltersParams,
  PostCWMetricsConfigSaveCWMetricsConfigParams,
  PostCloudIntelligenceDeleteCompanyCandidateParams,
  PostCloudIntelligenceInviteAccountRepParams,
  PostCloudIntelligenceReviewCompanyCandidateParams,
  PostCompanyAddAzureConnectivityParams,
  PostCompanyAddAzureTenantCloudProviderParams,
  PostCompanyAddAzureTenantConnectivityParams,
  PostCompanyAddGcpBillingAccountParams,
  PostCompanyAddGcpCompanyServiceAccountParams,
  PostCompanyAddGcpServiceAccountCloudProviderParams,
  PostCompanyAddUserParams,
  PostCompanyAddUsersParams,
  PostCompanyRemoveUsersParams,
  PostCompanySaveCompanyStandardTagsBodyOne,
  PostCompanySaveCompanyStandardTagsBodyThree,
  PostCompanySaveCompanyStandardTagsBodyTwo,
  PostCompanySaveCompanyStandardTagsParams,
  PostCreditsAddCreditsBySupportUserParams,
  PostCreditsUpdateCreditOverrideParams,
  PostCreditsUpdateSettingsPageParams,
  PostCspMktActivateAwsPaymentParams,
  PostCspMktActivateAwsSubscriptionParams,
  PostCspMktActivateAzureSubscriptionBySecretParams,
  PostCspMktActivateAzureSubscriptionParams,
  PostCspMktGetPendingPaymentMethodParams,
  PostDashboardRemoveSharedAccessParams,
  PostDashboardShareWithUserParams,
  PostExternalApiKeyCreateApiKeyParams,
  PostIntegrationSignOffIntegrationParams,
  PostIntegrationUpdateStatusParams,
  PostMspSaveMspUserCompaniesParams,
  PostNewSubscriptionUpdateMspCompanyInfoParams,
  PostNewSubscriptionUpdateMspCustomerCompanyInfoParams,
  PostOrganizationUpdateOrganizationParams,
  PostPaymentAddPaymentSourceParams,
  PostPaymentDeletePaymentSourceParams,
  PostPaymentUsePendingPaymentMethodParams,
  PostServiceActionSaveServiceActionParams,
  PostStagedCompanyConvertParams,
  PostUserCreateUserByEmailAddressParams,
  PostUserFacingPermissionApplyRoleUfPermissionsParams,
  PostUserFacingPermissionSaveRoleUserFacingPermissionsParams,
  PostUserGetApiClientUsersByCompanyIdParams,
  PostUserSaveTermsOfSvcAgreementParams,
  PostUserSaveUserIncludeFutureCompaniesParams,
  PostUserSaveUserStatusParams,
  PutCompanyAdminRegisterCompanyParams,
  PutCompanyCreateCompanyParams,
  PutCompanyRegisterCompanyParams,
  PutCompanySaveCompanyAppsParams,
  PutCompanySaveCustomerCompanyAppsParams,
  PutCompanyToggleCompanyAppLockedParams,
  PutExternalApiKeyRevokeApiKeyParams,
  PutUserSaveUserInfoParams,
  Role,
  RolePermission,
  RoleUserFacingPermission,
  ServiceAction,
  SingleSignOnConfig,
  StagedCompany,
  StagedCompanyConnectionStatus,
  StandardTag,
  SubscriptionDetail,
  SubscriptionOptions,
  SubscriptionType,
  SupportUserListItem,
  TOSAccepted,
  User,
  UserActivityQueryResult,
  UserFacingPermissionInfo,
  UserListItem,
  UserPreferences
} from './Customers/model'
import { request } from '../Services/BasicApi';



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const getAccountGetAccounts = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Account[]>(
      {url: `/Account/GetAccounts`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetAccountsQueryKey = () => {
    return [`/Account/GetAccounts`] as const;
    }

    
export const getGetAccountGetAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetAccounts>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetAccountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetAccounts>>> = ({ signal }) => getAccountGetAccounts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetAccounts>>>
export type GetAccountGetAccountsQueryError = unknown

export const useGetAccountGetAccounts = <TData = Awaited<ReturnType<typeof getAccountGetAccounts>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountGetAccountsByOU = (
    params?: GetAccountGetAccountsByOUParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Account[]>(
      {url: `/Account/GetAccountsByOU`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetAccountsByOUQueryKey = (params?: GetAccountGetAccountsByOUParams,) => {
    return [`/Account/GetAccountsByOU`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountGetAccountsByOUQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetAccountsByOU>>, TError = unknown>(params?: GetAccountGetAccountsByOUParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountsByOU>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetAccountsByOUQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetAccountsByOU>>> = ({ signal }) => getAccountGetAccountsByOU(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountsByOU>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetAccountsByOUQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetAccountsByOU>>>
export type GetAccountGetAccountsByOUQueryError = unknown

export const useGetAccountGetAccountsByOU = <TData = Awaited<ReturnType<typeof getAccountGetAccountsByOU>>, TError = unknown>(
 params?: GetAccountGetAccountsByOUParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountsByOU>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetAccountsByOUQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountGetAccountsByAwsOUId = (
    params?: GetAccountGetAccountsByAwsOUIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Account[]>(
      {url: `/Account/GetAccountsByAwsOUId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetAccountsByAwsOUIdQueryKey = (params?: GetAccountGetAccountsByAwsOUIdParams,) => {
    return [`/Account/GetAccountsByAwsOUId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountGetAccountsByAwsOUIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetAccountsByAwsOUId>>, TError = unknown>(params?: GetAccountGetAccountsByAwsOUIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountsByAwsOUId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetAccountsByAwsOUIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetAccountsByAwsOUId>>> = ({ signal }) => getAccountGetAccountsByAwsOUId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountsByAwsOUId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetAccountsByAwsOUIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetAccountsByAwsOUId>>>
export type GetAccountGetAccountsByAwsOUIdQueryError = unknown

export const useGetAccountGetAccountsByAwsOUId = <TData = Awaited<ReturnType<typeof getAccountGetAccountsByAwsOUId>>, TError = unknown>(
 params?: GetAccountGetAccountsByAwsOUIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountsByAwsOUId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetAccountsByAwsOUIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountGetAccount = (
    params?: GetAccountGetAccountParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Account>(
      {url: `/Account/GetAccount`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetAccountQueryKey = (params?: GetAccountGetAccountParams,) => {
    return [`/Account/GetAccount`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountGetAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetAccount>>, TError = unknown>(params?: GetAccountGetAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetAccountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetAccount>>> = ({ signal }) => getAccountGetAccount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetAccount>>>
export type GetAccountGetAccountQueryError = unknown

export const useGetAccountGetAccount = <TData = Awaited<ReturnType<typeof getAccountGetAccount>>, TError = unknown>(
 params?: GetAccountGetAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetAccountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountGetCompanyAccounts = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Account[]>(
      {url: `/Account/GetCompanyAccounts`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetCompanyAccountsQueryKey = () => {
    return [`/Account/GetCompanyAccounts`] as const;
    }

    
export const getGetAccountGetCompanyAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetCompanyAccounts>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetCompanyAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetCompanyAccountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetCompanyAccounts>>> = ({ signal }) => getAccountGetCompanyAccounts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetCompanyAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetCompanyAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetCompanyAccounts>>>
export type GetAccountGetCompanyAccountsQueryError = unknown

export const useGetAccountGetCompanyAccounts = <TData = Awaited<ReturnType<typeof getAccountGetCompanyAccounts>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetCompanyAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetCompanyAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountGetAccountByAWSId = (
    params?: GetAccountGetAccountByAWSIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Account>(
      {url: `/Account/GetAccountByAWSId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetAccountByAWSIdQueryKey = (params?: GetAccountGetAccountByAWSIdParams,) => {
    return [`/Account/GetAccountByAWSId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountGetAccountByAWSIdQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetAccountByAWSId>>, TError = unknown>(params?: GetAccountGetAccountByAWSIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountByAWSId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetAccountByAWSIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetAccountByAWSId>>> = ({ signal }) => getAccountGetAccountByAWSId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountByAWSId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetAccountByAWSIdQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetAccountByAWSId>>>
export type GetAccountGetAccountByAWSIdQueryError = unknown

export const useGetAccountGetAccountByAWSId = <TData = Awaited<ReturnType<typeof getAccountGetAccountByAWSId>>, TError = unknown>(
 params?: GetAccountGetAccountByAWSIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountByAWSId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetAccountByAWSIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAccountConnectSecondaryAccount = (
    account: Account,
    params?: PostAccountConnectSecondaryAccountParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Account/ConnectSecondaryAccount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: account,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostAccountConnectSecondaryAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountConnectSecondaryAccount>>, TError,{data: Account;params?: PostAccountConnectSecondaryAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccountConnectSecondaryAccount>>, TError,{data: Account;params?: PostAccountConnectSecondaryAccountParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountConnectSecondaryAccount>>, {data: Account;params?: PostAccountConnectSecondaryAccountParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postAccountConnectSecondaryAccount(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccountConnectSecondaryAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountConnectSecondaryAccount>>>
    export type PostAccountConnectSecondaryAccountMutationBody = Account
    export type PostAccountConnectSecondaryAccountMutationError = unknown

    export const usePostAccountConnectSecondaryAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountConnectSecondaryAccount>>, TError,{data: Account;params?: PostAccountConnectSecondaryAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAccountConnectSecondaryAccount>>,
        TError,
        {data: Account;params?: PostAccountConnectSecondaryAccountParams},
        TContext
      > => {

      const mutationOptions = getPostAccountConnectSecondaryAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAccountUpdateAccount = (
    account: Account,
    params?: PostAccountUpdateAccountParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Account/UpdateAccount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: account,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostAccountUpdateAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountUpdateAccount>>, TError,{data: Account;params?: PostAccountUpdateAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccountUpdateAccount>>, TError,{data: Account;params?: PostAccountUpdateAccountParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountUpdateAccount>>, {data: Account;params?: PostAccountUpdateAccountParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postAccountUpdateAccount(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccountUpdateAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountUpdateAccount>>>
    export type PostAccountUpdateAccountMutationBody = Account
    export type PostAccountUpdateAccountMutationError = unknown

    export const usePostAccountUpdateAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountUpdateAccount>>, TError,{data: Account;params?: PostAccountUpdateAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAccountUpdateAccount>>,
        TError,
        {data: Account;params?: PostAccountUpdateAccountParams},
        TContext
      > => {

      const mutationOptions = getPostAccountUpdateAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAccountDisconnectMasterAccount = (
    params?: GetAccountDisconnectMasterAccountParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Account/DisconnectMasterAccount`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountDisconnectMasterAccountQueryKey = (params?: GetAccountDisconnectMasterAccountParams,) => {
    return [`/Account/DisconnectMasterAccount`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountDisconnectMasterAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccountDisconnectMasterAccount>>, TError = unknown>(params?: GetAccountDisconnectMasterAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDisconnectMasterAccount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountDisconnectMasterAccountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountDisconnectMasterAccount>>> = ({ signal }) => getAccountDisconnectMasterAccount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountDisconnectMasterAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountDisconnectMasterAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountDisconnectMasterAccount>>>
export type GetAccountDisconnectMasterAccountQueryError = unknown

export const useGetAccountDisconnectMasterAccount = <TData = Awaited<ReturnType<typeof getAccountDisconnectMasterAccount>>, TError = unknown>(
 params?: GetAccountDisconnectMasterAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDisconnectMasterAccount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountDisconnectMasterAccountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountDisconnectSecondaryAccount = (
    params?: GetAccountDisconnectSecondaryAccountParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/Account/DisconnectSecondaryAccount`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountDisconnectSecondaryAccountQueryKey = (params?: GetAccountDisconnectSecondaryAccountParams,) => {
    return [`/Account/DisconnectSecondaryAccount`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountDisconnectSecondaryAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccountDisconnectSecondaryAccount>>, TError = unknown>(params?: GetAccountDisconnectSecondaryAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDisconnectSecondaryAccount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountDisconnectSecondaryAccountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountDisconnectSecondaryAccount>>> = ({ signal }) => getAccountDisconnectSecondaryAccount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountDisconnectSecondaryAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountDisconnectSecondaryAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountDisconnectSecondaryAccount>>>
export type GetAccountDisconnectSecondaryAccountQueryError = unknown

export const useGetAccountDisconnectSecondaryAccount = <TData = Awaited<ReturnType<typeof getAccountDisconnectSecondaryAccount>>, TError = unknown>(
 params?: GetAccountDisconnectSecondaryAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountDisconnectSecondaryAccount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountDisconnectSecondaryAccountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteAccountDeleteMasterAccount = (
    params?: DeleteAccountDeleteMasterAccountParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Account/DeleteMasterAccount`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteAccountDeleteMasterAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountDeleteMasterAccount>>, TError,{params?: DeleteAccountDeleteMasterAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccountDeleteMasterAccount>>, TError,{params?: DeleteAccountDeleteMasterAccountParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccountDeleteMasterAccount>>, {params?: DeleteAccountDeleteMasterAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAccountDeleteMasterAccount(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountDeleteMasterAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccountDeleteMasterAccount>>>
    
    export type DeleteAccountDeleteMasterAccountMutationError = unknown

    export const useDeleteAccountDeleteMasterAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountDeleteMasterAccount>>, TError,{params?: DeleteAccountDeleteMasterAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccountDeleteMasterAccount>>,
        TError,
        {params?: DeleteAccountDeleteMasterAccountParams},
        TContext
      > => {

      const mutationOptions = getDeleteAccountDeleteMasterAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteAccountDeleteSecondaryAccount = (
    params?: DeleteAccountDeleteSecondaryAccountParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Account/DeleteSecondaryAccount`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteAccountDeleteSecondaryAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountDeleteSecondaryAccount>>, TError,{params?: DeleteAccountDeleteSecondaryAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAccountDeleteSecondaryAccount>>, TError,{params?: DeleteAccountDeleteSecondaryAccountParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAccountDeleteSecondaryAccount>>, {params?: DeleteAccountDeleteSecondaryAccountParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteAccountDeleteSecondaryAccount(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountDeleteSecondaryAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAccountDeleteSecondaryAccount>>>
    
    export type DeleteAccountDeleteSecondaryAccountMutationError = unknown

    export const useDeleteAccountDeleteSecondaryAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAccountDeleteSecondaryAccount>>, TError,{params?: DeleteAccountDeleteSecondaryAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteAccountDeleteSecondaryAccount>>,
        TError,
        {params?: DeleteAccountDeleteSecondaryAccountParams},
        TContext
      > => {

      const mutationOptions = getDeleteAccountDeleteSecondaryAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAccountGetAccountConnectionStatus = (
    params?: GetAccountGetAccountConnectionStatusParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AccountConnectedStatus[]>(
      {url: `/Account/GetAccountConnectionStatus`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetAccountConnectionStatusQueryKey = (params?: GetAccountGetAccountConnectionStatusParams,) => {
    return [`/Account/GetAccountConnectionStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountGetAccountConnectionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetAccountConnectionStatus>>, TError = unknown>(params?: GetAccountGetAccountConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetAccountConnectionStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatus>>> = ({ signal }) => getAccountGetAccountConnectionStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetAccountConnectionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatus>>>
export type GetAccountGetAccountConnectionStatusQueryError = unknown

export const useGetAccountGetAccountConnectionStatus = <TData = Awaited<ReturnType<typeof getAccountGetAccountConnectionStatus>>, TError = unknown>(
 params?: GetAccountGetAccountConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetAccountConnectionStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountGetAccountConnectionStatusInternal = (
    params?: GetAccountGetAccountConnectionStatusInternalParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AccountConnectedStatus[]>(
      {url: `/Account/GetAccountConnectionStatusInternal`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetAccountConnectionStatusInternalQueryKey = (params?: GetAccountGetAccountConnectionStatusInternalParams,) => {
    return [`/Account/GetAccountConnectionStatusInternal`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountGetAccountConnectionStatusInternalQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetAccountConnectionStatusInternal>>, TError = unknown>(params?: GetAccountGetAccountConnectionStatusInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatusInternal>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetAccountConnectionStatusInternalQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatusInternal>>> = ({ signal }) => getAccountGetAccountConnectionStatusInternal(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatusInternal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetAccountConnectionStatusInternalQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatusInternal>>>
export type GetAccountGetAccountConnectionStatusInternalQueryError = unknown

export const useGetAccountGetAccountConnectionStatusInternal = <TData = Awaited<ReturnType<typeof getAccountGetAccountConnectionStatusInternal>>, TError = unknown>(
 params?: GetAccountGetAccountConnectionStatusInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetAccountConnectionStatusInternal>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetAccountConnectionStatusInternalQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAccountCheckIfIsMasterAccount = (
    params?: GetAccountCheckIfIsMasterAccountParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<boolean>(
      {url: `/Account/CheckIfIsMasterAccount`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountCheckIfIsMasterAccountQueryKey = (params?: GetAccountCheckIfIsMasterAccountParams,) => {
    return [`/Account/CheckIfIsMasterAccount`, ...(params ? [params]: [])] as const;
    }

    
export const getGetAccountCheckIfIsMasterAccountQueryOptions = <TData = Awaited<ReturnType<typeof getAccountCheckIfIsMasterAccount>>, TError = unknown>(params?: GetAccountCheckIfIsMasterAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountCheckIfIsMasterAccount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountCheckIfIsMasterAccountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountCheckIfIsMasterAccount>>> = ({ signal }) => getAccountCheckIfIsMasterAccount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountCheckIfIsMasterAccount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountCheckIfIsMasterAccountQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountCheckIfIsMasterAccount>>>
export type GetAccountCheckIfIsMasterAccountQueryError = unknown

export const useGetAccountCheckIfIsMasterAccount = <TData = Awaited<ReturnType<typeof getAccountCheckIfIsMasterAccount>>, TError = unknown>(
 params?: GetAccountCheckIfIsMasterAccountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountCheckIfIsMasterAccount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountCheckIfIsMasterAccountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postAccountGetOrCreateMaster = (
    params?: PostAccountGetOrCreateMasterParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Account>(
      {url: `/Account/GetOrCreateMaster`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostAccountGetOrCreateMasterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountGetOrCreateMaster>>, TError,{params?: PostAccountGetOrCreateMasterParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccountGetOrCreateMaster>>, TError,{params?: PostAccountGetOrCreateMasterParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountGetOrCreateMaster>>, {params?: PostAccountGetOrCreateMasterParams}> = (props) => {
          const {params} = props ?? {};

          return  postAccountGetOrCreateMaster(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccountGetOrCreateMasterMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountGetOrCreateMaster>>>
    
    export type PostAccountGetOrCreateMasterMutationError = unknown

    export const usePostAccountGetOrCreateMaster = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountGetOrCreateMaster>>, TError,{params?: PostAccountGetOrCreateMasterParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAccountGetOrCreateMaster>>,
        TError,
        {params?: PostAccountGetOrCreateMasterParams},
        TContext
      > => {

      const mutationOptions = getPostAccountGetOrCreateMasterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAccountSyncMaster = (
    params?: PostAccountSyncMasterParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Account>(
      {url: `/Account/SyncMaster`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostAccountSyncMasterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountSyncMaster>>, TError,{params?: PostAccountSyncMasterParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccountSyncMaster>>, TError,{params?: PostAccountSyncMasterParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountSyncMaster>>, {params?: PostAccountSyncMasterParams}> = (props) => {
          const {params} = props ?? {};

          return  postAccountSyncMaster(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccountSyncMasterMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountSyncMaster>>>
    
    export type PostAccountSyncMasterMutationError = unknown

    export const usePostAccountSyncMaster = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountSyncMaster>>, TError,{params?: PostAccountSyncMasterParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAccountSyncMaster>>,
        TError,
        {params?: PostAccountSyncMasterParams},
        TContext
      > => {

      const mutationOptions = getPostAccountSyncMasterMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAccountGetOrCreateLinked = (
    params?: PostAccountGetOrCreateLinkedParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Account>(
      {url: `/Account/GetOrCreateLinked`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostAccountGetOrCreateLinkedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountGetOrCreateLinked>>, TError,{params?: PostAccountGetOrCreateLinkedParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccountGetOrCreateLinked>>, TError,{params?: PostAccountGetOrCreateLinkedParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountGetOrCreateLinked>>, {params?: PostAccountGetOrCreateLinkedParams}> = (props) => {
          const {params} = props ?? {};

          return  postAccountGetOrCreateLinked(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccountGetOrCreateLinkedMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountGetOrCreateLinked>>>
    
    export type PostAccountGetOrCreateLinkedMutationError = unknown

    export const usePostAccountGetOrCreateLinked = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountGetOrCreateLinked>>, TError,{params?: PostAccountGetOrCreateLinkedParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAccountGetOrCreateLinked>>,
        TError,
        {params?: PostAccountGetOrCreateLinkedParams},
        TContext
      > => {

      const mutationOptions = getPostAccountGetOrCreateLinkedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postAccountSyncLinked = (
    params?: PostAccountSyncLinkedParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Account>(
      {url: `/Account/SyncLinked`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostAccountSyncLinkedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountSyncLinked>>, TError,{params?: PostAccountSyncLinkedParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postAccountSyncLinked>>, TError,{params?: PostAccountSyncLinkedParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountSyncLinked>>, {params?: PostAccountSyncLinkedParams}> = (props) => {
          const {params} = props ?? {};

          return  postAccountSyncLinked(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAccountSyncLinkedMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountSyncLinked>>>
    
    export type PostAccountSyncLinkedMutationError = unknown

    export const usePostAccountSyncLinked = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountSyncLinked>>, TError,{params?: PostAccountSyncLinkedParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postAccountSyncLinked>>,
        TError,
        {params?: PostAccountSyncLinkedParams},
        TContext
      > => {

      const mutationOptions = getPostAccountSyncLinkedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getAccountGetRelatedAccounts = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Account[][]>(
      {url: `/Account/GetRelatedAccounts`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAccountGetRelatedAccountsQueryKey = () => {
    return [`/Account/GetRelatedAccounts`] as const;
    }

    
export const getGetAccountGetRelatedAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getAccountGetRelatedAccounts>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetRelatedAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountGetRelatedAccountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccountGetRelatedAccounts>>> = ({ signal }) => getAccountGetRelatedAccounts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAccountGetRelatedAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAccountGetRelatedAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getAccountGetRelatedAccounts>>>
export type GetAccountGetRelatedAccountsQueryError = unknown

export const useGetAccountGetRelatedAccounts = <TData = Awaited<ReturnType<typeof getAccountGetRelatedAccounts>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAccountGetRelatedAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAccountGetRelatedAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getAppGetAppsAndFeatures = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AppFeatures[]>(
      {url: `/App/GetAppsAndFeatures`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetAppGetAppsAndFeaturesQueryKey = () => {
    return [`/App/GetAppsAndFeatures`] as const;
    }

    
export const getGetAppGetAppsAndFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getAppGetAppsAndFeatures>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppGetAppsAndFeatures>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAppGetAppsAndFeaturesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAppGetAppsAndFeatures>>> = ({ signal }) => getAppGetAppsAndFeatures(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAppGetAppsAndFeatures>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAppGetAppsAndFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getAppGetAppsAndFeatures>>>
export type GetAppGetAppsAndFeaturesQueryError = unknown

export const useGetAppGetAppsAndFeatures = <TData = Awaited<ReturnType<typeof getAppGetAppsAndFeatures>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAppGetAppsAndFeatures>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetAppGetAppsAndFeaturesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCloudIntelligenceSubmitCompanyCandidate = (
    customerSubsidyRequest: CustomerSubsidyRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CloudIntelligence/SubmitCompanyCandidate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerSubsidyRequest
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCloudIntelligenceSubmitCompanyCandidateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceSubmitCompanyCandidate>>, TError,{data: CustomerSubsidyRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceSubmitCompanyCandidate>>, TError,{data: CustomerSubsidyRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCloudIntelligenceSubmitCompanyCandidate>>, {data: CustomerSubsidyRequest}> = (props) => {
          const {data} = props ?? {};

          return  postCloudIntelligenceSubmitCompanyCandidate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCloudIntelligenceSubmitCompanyCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof postCloudIntelligenceSubmitCompanyCandidate>>>
    export type PostCloudIntelligenceSubmitCompanyCandidateMutationBody = CustomerSubsidyRequest
    export type PostCloudIntelligenceSubmitCompanyCandidateMutationError = unknown

    export const usePostCloudIntelligenceSubmitCompanyCandidate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceSubmitCompanyCandidate>>, TError,{data: CustomerSubsidyRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCloudIntelligenceSubmitCompanyCandidate>>,
        TError,
        {data: CustomerSubsidyRequest},
        TContext
      > => {

      const mutationOptions = getPostCloudIntelligenceSubmitCompanyCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCloudIntelligenceReviewCompanyCandidate = (
    params?: PostCloudIntelligenceReviewCompanyCandidateParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CloudIntelligence/ReviewCompanyCandidate`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCloudIntelligenceReviewCompanyCandidateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceReviewCompanyCandidate>>, TError,{params?: PostCloudIntelligenceReviewCompanyCandidateParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceReviewCompanyCandidate>>, TError,{params?: PostCloudIntelligenceReviewCompanyCandidateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCloudIntelligenceReviewCompanyCandidate>>, {params?: PostCloudIntelligenceReviewCompanyCandidateParams}> = (props) => {
          const {params} = props ?? {};

          return  postCloudIntelligenceReviewCompanyCandidate(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCloudIntelligenceReviewCompanyCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof postCloudIntelligenceReviewCompanyCandidate>>>
    
    export type PostCloudIntelligenceReviewCompanyCandidateMutationError = unknown

    export const usePostCloudIntelligenceReviewCompanyCandidate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceReviewCompanyCandidate>>, TError,{params?: PostCloudIntelligenceReviewCompanyCandidateParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCloudIntelligenceReviewCompanyCandidate>>,
        TError,
        {params?: PostCloudIntelligenceReviewCompanyCandidateParams},
        TContext
      > => {

      const mutationOptions = getPostCloudIntelligenceReviewCompanyCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCloudIntelligenceGetCustomerCompany = (
    params?: GetCloudIntelligenceGetCustomerCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company>(
      {url: `/CloudIntelligence/GetCustomerCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCloudIntelligenceGetCustomerCompanyQueryKey = (params?: GetCloudIntelligenceGetCustomerCompanyParams,) => {
    return [`/CloudIntelligence/GetCustomerCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCloudIntelligenceGetCustomerCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerCompany>>, TError = unknown>(params?: GetCloudIntelligenceGetCustomerCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCloudIntelligenceGetCustomerCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerCompany>>> = ({ signal }) => getCloudIntelligenceGetCustomerCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCloudIntelligenceGetCustomerCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerCompany>>>
export type GetCloudIntelligenceGetCustomerCompanyQueryError = unknown

export const useGetCloudIntelligenceGetCustomerCompany = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerCompany>>, TError = unknown>(
 params?: GetCloudIntelligenceGetCustomerCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCloudIntelligenceGetCustomerCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCloudIntelligenceGetCustomersByUser = (
    params?: GetCloudIntelligenceGetCustomersByUserParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<number[]>(
      {url: `/CloudIntelligence/GetCustomersByUser`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCloudIntelligenceGetCustomersByUserQueryKey = (params?: GetCloudIntelligenceGetCustomersByUserParams,) => {
    return [`/CloudIntelligence/GetCustomersByUser`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCloudIntelligenceGetCustomersByUserQueryOptions = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomersByUser>>, TError = unknown>(params?: GetCloudIntelligenceGetCustomersByUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomersByUser>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCloudIntelligenceGetCustomersByUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomersByUser>>> = ({ signal }) => getCloudIntelligenceGetCustomersByUser(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomersByUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCloudIntelligenceGetCustomersByUserQueryResult = NonNullable<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomersByUser>>>
export type GetCloudIntelligenceGetCustomersByUserQueryError = unknown

export const useGetCloudIntelligenceGetCustomersByUser = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomersByUser>>, TError = unknown>(
 params?: GetCloudIntelligenceGetCustomersByUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomersByUser>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCloudIntelligenceGetCustomersByUserQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCloudIntelligenceGetCustomerSubsidyRequests = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CustomerSubsidyViewModel[]>(
      {url: `/CloudIntelligence/GetCustomerSubsidyRequests`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCloudIntelligenceGetCustomerSubsidyRequestsQueryKey = () => {
    return [`/CloudIntelligence/GetCustomerSubsidyRequests`] as const;
    }

    
export const getGetCloudIntelligenceGetCustomerSubsidyRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequests>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequests>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCloudIntelligenceGetCustomerSubsidyRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequests>>> = ({ signal }) => getCloudIntelligenceGetCustomerSubsidyRequests(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequests>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCloudIntelligenceGetCustomerSubsidyRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequests>>>
export type GetCloudIntelligenceGetCustomerSubsidyRequestsQueryError = unknown

export const useGetCloudIntelligenceGetCustomerSubsidyRequests = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequests>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequests>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCloudIntelligenceGetCustomerSubsidyRequestsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCloudIntelligenceGetCustomerSubsidyRequestById = (
    params?: GetCloudIntelligenceGetCustomerSubsidyRequestByIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CustomerSubsidyViewModel>(
      {url: `/CloudIntelligence/GetCustomerSubsidyRequestById`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCloudIntelligenceGetCustomerSubsidyRequestByIdQueryKey = (params?: GetCloudIntelligenceGetCustomerSubsidyRequestByIdParams,) => {
    return [`/CloudIntelligence/GetCustomerSubsidyRequestById`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCloudIntelligenceGetCustomerSubsidyRequestByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequestById>>, TError = unknown>(params?: GetCloudIntelligenceGetCustomerSubsidyRequestByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequestById>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCloudIntelligenceGetCustomerSubsidyRequestByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequestById>>> = ({ signal }) => getCloudIntelligenceGetCustomerSubsidyRequestById(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequestById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCloudIntelligenceGetCustomerSubsidyRequestByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequestById>>>
export type GetCloudIntelligenceGetCustomerSubsidyRequestByIdQueryError = unknown

export const useGetCloudIntelligenceGetCustomerSubsidyRequestById = <TData = Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequestById>>, TError = unknown>(
 params?: GetCloudIntelligenceGetCustomerSubsidyRequestByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCloudIntelligenceGetCustomerSubsidyRequestById>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCloudIntelligenceGetCustomerSubsidyRequestByIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCloudIntelligenceDeleteCompanyCandidate = (
    params?: PostCloudIntelligenceDeleteCompanyCandidateParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CloudIntelligence/DeleteCompanyCandidate`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCloudIntelligenceDeleteCompanyCandidateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceDeleteCompanyCandidate>>, TError,{params?: PostCloudIntelligenceDeleteCompanyCandidateParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceDeleteCompanyCandidate>>, TError,{params?: PostCloudIntelligenceDeleteCompanyCandidateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCloudIntelligenceDeleteCompanyCandidate>>, {params?: PostCloudIntelligenceDeleteCompanyCandidateParams}> = (props) => {
          const {params} = props ?? {};

          return  postCloudIntelligenceDeleteCompanyCandidate(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCloudIntelligenceDeleteCompanyCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof postCloudIntelligenceDeleteCompanyCandidate>>>
    
    export type PostCloudIntelligenceDeleteCompanyCandidateMutationError = unknown

    export const usePostCloudIntelligenceDeleteCompanyCandidate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceDeleteCompanyCandidate>>, TError,{params?: PostCloudIntelligenceDeleteCompanyCandidateParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCloudIntelligenceDeleteCompanyCandidate>>,
        TError,
        {params?: PostCloudIntelligenceDeleteCompanyCandidateParams},
        TContext
      > => {

      const mutationOptions = getPostCloudIntelligenceDeleteCompanyCandidateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCloudIntelligenceInviteAccountRep = (
    params?: PostCloudIntelligenceInviteAccountRepParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CloudIntelligence/InviteAccountRep`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCloudIntelligenceInviteAccountRepMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceInviteAccountRep>>, TError,{params?: PostCloudIntelligenceInviteAccountRepParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceInviteAccountRep>>, TError,{params?: PostCloudIntelligenceInviteAccountRepParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCloudIntelligenceInviteAccountRep>>, {params?: PostCloudIntelligenceInviteAccountRepParams}> = (props) => {
          const {params} = props ?? {};

          return  postCloudIntelligenceInviteAccountRep(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCloudIntelligenceInviteAccountRepMutationResult = NonNullable<Awaited<ReturnType<typeof postCloudIntelligenceInviteAccountRep>>>
    
    export type PostCloudIntelligenceInviteAccountRepMutationError = unknown

    export const usePostCloudIntelligenceInviteAccountRep = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCloudIntelligenceInviteAccountRep>>, TError,{params?: PostCloudIntelligenceInviteAccountRepParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCloudIntelligenceInviteAccountRep>>,
        TError,
        {params?: PostCloudIntelligenceInviteAccountRepParams},
        TContext
      > => {

      const mutationOptions = getPostCloudIntelligenceInviteAccountRepMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetCompanyApps = (
    params?: GetCompanyGetCompanyAppsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyApp[]>(
      {url: `/Company/GetCompanyApps`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyAppsQueryKey = (params?: GetCompanyGetCompanyAppsParams,) => {
    return [`/Company/GetCompanyApps`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetCompanyAppsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyApps>>, TError = unknown>(params?: GetCompanyGetCompanyAppsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyApps>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyAppsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyApps>>> = ({ signal }) => getCompanyGetCompanyApps(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyApps>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyAppsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyApps>>>
export type GetCompanyGetCompanyAppsQueryError = unknown

export const useGetCompanyGetCompanyApps = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyApps>>, TError = unknown>(
 params?: GetCompanyGetCompanyAppsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyApps>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyAppsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCompanyAppInfo = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyApps>(
      {url: `/Company/GetCompanyAppInfo`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyAppInfoQueryKey = () => {
    return [`/Company/GetCompanyAppInfo`] as const;
    }

    
export const getGetCompanyGetCompanyAppInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyAppInfo>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyAppInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyAppInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyAppInfo>>> = ({ signal }) => getCompanyGetCompanyAppInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyAppInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyAppInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyAppInfo>>>
export type GetCompanyGetCompanyAppInfoQueryError = unknown

export const useGetCompanyGetCompanyAppInfo = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyAppInfo>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyAppInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyAppInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putCompanyToggleCompanyAppLocked = (
    params?: PutCompanyToggleCompanyAppLockedParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/ToggleCompanyAppLocked`, method: 'PUT',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanyToggleCompanyAppLockedMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyToggleCompanyAppLocked>>, TError,{params?: PutCompanyToggleCompanyAppLockedParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanyToggleCompanyAppLocked>>, TError,{params?: PutCompanyToggleCompanyAppLockedParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanyToggleCompanyAppLocked>>, {params?: PutCompanyToggleCompanyAppLockedParams}> = (props) => {
          const {params} = props ?? {};

          return  putCompanyToggleCompanyAppLocked(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanyToggleCompanyAppLockedMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanyToggleCompanyAppLocked>>>
    
    export type PutCompanyToggleCompanyAppLockedMutationError = unknown

    export const usePutCompanyToggleCompanyAppLocked = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyToggleCompanyAppLocked>>, TError,{params?: PutCompanyToggleCompanyAppLockedParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanyToggleCompanyAppLocked>>,
        TError,
        {params?: PutCompanyToggleCompanyAppLockedParams},
        TContext
      > => {

      const mutationOptions = getPutCompanyToggleCompanyAppLockedMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putCompanySaveCompanyApps = (
    putCompanySaveCompanyAppsBody: number[],
    params?: PutCompanySaveCompanyAppsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/SaveCompanyApps`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putCompanySaveCompanyAppsBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanySaveCompanyAppsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCompanyApps>>, TError,{data: number[];params?: PutCompanySaveCompanyAppsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCompanyApps>>, TError,{data: number[];params?: PutCompanySaveCompanyAppsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanySaveCompanyApps>>, {data: number[];params?: PutCompanySaveCompanyAppsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putCompanySaveCompanyApps(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanySaveCompanyAppsMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanySaveCompanyApps>>>
    export type PutCompanySaveCompanyAppsMutationBody = number[]
    export type PutCompanySaveCompanyAppsMutationError = unknown

    export const usePutCompanySaveCompanyApps = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCompanyApps>>, TError,{data: number[];params?: PutCompanySaveCompanyAppsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanySaveCompanyApps>>,
        TError,
        {data: number[];params?: PutCompanySaveCompanyAppsParams},
        TContext
      > => {

      const mutationOptions = getPutCompanySaveCompanyAppsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putCompanySaveCustomerCompanyApps = (
    putCompanySaveCustomerCompanyAppsBody: number[],
    params?: PutCompanySaveCustomerCompanyAppsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/SaveCustomerCompanyApps`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putCompanySaveCustomerCompanyAppsBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanySaveCustomerCompanyAppsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCustomerCompanyApps>>, TError,{data: number[];params?: PutCompanySaveCustomerCompanyAppsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCustomerCompanyApps>>, TError,{data: number[];params?: PutCompanySaveCustomerCompanyAppsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanySaveCustomerCompanyApps>>, {data: number[];params?: PutCompanySaveCustomerCompanyAppsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putCompanySaveCustomerCompanyApps(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanySaveCustomerCompanyAppsMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanySaveCustomerCompanyApps>>>
    export type PutCompanySaveCustomerCompanyAppsMutationBody = number[]
    export type PutCompanySaveCustomerCompanyAppsMutationError = unknown

    export const usePutCompanySaveCustomerCompanyApps = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCustomerCompanyApps>>, TError,{data: number[];params?: PutCompanySaveCustomerCompanyAppsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanySaveCustomerCompanyApps>>,
        TError,
        {data: number[];params?: PutCompanySaveCustomerCompanyAppsParams},
        TContext
      > => {

      const mutationOptions = getPutCompanySaveCustomerCompanyAppsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetCompanyFeatures = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyFeature[]>(
      {url: `/Company/GetCompanyFeatures`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyFeaturesQueryKey = () => {
    return [`/Company/GetCompanyFeatures`] as const;
    }

    
export const getGetCompanyGetCompanyFeaturesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyFeatures>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyFeatures>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyFeaturesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyFeatures>>> = ({ signal }) => getCompanyGetCompanyFeatures(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyFeatures>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyFeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyFeatures>>>
export type GetCompanyGetCompanyFeaturesQueryError = unknown

export const useGetCompanyGetCompanyFeatures = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyFeatures>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyFeatures>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyFeaturesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putCompanySaveCompanyFeatures = (
    putCompanySaveCompanyFeaturesBody: string[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/SaveCompanyFeatures`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putCompanySaveCompanyFeaturesBody
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanySaveCompanyFeaturesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCompanyFeatures>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCompanyFeatures>>, TError,{data: string[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanySaveCompanyFeatures>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  putCompanySaveCompanyFeatures(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanySaveCompanyFeaturesMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanySaveCompanyFeatures>>>
    export type PutCompanySaveCompanyFeaturesMutationBody = string[]
    export type PutCompanySaveCompanyFeaturesMutationError = unknown

    export const usePutCompanySaveCompanyFeatures = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanySaveCompanyFeatures>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanySaveCompanyFeatures>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getPutCompanySaveCompanyFeaturesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetCurrentCompany = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company>(
      {url: `/Company/GetCurrentCompany`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCurrentCompanyQueryKey = () => {
    return [`/Company/GetCurrentCompany`] as const;
    }

    
export const getGetCompanyGetCurrentCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCurrentCompany>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCurrentCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCurrentCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCurrentCompany>>> = ({ signal }) => getCompanyGetCurrentCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCurrentCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCurrentCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCurrentCompany>>>
export type GetCompanyGetCurrentCompanyQueryError = unknown

export const useGetCompanyGetCurrentCompany = <TData = Awaited<ReturnType<typeof getCompanyGetCurrentCompany>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCurrentCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCurrentCompanyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCompany = (
    params?: GetCompanyGetCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company>(
      {url: `/Company/GetCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyQueryKey = (params?: GetCompanyGetCompanyParams,) => {
    return [`/Company/GetCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompany>>, TError = unknown>(params?: GetCompanyGetCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompany>>> = ({ signal }) => getCompanyGetCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompany>>>
export type GetCompanyGetCompanyQueryError = unknown

export const useGetCompanyGetCompany = <TData = Awaited<ReturnType<typeof getCompanyGetCompany>>, TError = unknown>(
 params?: GetCompanyGetCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCompanyInternal = (
    params?: GetCompanyGetCompanyInternalParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company>(
      {url: `/Company/GetCompanyInternal`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyInternalQueryKey = (params?: GetCompanyGetCompanyInternalParams,) => {
    return [`/Company/GetCompanyInternal`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetCompanyInternalQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyInternal>>, TError = unknown>(params?: GetCompanyGetCompanyInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyInternal>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyInternalQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyInternal>>> = ({ signal }) => getCompanyGetCompanyInternal(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyInternal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyInternalQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyInternal>>>
export type GetCompanyGetCompanyInternalQueryError = unknown

export const useGetCompanyGetCompanyInternal = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyInternal>>, TError = unknown>(
 params?: GetCompanyGetCompanyInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyInternal>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyInternalQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCompanies = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company[]>(
      {url: `/Company/GetCompanies`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompaniesQueryKey = () => {
    return [`/Company/GetCompanies`] as const;
    }

    
export const getGetCompanyGetCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanies>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanies>>> = ({ signal }) => getCompanyGetCompanies(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanies>>>
export type GetCompanyGetCompaniesQueryError = unknown

export const useGetCompanyGetCompanies = <TData = Awaited<ReturnType<typeof getCompanyGetCompanies>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanySaveCompany = (
    company: Company,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/SaveCompany`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: company
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanySaveCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompany>>, TError,{data: Company}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompany>>, TError,{data: Company}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanySaveCompany>>, {data: Company}> = (props) => {
          const {data} = props ?? {};

          return  postCompanySaveCompany(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanySaveCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanySaveCompany>>>
    export type PostCompanySaveCompanyMutationBody = Company
    export type PostCompanySaveCompanyMutationError = unknown

    export const usePostCompanySaveCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompany>>, TError,{data: Company}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanySaveCompany>>,
        TError,
        {data: Company},
        TContext
      > => {

      const mutationOptions = getPostCompanySaveCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putCompanyCreateCompany = (
    params?: PutCompanyCreateCompanyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Company>(
      {url: `/Company/CreateCompany`, method: 'PUT',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanyCreateCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyCreateCompany>>, TError,{params?: PutCompanyCreateCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanyCreateCompany>>, TError,{params?: PutCompanyCreateCompanyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanyCreateCompany>>, {params?: PutCompanyCreateCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  putCompanyCreateCompany(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanyCreateCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanyCreateCompany>>>
    
    export type PutCompanyCreateCompanyMutationError = unknown

    export const usePutCompanyCreateCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyCreateCompany>>, TError,{params?: PutCompanyCreateCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanyCreateCompany>>,
        TError,
        {params?: PutCompanyCreateCompanyParams},
        TContext
      > => {

      const mutationOptions = getPutCompanyCreateCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putCompanyRegisterCompany = (
    params?: PutCompanyRegisterCompanyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Company>(
      {url: `/Company/RegisterCompany`, method: 'PUT',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanyRegisterCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyRegisterCompany>>, TError,{params?: PutCompanyRegisterCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanyRegisterCompany>>, TError,{params?: PutCompanyRegisterCompanyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanyRegisterCompany>>, {params?: PutCompanyRegisterCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  putCompanyRegisterCompany(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanyRegisterCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanyRegisterCompany>>>
    
    export type PutCompanyRegisterCompanyMutationError = unknown

    export const usePutCompanyRegisterCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyRegisterCompany>>, TError,{params?: PutCompanyRegisterCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanyRegisterCompany>>,
        TError,
        {params?: PutCompanyRegisterCompanyParams},
        TContext
      > => {

      const mutationOptions = getPutCompanyRegisterCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetCompanyConfig = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyConfiguration[]>(
      {url: `/Company/GetCompanyConfig`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyConfigQueryKey = () => {
    return [`/Company/GetCompanyConfig`] as const;
    }

    
export const getGetCompanyGetCompanyConfigQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyConfig>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyConfig>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyConfig>>> = ({ signal }) => getCompanyGetCompanyConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyConfig>>>
export type GetCompanyGetCompanyConfigQueryError = unknown

export const useGetCompanyGetCompanyConfig = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyConfig>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyConfig>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyConfigQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanySaveCompanyConfigs = (
    companyConfiguration: CompanyConfiguration[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyConfiguration[]>(
      {url: `/Company/SaveCompanyConfigs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyConfiguration
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanySaveCompanyConfigsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompanyConfigs>>, TError,{data: CompanyConfiguration[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompanyConfigs>>, TError,{data: CompanyConfiguration[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanySaveCompanyConfigs>>, {data: CompanyConfiguration[]}> = (props) => {
          const {data} = props ?? {};

          return  postCompanySaveCompanyConfigs(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanySaveCompanyConfigsMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanySaveCompanyConfigs>>>
    export type PostCompanySaveCompanyConfigsMutationBody = CompanyConfiguration[]
    export type PostCompanySaveCompanyConfigsMutationError = unknown

    export const usePostCompanySaveCompanyConfigs = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompanyConfigs>>, TError,{data: CompanyConfiguration[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanySaveCompanyConfigs>>,
        TError,
        {data: CompanyConfiguration[]},
        TContext
      > => {

      const mutationOptions = getPostCompanySaveCompanyConfigsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putCompanyAdminRegisterCompany = (
    params?: PutCompanyAdminRegisterCompanyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Company>(
      {url: `/Company/AdminRegisterCompany`, method: 'PUT',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanyAdminRegisterCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyAdminRegisterCompany>>, TError,{params?: PutCompanyAdminRegisterCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanyAdminRegisterCompany>>, TError,{params?: PutCompanyAdminRegisterCompanyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanyAdminRegisterCompany>>, {params?: PutCompanyAdminRegisterCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  putCompanyAdminRegisterCompany(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanyAdminRegisterCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanyAdminRegisterCompany>>>
    
    export type PutCompanyAdminRegisterCompanyMutationError = unknown

    export const usePutCompanyAdminRegisterCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyAdminRegisterCompany>>, TError,{params?: PutCompanyAdminRegisterCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanyAdminRegisterCompany>>,
        TError,
        {params?: PutCompanyAdminRegisterCompanyParams},
        TContext
      > => {

      const mutationOptions = getPutCompanyAdminRegisterCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteCompanyDeleteCompany = (
    params?: DeleteCompanyDeleteCompanyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/DeleteCompany`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteCompanyDeleteCompanyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDeleteCompany>>, TError,{params?: DeleteCompanyDeleteCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDeleteCompany>>, TError,{params?: DeleteCompanyDeleteCompanyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyDeleteCompany>>, {params?: DeleteCompanyDeleteCompanyParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteCompanyDeleteCompany(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyDeleteCompanyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyDeleteCompany>>>
    
    export type DeleteCompanyDeleteCompanyMutationError = unknown

    export const useDeleteCompanyDeleteCompany = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyDeleteCompany>>, TError,{params?: DeleteCompanyDeleteCompanyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanyDeleteCompany>>,
        TError,
        {params?: DeleteCompanyDeleteCompanyParams},
        TContext
      > => {

      const mutationOptions = getDeleteCompanyDeleteCompanyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetAccountCompany = (
    params?: GetCompanyGetAccountCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyAccount[]>(
      {url: `/Company/GetAccountCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetAccountCompanyQueryKey = (params?: GetCompanyGetAccountCompanyParams,) => {
    return [`/Company/GetAccountCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetAccountCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetAccountCompany>>, TError = unknown>(params?: GetCompanyGetAccountCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAccountCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetAccountCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetAccountCompany>>> = ({ signal }) => getCompanyGetAccountCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAccountCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetAccountCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetAccountCompany>>>
export type GetCompanyGetAccountCompanyQueryError = unknown

export const useGetCompanyGetAccountCompany = <TData = Awaited<ReturnType<typeof getCompanyGetAccountCompany>>, TError = unknown>(
 params?: GetCompanyGetAccountCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAccountCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetAccountCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanyAddUsers = (
    postCompanyAddUsersBody: number[],
    params?: PostCompanyAddUsersParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/AddUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCompanyAddUsersBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddUsers>>, TError,{data: number[];params?: PostCompanyAddUsersParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddUsers>>, TError,{data: number[];params?: PostCompanyAddUsersParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddUsers>>, {data: number[];params?: PostCompanyAddUsersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyAddUsers(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddUsers>>>
    export type PostCompanyAddUsersMutationBody = number[]
    export type PostCompanyAddUsersMutationError = unknown

    export const usePostCompanyAddUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddUsers>>, TError,{data: number[];params?: PostCompanyAddUsersParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddUsers>>,
        TError,
        {data: number[];params?: PostCompanyAddUsersParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyAddUser = (
    params?: PostCompanyAddUserParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyUser>(
      {url: `/Company/AddUser`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddUser>>, TError,{params?: PostCompanyAddUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddUser>>, TError,{params?: PostCompanyAddUserParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddUser>>, {params?: PostCompanyAddUserParams}> = (props) => {
          const {params} = props ?? {};

          return  postCompanyAddUser(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddUserMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddUser>>>
    
    export type PostCompanyAddUserMutationError = unknown

    export const usePostCompanyAddUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddUser>>, TError,{params?: PostCompanyAddUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddUser>>,
        TError,
        {params?: PostCompanyAddUserParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyRemoveUsers = (
    postCompanyRemoveUsersBody: number[],
    params?: PostCompanyRemoveUsersParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/RemoveUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCompanyRemoveUsersBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyRemoveUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyRemoveUsers>>, TError,{data: number[];params?: PostCompanyRemoveUsersParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyRemoveUsers>>, TError,{data: number[];params?: PostCompanyRemoveUsersParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyRemoveUsers>>, {data: number[];params?: PostCompanyRemoveUsersParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyRemoveUsers(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyRemoveUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyRemoveUsers>>>
    export type PostCompanyRemoveUsersMutationBody = number[]
    export type PostCompanyRemoveUsersMutationError = unknown

    export const usePostCompanyRemoveUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyRemoveUsers>>, TError,{data: number[];params?: PostCompanyRemoveUsersParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyRemoveUsers>>,
        TError,
        {data: number[];params?: PostCompanyRemoveUsersParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyRemoveUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetCompanyBySystemName = (
    params?: GetCompanyGetCompanyBySystemNameParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company>(
      {url: `/Company/GetCompanyBySystemName`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyBySystemNameQueryKey = (params?: GetCompanyGetCompanyBySystemNameParams,) => {
    return [`/Company/GetCompanyBySystemName`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetCompanyBySystemNameQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyBySystemName>>, TError = unknown>(params?: GetCompanyGetCompanyBySystemNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyBySystemName>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyBySystemNameQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyBySystemName>>> = ({ signal }) => getCompanyGetCompanyBySystemName(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyBySystemName>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyBySystemNameQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyBySystemName>>>
export type GetCompanyGetCompanyBySystemNameQueryError = unknown

export const useGetCompanyGetCompanyBySystemName = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyBySystemName>>, TError = unknown>(
 params?: GetCompanyGetCompanyBySystemNameParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyBySystemName>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyBySystemNameQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanySaveCompanyStandardTags = (
    postCompanySaveCompanyStandardTagsBody: PostCompanySaveCompanyStandardTagsBodyOne | PostCompanySaveCompanyStandardTagsBodyTwo | PostCompanySaveCompanyStandardTagsBodyThree,
    params?: PostCompanySaveCompanyStandardTagsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/SaveCompanyStandardTags`, method: 'POST',
      data: postCompanySaveCompanyStandardTagsBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanySaveCompanyStandardTagsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompanyStandardTags>>, TError,{data: PostCompanySaveCompanyStandardTagsBodyOne | PostCompanySaveCompanyStandardTagsBodyTwo | PostCompanySaveCompanyStandardTagsBodyThree;params?: PostCompanySaveCompanyStandardTagsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompanyStandardTags>>, TError,{data: PostCompanySaveCompanyStandardTagsBodyOne | PostCompanySaveCompanyStandardTagsBodyTwo | PostCompanySaveCompanyStandardTagsBodyThree;params?: PostCompanySaveCompanyStandardTagsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanySaveCompanyStandardTags>>, {data: PostCompanySaveCompanyStandardTagsBodyOne | PostCompanySaveCompanyStandardTagsBodyTwo | PostCompanySaveCompanyStandardTagsBodyThree;params?: PostCompanySaveCompanyStandardTagsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanySaveCompanyStandardTags(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanySaveCompanyStandardTagsMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanySaveCompanyStandardTags>>>
    export type PostCompanySaveCompanyStandardTagsMutationBody = PostCompanySaveCompanyStandardTagsBodyOne | PostCompanySaveCompanyStandardTagsBodyTwo | PostCompanySaveCompanyStandardTagsBodyThree
    export type PostCompanySaveCompanyStandardTagsMutationError = unknown

    export const usePostCompanySaveCompanyStandardTags = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySaveCompanyStandardTags>>, TError,{data: PostCompanySaveCompanyStandardTagsBodyOne | PostCompanySaveCompanyStandardTagsBodyTwo | PostCompanySaveCompanyStandardTagsBodyThree;params?: PostCompanySaveCompanyStandardTagsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanySaveCompanyStandardTags>>,
        TError,
        {data: PostCompanySaveCompanyStandardTagsBodyOne | PostCompanySaveCompanyStandardTagsBodyTwo | PostCompanySaveCompanyStandardTagsBodyThree;params?: PostCompanySaveCompanyStandardTagsParams},
        TContext
      > => {

      const mutationOptions = getPostCompanySaveCompanyStandardTagsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetCompanyStandardTags = (
    params?: GetCompanyGetCompanyStandardTagsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyStandardTag[]>(
      {url: `/Company/GetCompanyStandardTags`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyStandardTagsQueryKey = (params?: GetCompanyGetCompanyStandardTagsParams,) => {
    return [`/Company/GetCompanyStandardTags`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetCompanyStandardTagsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyStandardTags>>, TError = unknown>(params?: GetCompanyGetCompanyStandardTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyStandardTags>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyStandardTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyStandardTags>>> = ({ signal }) => getCompanyGetCompanyStandardTags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyStandardTags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyStandardTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyStandardTags>>>
export type GetCompanyGetCompanyStandardTagsQueryError = unknown

export const useGetCompanyGetCompanyStandardTags = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyStandardTags>>, TError = unknown>(
 params?: GetCompanyGetCompanyStandardTagsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyStandardTags>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyStandardTagsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetStandardTags = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<StandardTag[]>(
      {url: `/Company/GetStandardTags`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetStandardTagsQueryKey = () => {
    return [`/Company/GetStandardTags`] as const;
    }

    
export const getGetCompanyGetStandardTagsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetStandardTags>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetStandardTags>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetStandardTagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetStandardTags>>> = ({ signal }) => getCompanyGetStandardTags(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetStandardTags>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetStandardTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetStandardTags>>>
export type GetCompanyGetStandardTagsQueryError = unknown

export const useGetCompanyGetStandardTags = <TData = Awaited<ReturnType<typeof getCompanyGetStandardTags>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetStandardTags>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetStandardTagsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCompanyCloudProviders = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyCloudProvider[]>(
      {url: `/Company/GetCompanyCloudProviders`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyCloudProvidersQueryKey = () => {
    return [`/Company/GetCompanyCloudProviders`] as const;
    }

    
export const getGetCompanyGetCompanyCloudProvidersQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviders>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviders>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyCloudProvidersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviders>>> = ({ signal }) => getCompanyGetCompanyCloudProviders(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyCloudProvidersQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviders>>>
export type GetCompanyGetCompanyCloudProvidersQueryError = unknown

export const useGetCompanyGetCompanyCloudProviders = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviders>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviders>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyCloudProvidersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCompanyCloudProviderAddresses = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyAddress[]>(
      {url: `/Company/GetCompanyCloudProviderAddresses`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyCloudProviderAddressesQueryKey = () => {
    return [`/Company/GetCompanyCloudProviderAddresses`] as const;
    }

    
export const getGetCompanyGetCompanyCloudProviderAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviderAddresses>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviderAddresses>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyCloudProviderAddressesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviderAddresses>>> = ({ signal }) => getCompanyGetCompanyCloudProviderAddresses(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviderAddresses>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyCloudProviderAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviderAddresses>>>
export type GetCompanyGetCompanyCloudProviderAddressesQueryError = unknown

export const useGetCompanyGetCompanyCloudProviderAddresses = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviderAddresses>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProviderAddresses>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyCloudProviderAddressesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCompanyCloudProvidersInternal = (
    params?: GetCompanyGetCompanyCloudProvidersInternalParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyCloudProvider[]>(
      {url: `/Company/GetCompanyCloudProvidersInternal`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCompanyCloudProvidersInternalQueryKey = (params?: GetCompanyGetCompanyCloudProvidersInternalParams,) => {
    return [`/Company/GetCompanyCloudProvidersInternal`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetCompanyCloudProvidersInternalQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyCloudProvidersInternal>>, TError = unknown>(params?: GetCompanyGetCompanyCloudProvidersInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProvidersInternal>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCompanyCloudProvidersInternalQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProvidersInternal>>> = ({ signal }) => getCompanyGetCompanyCloudProvidersInternal(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProvidersInternal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCompanyCloudProvidersInternalQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProvidersInternal>>>
export type GetCompanyGetCompanyCloudProvidersInternalQueryError = unknown

export const useGetCompanyGetCompanyCloudProvidersInternal = <TData = Awaited<ReturnType<typeof getCompanyGetCompanyCloudProvidersInternal>>, TError = unknown>(
 params?: GetCompanyGetCompanyCloudProvidersInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCompanyCloudProvidersInternal>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCompanyCloudProvidersInternalQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetAzureConnectionInfo = (
    params?: GetCompanyGetAzureConnectionInfoParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AzureConnectivityInfo[]>(
      {url: `/Company/GetAzureConnectionInfo`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetAzureConnectionInfoQueryKey = (params?: GetCompanyGetAzureConnectionInfoParams,) => {
    return [`/Company/GetAzureConnectionInfo`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetAzureConnectionInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfo>>, TError = unknown>(params?: GetCompanyGetAzureConnectionInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetAzureConnectionInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfo>>> = ({ signal }) => getCompanyGetAzureConnectionInfo(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetAzureConnectionInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfo>>>
export type GetCompanyGetAzureConnectionInfoQueryError = unknown

export const useGetCompanyGetAzureConnectionInfo = <TData = Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfo>>, TError = unknown>(
 params?: GetCompanyGetAzureConnectionInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetAzureConnectionInfoQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetAzureConnectionInfoInternal = (
    params?: GetCompanyGetAzureConnectionInfoInternalParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AzureConnectivityInfo[]>(
      {url: `/Company/GetAzureConnectionInfoInternal`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetAzureConnectionInfoInternalQueryKey = (params?: GetCompanyGetAzureConnectionInfoInternalParams,) => {
    return [`/Company/GetAzureConnectionInfoInternal`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetAzureConnectionInfoInternalQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfoInternal>>, TError = unknown>(params?: GetCompanyGetAzureConnectionInfoInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfoInternal>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetAzureConnectionInfoInternalQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfoInternal>>> = ({ signal }) => getCompanyGetAzureConnectionInfoInternal(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfoInternal>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetAzureConnectionInfoInternalQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfoInternal>>>
export type GetCompanyGetAzureConnectionInfoInternalQueryError = unknown

export const useGetCompanyGetAzureConnectionInfoInternal = <TData = Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfoInternal>>, TError = unknown>(
 params?: GetCompanyGetAzureConnectionInfoInternalParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureConnectionInfoInternal>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetAzureConnectionInfoInternalQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetCloudConnections = (
    params?: GetCompanyGetCloudConnectionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyCloudProvider[]>(
      {url: `/Company/GetCloudConnections`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetCloudConnectionsQueryKey = (params?: GetCompanyGetCloudConnectionsParams,) => {
    return [`/Company/GetCloudConnections`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetCloudConnectionsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetCloudConnections>>, TError = unknown>(params?: GetCompanyGetCloudConnectionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCloudConnections>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetCloudConnectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetCloudConnections>>> = ({ signal }) => getCompanyGetCloudConnections(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCloudConnections>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetCloudConnectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetCloudConnections>>>
export type GetCompanyGetCloudConnectionsQueryError = unknown

export const useGetCompanyGetCloudConnections = <TData = Awaited<ReturnType<typeof getCompanyGetCloudConnections>>, TError = unknown>(
 params?: GetCompanyGetCloudConnectionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetCloudConnections>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetCloudConnectionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanyAddCloudConnection = (
    newCompanyCloudProvider: NewCompanyCloudProvider,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyCloudProvider>(
      {url: `/Company/AddCloudConnection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newCompanyCloudProvider
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddCloudConnectionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddCloudConnection>>, TError,{data: NewCompanyCloudProvider}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddCloudConnection>>, TError,{data: NewCompanyCloudProvider}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddCloudConnection>>, {data: NewCompanyCloudProvider}> = (props) => {
          const {data} = props ?? {};

          return  postCompanyAddCloudConnection(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddCloudConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddCloudConnection>>>
    export type PostCompanyAddCloudConnectionMutationBody = NewCompanyCloudProvider
    export type PostCompanyAddCloudConnectionMutationError = unknown

    export const usePostCompanyAddCloudConnection = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddCloudConnection>>, TError,{data: NewCompanyCloudProvider}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddCloudConnection>>,
        TError,
        {data: NewCompanyCloudProvider},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddCloudConnectionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyAddAzureConnectivity = (
    azureConnectivityInfo: AzureConnectivityInfo[],
    params?: PostCompanyAddAzureConnectivityParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AzureConnectivityInfo[]>(
      {url: `/Company/AddAzureConnectivity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: azureConnectivityInfo,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddAzureConnectivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureConnectivity>>, TError,{data: AzureConnectivityInfo[];params?: PostCompanyAddAzureConnectivityParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureConnectivity>>, TError,{data: AzureConnectivityInfo[];params?: PostCompanyAddAzureConnectivityParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddAzureConnectivity>>, {data: AzureConnectivityInfo[];params?: PostCompanyAddAzureConnectivityParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyAddAzureConnectivity(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddAzureConnectivityMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddAzureConnectivity>>>
    export type PostCompanyAddAzureConnectivityMutationBody = AzureConnectivityInfo[]
    export type PostCompanyAddAzureConnectivityMutationError = unknown

    export const usePostCompanyAddAzureConnectivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureConnectivity>>, TError,{data: AzureConnectivityInfo[];params?: PostCompanyAddAzureConnectivityParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddAzureConnectivity>>,
        TError,
        {data: AzureConnectivityInfo[];params?: PostCompanyAddAzureConnectivityParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddAzureConnectivityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyAddAzureTenantConnectivity = (
    azureConnectivityInfo: AzureConnectivityInfo[],
    params?: PostCompanyAddAzureTenantConnectivityParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AzureConnectivityInfo[]>(
      {url: `/Company/AddAzureTenantConnectivity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: azureConnectivityInfo,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddAzureTenantConnectivityMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureTenantConnectivity>>, TError,{data: AzureConnectivityInfo[];params?: PostCompanyAddAzureTenantConnectivityParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureTenantConnectivity>>, TError,{data: AzureConnectivityInfo[];params?: PostCompanyAddAzureTenantConnectivityParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddAzureTenantConnectivity>>, {data: AzureConnectivityInfo[];params?: PostCompanyAddAzureTenantConnectivityParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyAddAzureTenantConnectivity(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddAzureTenantConnectivityMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddAzureTenantConnectivity>>>
    export type PostCompanyAddAzureTenantConnectivityMutationBody = AzureConnectivityInfo[]
    export type PostCompanyAddAzureTenantConnectivityMutationError = unknown

    export const usePostCompanyAddAzureTenantConnectivity = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureTenantConnectivity>>, TError,{data: AzureConnectivityInfo[];params?: PostCompanyAddAzureTenantConnectivityParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddAzureTenantConnectivity>>,
        TError,
        {data: AzureConnectivityInfo[];params?: PostCompanyAddAzureTenantConnectivityParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddAzureTenantConnectivityMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyAddAzureTenantCloudProvider = (
    companyCloudProviderRequest: CompanyCloudProviderRequest[],
    params?: PostCompanyAddAzureTenantCloudProviderParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyCloudProvider[]>(
      {url: `/Company/AddAzureTenantCloudProvider`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyCloudProviderRequest,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddAzureTenantCloudProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureTenantCloudProvider>>, TError,{data: CompanyCloudProviderRequest[];params?: PostCompanyAddAzureTenantCloudProviderParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureTenantCloudProvider>>, TError,{data: CompanyCloudProviderRequest[];params?: PostCompanyAddAzureTenantCloudProviderParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddAzureTenantCloudProvider>>, {data: CompanyCloudProviderRequest[];params?: PostCompanyAddAzureTenantCloudProviderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyAddAzureTenantCloudProvider(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddAzureTenantCloudProviderMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddAzureTenantCloudProvider>>>
    export type PostCompanyAddAzureTenantCloudProviderMutationBody = CompanyCloudProviderRequest[]
    export type PostCompanyAddAzureTenantCloudProviderMutationError = unknown

    export const usePostCompanyAddAzureTenantCloudProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddAzureTenantCloudProvider>>, TError,{data: CompanyCloudProviderRequest[];params?: PostCompanyAddAzureTenantCloudProviderParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddAzureTenantCloudProvider>>,
        TError,
        {data: CompanyCloudProviderRequest[];params?: PostCompanyAddAzureTenantCloudProviderParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddAzureTenantCloudProviderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetAzureSubscriptions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AzureSubscriptionInfo[]>(
      {url: `/Company/GetAzureSubscriptions`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetAzureSubscriptionsQueryKey = () => {
    return [`/Company/GetAzureSubscriptions`] as const;
    }

    
export const getGetCompanyGetAzureSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetAzureSubscriptions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureSubscriptions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetAzureSubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetAzureSubscriptions>>> = ({ signal }) => getCompanyGetAzureSubscriptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetAzureSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetAzureSubscriptions>>>
export type GetCompanyGetAzureSubscriptionsQueryError = unknown

export const useGetCompanyGetAzureSubscriptions = <TData = Awaited<ReturnType<typeof getCompanyGetAzureSubscriptions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetAzureSubscriptions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetAzureSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanyAddGcpCompanyServiceAccount = (
    gcpConnectivityInfo: GcpConnectivityInfo,
    params?: PostCompanyAddGcpCompanyServiceAccountParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<GcpConnectivityInfo>(
      {url: `/Company/AddGcpCompanyServiceAccount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gcpConnectivityInfo,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddGcpCompanyServiceAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpCompanyServiceAccount>>, TError,{data: GcpConnectivityInfo;params?: PostCompanyAddGcpCompanyServiceAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpCompanyServiceAccount>>, TError,{data: GcpConnectivityInfo;params?: PostCompanyAddGcpCompanyServiceAccountParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddGcpCompanyServiceAccount>>, {data: GcpConnectivityInfo;params?: PostCompanyAddGcpCompanyServiceAccountParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyAddGcpCompanyServiceAccount(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddGcpCompanyServiceAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddGcpCompanyServiceAccount>>>
    export type PostCompanyAddGcpCompanyServiceAccountMutationBody = GcpConnectivityInfo
    export type PostCompanyAddGcpCompanyServiceAccountMutationError = unknown

    export const usePostCompanyAddGcpCompanyServiceAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpCompanyServiceAccount>>, TError,{data: GcpConnectivityInfo;params?: PostCompanyAddGcpCompanyServiceAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddGcpCompanyServiceAccount>>,
        TError,
        {data: GcpConnectivityInfo;params?: PostCompanyAddGcpCompanyServiceAccountParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddGcpCompanyServiceAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyAddGcpServiceAccountCloudProvider = (
    companyCloudProviderRequest: CompanyCloudProviderRequest[],
    params?: PostCompanyAddGcpServiceAccountCloudProviderParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyCloudProvider[]>(
      {url: `/Company/AddGcpServiceAccountCloudProvider`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyCloudProviderRequest,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddGcpServiceAccountCloudProviderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpServiceAccountCloudProvider>>, TError,{data: CompanyCloudProviderRequest[];params?: PostCompanyAddGcpServiceAccountCloudProviderParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpServiceAccountCloudProvider>>, TError,{data: CompanyCloudProviderRequest[];params?: PostCompanyAddGcpServiceAccountCloudProviderParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddGcpServiceAccountCloudProvider>>, {data: CompanyCloudProviderRequest[];params?: PostCompanyAddGcpServiceAccountCloudProviderParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyAddGcpServiceAccountCloudProvider(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddGcpServiceAccountCloudProviderMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddGcpServiceAccountCloudProvider>>>
    export type PostCompanyAddGcpServiceAccountCloudProviderMutationBody = CompanyCloudProviderRequest[]
    export type PostCompanyAddGcpServiceAccountCloudProviderMutationError = unknown

    export const usePostCompanyAddGcpServiceAccountCloudProvider = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpServiceAccountCloudProvider>>, TError,{data: CompanyCloudProviderRequest[];params?: PostCompanyAddGcpServiceAccountCloudProviderParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddGcpServiceAccountCloudProvider>>,
        TError,
        {data: CompanyCloudProviderRequest[];params?: PostCompanyAddGcpServiceAccountCloudProviderParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddGcpServiceAccountCloudProviderMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetGcpProjects = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GcpProjectInfo[]>(
      {url: `/Company/GetGcpProjects`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetGcpProjectsQueryKey = () => {
    return [`/Company/GetGcpProjects`] as const;
    }

    
export const getGetCompanyGetGcpProjectsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetGcpProjects>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpProjects>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetGcpProjectsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetGcpProjects>>> = ({ signal }) => getCompanyGetGcpProjects(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpProjects>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetGcpProjectsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetGcpProjects>>>
export type GetCompanyGetGcpProjectsQueryError = unknown

export const useGetCompanyGetGcpProjects = <TData = Awaited<ReturnType<typeof getCompanyGetGcpProjects>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpProjects>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetGcpProjectsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetGcpConnectionInfo = (
    params?: GetCompanyGetGcpConnectionInfoParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GcpConnectivityInfo[]>(
      {url: `/Company/GetGcpConnectionInfo`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetGcpConnectionInfoQueryKey = (params?: GetCompanyGetGcpConnectionInfoParams,) => {
    return [`/Company/GetGcpConnectionInfo`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetGcpConnectionInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetGcpConnectionInfo>>, TError = unknown>(params?: GetCompanyGetGcpConnectionInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetGcpConnectionInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetGcpConnectionInfo>>> = ({ signal }) => getCompanyGetGcpConnectionInfo(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpConnectionInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetGcpConnectionInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetGcpConnectionInfo>>>
export type GetCompanyGetGcpConnectionInfoQueryError = unknown

export const useGetCompanyGetGcpConnectionInfo = <TData = Awaited<ReturnType<typeof getCompanyGetGcpConnectionInfo>>, TError = unknown>(
 params?: GetCompanyGetGcpConnectionInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpConnectionInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetGcpConnectionInfoQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyGetGcpServiceAccountInfo = (
    params?: GetCompanyGetGcpServiceAccountInfoParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GcpConnectivityInfo>(
      {url: `/Company/GetGcpServiceAccountInfo`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetGcpServiceAccountInfoQueryKey = (params?: GetCompanyGetGcpServiceAccountInfoParams,) => {
    return [`/Company/GetGcpServiceAccountInfo`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetGcpServiceAccountInfoQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetGcpServiceAccountInfo>>, TError = unknown>(params?: GetCompanyGetGcpServiceAccountInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpServiceAccountInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetGcpServiceAccountInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetGcpServiceAccountInfo>>> = ({ signal }) => getCompanyGetGcpServiceAccountInfo(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpServiceAccountInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetGcpServiceAccountInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetGcpServiceAccountInfo>>>
export type GetCompanyGetGcpServiceAccountInfoQueryError = unknown

export const useGetCompanyGetGcpServiceAccountInfo = <TData = Awaited<ReturnType<typeof getCompanyGetGcpServiceAccountInfo>>, TError = unknown>(
 params?: GetCompanyGetGcpServiceAccountInfoParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpServiceAccountInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetGcpServiceAccountInfoQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyCheckCloudProviderConnectivity = (
    params?: GetCompanyCheckCloudProviderConnectivityParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CloudProviderConnectionStatus[]>(
      {url: `/Company/CheckCloudProviderConnectivity`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyCheckCloudProviderConnectivityQueryKey = (params?: GetCompanyCheckCloudProviderConnectivityParams,) => {
    return [`/Company/CheckCloudProviderConnectivity`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyCheckCloudProviderConnectivityQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyCheckCloudProviderConnectivity>>, TError = unknown>(params?: GetCompanyCheckCloudProviderConnectivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyCheckCloudProviderConnectivity>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyCheckCloudProviderConnectivityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyCheckCloudProviderConnectivity>>> = ({ signal }) => getCompanyCheckCloudProviderConnectivity(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyCheckCloudProviderConnectivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyCheckCloudProviderConnectivityQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyCheckCloudProviderConnectivity>>>
export type GetCompanyCheckCloudProviderConnectivityQueryError = unknown

export const useGetCompanyCheckCloudProviderConnectivity = <TData = Awaited<ReturnType<typeof getCompanyCheckCloudProviderConnectivity>>, TError = unknown>(
 params?: GetCompanyCheckCloudProviderConnectivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyCheckCloudProviderConnectivity>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyCheckCloudProviderConnectivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanySetupSingleSignOn = (
    singleSignOnConfig: SingleSignOnConfig,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<SingleSignOnConfig>(
      {url: `/Company/SetupSingleSignOn`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: singleSignOnConfig
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanySetupSingleSignOnMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySetupSingleSignOn>>, TError,{data: SingleSignOnConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanySetupSingleSignOn>>, TError,{data: SingleSignOnConfig}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanySetupSingleSignOn>>, {data: SingleSignOnConfig}> = (props) => {
          const {data} = props ?? {};

          return  postCompanySetupSingleSignOn(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanySetupSingleSignOnMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanySetupSingleSignOn>>>
    export type PostCompanySetupSingleSignOnMutationBody = SingleSignOnConfig
    export type PostCompanySetupSingleSignOnMutationError = unknown

    export const usePostCompanySetupSingleSignOn = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanySetupSingleSignOn>>, TError,{data: SingleSignOnConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanySetupSingleSignOn>>,
        TError,
        {data: SingleSignOnConfig},
        TContext
      > => {

      const mutationOptions = getPostCompanySetupSingleSignOnMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetSingleSignOn = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SingleSignOnConfig>(
      {url: `/Company/GetSingleSignOn`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetSingleSignOnQueryKey = () => {
    return [`/Company/GetSingleSignOn`] as const;
    }

    
export const getGetCompanyGetSingleSignOnQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetSingleSignOn>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetSingleSignOn>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetSingleSignOnQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetSingleSignOn>>> = ({ signal }) => getCompanyGetSingleSignOn(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetSingleSignOn>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetSingleSignOnQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetSingleSignOn>>>
export type GetCompanyGetSingleSignOnQueryError = unknown

export const useGetCompanyGetSingleSignOn = <TData = Awaited<ReturnType<typeof getCompanyGetSingleSignOn>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetSingleSignOn>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetSingleSignOnQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteCompanyRemoveSingleSignOn = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<SingleSignOnConfig>(
      {url: `/Company/RemoveSingleSignOn`, method: 'DELETE'
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteCompanyRemoveSingleSignOnMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyRemoveSingleSignOn>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyRemoveSingleSignOn>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyRemoveSingleSignOn>>, void> = () => {
          

          return  deleteCompanyRemoveSingleSignOn(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyRemoveSingleSignOnMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyRemoveSingleSignOn>>>
    
    export type DeleteCompanyRemoveSingleSignOnMutationError = unknown

    export const useDeleteCompanyRemoveSingleSignOn = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyRemoveSingleSignOn>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanyRemoveSingleSignOn>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteCompanyRemoveSingleSignOnMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteCompanyBulkDeleteCompanies = (
    deleteCompanyBulkDeleteCompaniesBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/BulkDeleteCompanies`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteCompanyBulkDeleteCompaniesBody
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteCompanyBulkDeleteCompaniesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyBulkDeleteCompanies>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyBulkDeleteCompanies>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCompanyBulkDeleteCompanies>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  deleteCompanyBulkDeleteCompanies(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCompanyBulkDeleteCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCompanyBulkDeleteCompanies>>>
    export type DeleteCompanyBulkDeleteCompaniesMutationBody = number[]
    export type DeleteCompanyBulkDeleteCompaniesMutationError = unknown

    export const useDeleteCompanyBulkDeleteCompanies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCompanyBulkDeleteCompanies>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCompanyBulkDeleteCompanies>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getDeleteCompanyBulkDeleteCompaniesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putCompanyUpdateCompanyTypeById = (
    companyTypeRequest: CompanyTypeRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Company/UpdateCompanyTypeById`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: companyTypeRequest
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutCompanyUpdateCompanyTypeByIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyUpdateCompanyTypeById>>, TError,{data: CompanyTypeRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putCompanyUpdateCompanyTypeById>>, TError,{data: CompanyTypeRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCompanyUpdateCompanyTypeById>>, {data: CompanyTypeRequest}> = (props) => {
          const {data} = props ?? {};

          return  putCompanyUpdateCompanyTypeById(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCompanyUpdateCompanyTypeByIdMutationResult = NonNullable<Awaited<ReturnType<typeof putCompanyUpdateCompanyTypeById>>>
    export type PutCompanyUpdateCompanyTypeByIdMutationBody = CompanyTypeRequest
    export type PutCompanyUpdateCompanyTypeByIdMutationError = unknown

    export const usePutCompanyUpdateCompanyTypeById = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCompanyUpdateCompanyTypeById>>, TError,{data: CompanyTypeRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putCompanyUpdateCompanyTypeById>>,
        TError,
        {data: CompanyTypeRequest},
        TContext
      > => {

      const mutationOptions = getPutCompanyUpdateCompanyTypeByIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyAddGcpBillingAccount = (
    gcpBillingAccount: GcpBillingAccount,
    params?: PostCompanyAddGcpBillingAccountParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<GcpBillingAccount>(
      {url: `/Company/AddGcpBillingAccount`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gcpBillingAccount,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyAddGcpBillingAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpBillingAccount>>, TError,{data: GcpBillingAccount;params?: PostCompanyAddGcpBillingAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpBillingAccount>>, TError,{data: GcpBillingAccount;params?: PostCompanyAddGcpBillingAccountParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyAddGcpBillingAccount>>, {data: GcpBillingAccount;params?: PostCompanyAddGcpBillingAccountParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postCompanyAddGcpBillingAccount(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyAddGcpBillingAccountMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyAddGcpBillingAccount>>>
    export type PostCompanyAddGcpBillingAccountMutationBody = GcpBillingAccount
    export type PostCompanyAddGcpBillingAccountMutationError = unknown

    export const usePostCompanyAddGcpBillingAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyAddGcpBillingAccount>>, TError,{data: GcpBillingAccount;params?: PostCompanyAddGcpBillingAccountParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyAddGcpBillingAccount>>,
        TError,
        {data: GcpBillingAccount;params?: PostCompanyAddGcpBillingAccountParams},
        TContext
      > => {

      const mutationOptions = getPostCompanyAddGcpBillingAccountMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyGetGcpBillingAccounts = (
    params?: GetCompanyGetGcpBillingAccountsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GcpBillingAccount[]>(
      {url: `/Company/GetGcpBillingAccounts`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyGetGcpBillingAccountsQueryKey = (params?: GetCompanyGetGcpBillingAccountsParams,) => {
    return [`/Company/GetGcpBillingAccounts`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyGetGcpBillingAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyGetGcpBillingAccounts>>, TError = unknown>(params?: GetCompanyGetGcpBillingAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpBillingAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyGetGcpBillingAccountsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyGetGcpBillingAccounts>>> = ({ signal }) => getCompanyGetGcpBillingAccounts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpBillingAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyGetGcpBillingAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyGetGcpBillingAccounts>>>
export type GetCompanyGetGcpBillingAccountsQueryError = unknown

export const useGetCompanyGetGcpBillingAccounts = <TData = Awaited<ReturnType<typeof getCompanyGetGcpBillingAccounts>>, TError = unknown>(
 params?: GetCompanyGetGcpBillingAccountsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyGetGcpBillingAccounts>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyGetGcpBillingAccountsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot = (
    params?: GetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyDailyCreditSnapshot>(
      {url: `/CompanyDailyCreditSnapshot/GetCompanyDailyCreditSnapshot`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotQueryKey = (params?: GetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotParams,) => {
    return [`/CompanyDailyCreditSnapshot/GetCompanyDailyCreditSnapshot`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot>>, TError = unknown>(params?: GetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot>>> = ({ signal }) => getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot>>>
export type GetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotQueryError = unknown

export const useGetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot = <TData = Awaited<ReturnType<typeof getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot>>, TError = unknown>(
 params?: GetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshot>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyDailyCreditSnapshotGetCompanyDailyCreditSnapshotQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot = (
    companyDailyCreditSnapshot: CompanyDailyCreditSnapshot,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyDailyCreditSnapshot>(
      {url: `/CompanyDailyCreditSnapshot/SaveCompanyDailyCreditSnapshot`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyDailyCreditSnapshot
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshotMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot>>, TError,{data: CompanyDailyCreditSnapshot}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot>>, TError,{data: CompanyDailyCreditSnapshot}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot>>, {data: CompanyDailyCreditSnapshot}> = (props) => {
          const {data} = props ?? {};

          return  postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshotMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot>>>
    export type PostCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshotMutationBody = CompanyDailyCreditSnapshot
    export type PostCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshotMutationError = unknown

    export const usePostCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot>>, TError,{data: CompanyDailyCreditSnapshot}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshot>>,
        TError,
        {data: CompanyDailyCreditSnapshot},
        TContext
      > => {

      const mutationOptions = getPostCompanyDailyCreditSnapshotSaveCompanyDailyCreditSnapshotMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCompanyRelationshipGetCompanyRelationships = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyRelationshipBundle>(
      {url: `/CompanyRelationship/GetCompanyRelationships`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyRelationshipGetCompanyRelationshipsQueryKey = () => {
    return [`/CompanyRelationship/GetCompanyRelationships`] as const;
    }

    
export const getGetCompanyRelationshipGetCompanyRelationshipsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyRelationshipGetCompanyRelationships>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetCompanyRelationships>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyRelationshipGetCompanyRelationshipsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyRelationshipGetCompanyRelationships>>> = ({ signal }) => getCompanyRelationshipGetCompanyRelationships(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetCompanyRelationships>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyRelationshipGetCompanyRelationshipsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyRelationshipGetCompanyRelationships>>>
export type GetCompanyRelationshipGetCompanyRelationshipsQueryError = unknown

export const useGetCompanyRelationshipGetCompanyRelationships = <TData = Awaited<ReturnType<typeof getCompanyRelationshipGetCompanyRelationships>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetCompanyRelationships>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyRelationshipGetCompanyRelationshipsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyRelationshipGetDataAccessDefinitions = (
    params?: GetCompanyRelationshipGetDataAccessDefinitionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<DataAccessDefinitionBundle[]>(
      {url: `/CompanyRelationship/GetDataAccessDefinitions`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyRelationshipGetDataAccessDefinitionsQueryKey = (params?: GetCompanyRelationshipGetDataAccessDefinitionsParams,) => {
    return [`/CompanyRelationship/GetDataAccessDefinitions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyRelationshipGetDataAccessDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessDefinitions>>, TError = unknown>(params?: GetCompanyRelationshipGetDataAccessDefinitionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessDefinitions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyRelationshipGetDataAccessDefinitionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessDefinitions>>> = ({ signal }) => getCompanyRelationshipGetDataAccessDefinitions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessDefinitions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyRelationshipGetDataAccessDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessDefinitions>>>
export type GetCompanyRelationshipGetDataAccessDefinitionsQueryError = unknown

export const useGetCompanyRelationshipGetDataAccessDefinitions = <TData = Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessDefinitions>>, TError = unknown>(
 params?: GetCompanyRelationshipGetDataAccessDefinitionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessDefinitions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyRelationshipGetDataAccessDefinitionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCompanyRelationshipGetDataAccessBeneficiaries = (
    params?: GetCompanyRelationshipGetDataAccessBeneficiariesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<number[]>(
      {url: `/CompanyRelationship/GetDataAccessBeneficiaries`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCompanyRelationshipGetDataAccessBeneficiariesQueryKey = (params?: GetCompanyRelationshipGetDataAccessBeneficiariesParams,) => {
    return [`/CompanyRelationship/GetDataAccessBeneficiaries`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCompanyRelationshipGetDataAccessBeneficiariesQueryOptions = <TData = Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessBeneficiaries>>, TError = unknown>(params?: GetCompanyRelationshipGetDataAccessBeneficiariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessBeneficiaries>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyRelationshipGetDataAccessBeneficiariesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessBeneficiaries>>> = ({ signal }) => getCompanyRelationshipGetDataAccessBeneficiaries(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessBeneficiaries>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCompanyRelationshipGetDataAccessBeneficiariesQueryResult = NonNullable<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessBeneficiaries>>>
export type GetCompanyRelationshipGetDataAccessBeneficiariesQueryError = unknown

export const useGetCompanyRelationshipGetDataAccessBeneficiaries = <TData = Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessBeneficiaries>>, TError = unknown>(
 params?: GetCompanyRelationshipGetDataAccessBeneficiariesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCompanyRelationshipGetDataAccessBeneficiaries>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCompanyRelationshipGetDataAccessBeneficiariesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCompanyStatsUpsertCompanyStats = (
    companyStat: CompanyStat[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CompanyStats/UpsertCompanyStats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyStat
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyStatsUpsertCompanyStatsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsUpsertCompanyStats>>, TError,{data: CompanyStat[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsUpsertCompanyStats>>, TError,{data: CompanyStat[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyStatsUpsertCompanyStats>>, {data: CompanyStat[]}> = (props) => {
          const {data} = props ?? {};

          return  postCompanyStatsUpsertCompanyStats(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyStatsUpsertCompanyStatsMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyStatsUpsertCompanyStats>>>
    export type PostCompanyStatsUpsertCompanyStatsMutationBody = CompanyStat[]
    export type PostCompanyStatsUpsertCompanyStatsMutationError = unknown

    export const usePostCompanyStatsUpsertCompanyStats = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsUpsertCompanyStats>>, TError,{data: CompanyStat[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyStatsUpsertCompanyStats>>,
        TError,
        {data: CompanyStat[]},
        TContext
      > => {

      const mutationOptions = getPostCompanyStatsUpsertCompanyStatsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyStatsDeleteCompanyStats = (
    postCompanyStatsDeleteCompanyStatsBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CompanyStats/DeleteCompanyStats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCompanyStatsDeleteCompanyStatsBody
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyStatsDeleteCompanyStatsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsDeleteCompanyStats>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsDeleteCompanyStats>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyStatsDeleteCompanyStats>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postCompanyStatsDeleteCompanyStats(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyStatsDeleteCompanyStatsMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyStatsDeleteCompanyStats>>>
    export type PostCompanyStatsDeleteCompanyStatsMutationBody = number[]
    export type PostCompanyStatsDeleteCompanyStatsMutationError = unknown

    export const usePostCompanyStatsDeleteCompanyStats = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsDeleteCompanyStats>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyStatsDeleteCompanyStats>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostCompanyStatsDeleteCompanyStatsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCompanyStatsQueryCompanyStats = (
    companyStatsQuery: CompanyStatsQuery,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyStatQueryResult>(
      {url: `/CompanyStats/QueryCompanyStats`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyStatsQuery
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCompanyStatsQueryCompanyStatsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsQueryCompanyStats>>, TError,{data: CompanyStatsQuery}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsQueryCompanyStats>>, TError,{data: CompanyStatsQuery}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCompanyStatsQueryCompanyStats>>, {data: CompanyStatsQuery}> = (props) => {
          const {data} = props ?? {};

          return  postCompanyStatsQueryCompanyStats(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCompanyStatsQueryCompanyStatsMutationResult = NonNullable<Awaited<ReturnType<typeof postCompanyStatsQueryCompanyStats>>>
    export type PostCompanyStatsQueryCompanyStatsMutationBody = CompanyStatsQuery
    export type PostCompanyStatsQueryCompanyStatsMutationError = unknown

    export const usePostCompanyStatsQueryCompanyStats = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCompanyStatsQueryCompanyStats>>, TError,{data: CompanyStatsQuery}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCompanyStatsQueryCompanyStats>>,
        TError,
        {data: CompanyStatsQuery},
        TContext
      > => {

      const mutationOptions = getPostCompanyStatsQueryCompanyStatsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCreditsGetCreditSummary = (
    params?: GetCreditsGetCreditSummaryParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CreditSummary>(
      {url: `/Credits/GetCreditSummary`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsGetCreditSummaryQueryKey = (params?: GetCreditsGetCreditSummaryParams,) => {
    return [`/Credits/GetCreditSummary`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCreditsGetCreditSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsGetCreditSummary>>, TError = unknown>(params?: GetCreditsGetCreditSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditSummary>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsGetCreditSummaryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsGetCreditSummary>>> = ({ signal }) => getCreditsGetCreditSummary(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsGetCreditSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsGetCreditSummary>>>
export type GetCreditsGetCreditSummaryQueryError = unknown

export const useGetCreditsGetCreditSummary = <TData = Awaited<ReturnType<typeof getCreditsGetCreditSummary>>, TError = unknown>(
 params?: GetCreditsGetCreditSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditSummary>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsGetCreditSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCreditsUpdateCreditOverride = (
    params?: PostCreditsUpdateCreditOverrideParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CreditSummary>(
      {url: `/Credits/UpdateCreditOverride`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCreditsUpdateCreditOverrideMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditsUpdateCreditOverride>>, TError,{params?: PostCreditsUpdateCreditOverrideParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreditsUpdateCreditOverride>>, TError,{params?: PostCreditsUpdateCreditOverrideParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreditsUpdateCreditOverride>>, {params?: PostCreditsUpdateCreditOverrideParams}> = (props) => {
          const {params} = props ?? {};

          return  postCreditsUpdateCreditOverride(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreditsUpdateCreditOverrideMutationResult = NonNullable<Awaited<ReturnType<typeof postCreditsUpdateCreditOverride>>>
    
    export type PostCreditsUpdateCreditOverrideMutationError = unknown

    export const usePostCreditsUpdateCreditOverride = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditsUpdateCreditOverride>>, TError,{params?: PostCreditsUpdateCreditOverrideParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCreditsUpdateCreditOverride>>,
        TError,
        {params?: PostCreditsUpdateCreditOverrideParams},
        TContext
      > => {

      const mutationOptions = getPostCreditsUpdateCreditOverrideMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCreditsGetCreditTransactions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CreditTransaction[]>(
      {url: `/Credits/GetCreditTransactions`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsGetCreditTransactionsQueryKey = () => {
    return [`/Credits/GetCreditTransactions`] as const;
    }

    
export const getGetCreditsGetCreditTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsGetCreditTransactions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditTransactions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsGetCreditTransactionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsGetCreditTransactions>>> = ({ signal }) => getCreditsGetCreditTransactions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditTransactions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsGetCreditTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsGetCreditTransactions>>>
export type GetCreditsGetCreditTransactionsQueryError = unknown

export const useGetCreditsGetCreditTransactions = <TData = Awaited<ReturnType<typeof getCreditsGetCreditTransactions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditTransactions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsGetCreditTransactionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreditsGetCreditTransactionsForPeriod = (
    params?: GetCreditsGetCreditTransactionsForPeriodParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CreditTransaction[]>(
      {url: `/Credits/GetCreditTransactionsForPeriod`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsGetCreditTransactionsForPeriodQueryKey = (params?: GetCreditsGetCreditTransactionsForPeriodParams,) => {
    return [`/Credits/GetCreditTransactionsForPeriod`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCreditsGetCreditTransactionsForPeriodQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsGetCreditTransactionsForPeriod>>, TError = unknown>(params?: GetCreditsGetCreditTransactionsForPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditTransactionsForPeriod>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsGetCreditTransactionsForPeriodQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsGetCreditTransactionsForPeriod>>> = ({ signal }) => getCreditsGetCreditTransactionsForPeriod(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditTransactionsForPeriod>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsGetCreditTransactionsForPeriodQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsGetCreditTransactionsForPeriod>>>
export type GetCreditsGetCreditTransactionsForPeriodQueryError = unknown

export const useGetCreditsGetCreditTransactionsForPeriod = <TData = Awaited<ReturnType<typeof getCreditsGetCreditTransactionsForPeriod>>, TError = unknown>(
 params?: GetCreditsGetCreditTransactionsForPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditTransactionsForPeriod>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsGetCreditTransactionsForPeriodQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreditsGetCreditsSpentForPeriod = (
    params?: GetCreditsGetCreditsSpentForPeriodParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyCreditUsage[]>(
      {url: `/Credits/GetCreditsSpentForPeriod`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsGetCreditsSpentForPeriodQueryKey = (params?: GetCreditsGetCreditsSpentForPeriodParams,) => {
    return [`/Credits/GetCreditsSpentForPeriod`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCreditsGetCreditsSpentForPeriodQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsGetCreditsSpentForPeriod>>, TError = unknown>(params?: GetCreditsGetCreditsSpentForPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditsSpentForPeriod>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsGetCreditsSpentForPeriodQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsGetCreditsSpentForPeriod>>> = ({ signal }) => getCreditsGetCreditsSpentForPeriod(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditsSpentForPeriod>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsGetCreditsSpentForPeriodQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsGetCreditsSpentForPeriod>>>
export type GetCreditsGetCreditsSpentForPeriodQueryError = unknown

export const useGetCreditsGetCreditsSpentForPeriod = <TData = Awaited<ReturnType<typeof getCreditsGetCreditsSpentForPeriod>>, TError = unknown>(
 params?: GetCreditsGetCreditsSpentForPeriodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsGetCreditsSpentForPeriod>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsGetCreditsSpentForPeriodQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreditsAddCredits = (
    params?: GetCreditsAddCreditsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<boolean>(
      {url: `/Credits/AddCredits`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsAddCreditsQueryKey = (params?: GetCreditsAddCreditsParams,) => {
    return [`/Credits/AddCredits`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCreditsAddCreditsQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsAddCredits>>, TError = unknown>(params?: GetCreditsAddCreditsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsAddCredits>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsAddCreditsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsAddCredits>>> = ({ signal }) => getCreditsAddCredits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsAddCredits>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsAddCreditsQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsAddCredits>>>
export type GetCreditsAddCreditsQueryError = unknown

export const useGetCreditsAddCredits = <TData = Awaited<ReturnType<typeof getCreditsAddCredits>>, TError = unknown>(
 params?: GetCreditsAddCreditsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsAddCredits>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsAddCreditsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCreditsAddCreditsBySupportUser = (
    params?: PostCreditsAddCreditsBySupportUserParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/Credits/AddCreditsBySupportUser`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCreditsAddCreditsBySupportUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditsAddCreditsBySupportUser>>, TError,{params?: PostCreditsAddCreditsBySupportUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreditsAddCreditsBySupportUser>>, TError,{params?: PostCreditsAddCreditsBySupportUserParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreditsAddCreditsBySupportUser>>, {params?: PostCreditsAddCreditsBySupportUserParams}> = (props) => {
          const {params} = props ?? {};

          return  postCreditsAddCreditsBySupportUser(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreditsAddCreditsBySupportUserMutationResult = NonNullable<Awaited<ReturnType<typeof postCreditsAddCreditsBySupportUser>>>
    
    export type PostCreditsAddCreditsBySupportUserMutationError = unknown

    export const usePostCreditsAddCreditsBySupportUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditsAddCreditsBySupportUser>>, TError,{params?: PostCreditsAddCreditsBySupportUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCreditsAddCreditsBySupportUser>>,
        TError,
        {params?: PostCreditsAddCreditsBySupportUserParams},
        TContext
      > => {

      const mutationOptions = getPostCreditsAddCreditsBySupportUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCreditsCheckCreditCount = (
    params?: GetCreditsCheckCreditCountParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<number>(
      {url: `/Credits/CheckCreditCount`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsCheckCreditCountQueryKey = (params?: GetCreditsCheckCreditCountParams,) => {
    return [`/Credits/CheckCreditCount`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCreditsCheckCreditCountQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsCheckCreditCount>>, TError = unknown>(params?: GetCreditsCheckCreditCountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsCheckCreditCount>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsCheckCreditCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsCheckCreditCount>>> = ({ signal }) => getCreditsCheckCreditCount(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsCheckCreditCount>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsCheckCreditCountQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsCheckCreditCount>>>
export type GetCreditsCheckCreditCountQueryError = unknown

export const useGetCreditsCheckCreditCount = <TData = Awaited<ReturnType<typeof getCreditsCheckCreditCount>>, TError = unknown>(
 params?: GetCreditsCheckCreditCountParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsCheckCreditCount>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsCheckCreditCountQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreditsIsSpendLimited = (
    params?: GetCreditsIsSpendLimitedParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<boolean>(
      {url: `/Credits/IsSpendLimited`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsIsSpendLimitedQueryKey = (params?: GetCreditsIsSpendLimitedParams,) => {
    return [`/Credits/IsSpendLimited`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCreditsIsSpendLimitedQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsIsSpendLimited>>, TError = unknown>(params?: GetCreditsIsSpendLimitedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsIsSpendLimited>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsIsSpendLimitedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsIsSpendLimited>>> = ({ signal }) => getCreditsIsSpendLimited(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsIsSpendLimited>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsIsSpendLimitedQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsIsSpendLimited>>>
export type GetCreditsIsSpendLimitedQueryError = unknown

export const useGetCreditsIsSpendLimited = <TData = Awaited<ReturnType<typeof getCreditsIsSpendLimited>>, TError = unknown>(
 params?: GetCreditsIsSpendLimitedParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsIsSpendLimited>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsIsSpendLimitedQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCreditsTryClaimCredits = (
    params?: GetCreditsTryClaimCreditsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<boolean>(
      {url: `/Credits/TryClaimCredits`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCreditsTryClaimCreditsQueryKey = (params?: GetCreditsTryClaimCreditsParams,) => {
    return [`/Credits/TryClaimCredits`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCreditsTryClaimCreditsQueryOptions = <TData = Awaited<ReturnType<typeof getCreditsTryClaimCredits>>, TError = unknown>(params?: GetCreditsTryClaimCreditsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsTryClaimCredits>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCreditsTryClaimCreditsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCreditsTryClaimCredits>>> = ({ signal }) => getCreditsTryClaimCredits(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCreditsTryClaimCredits>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCreditsTryClaimCreditsQueryResult = NonNullable<Awaited<ReturnType<typeof getCreditsTryClaimCredits>>>
export type GetCreditsTryClaimCreditsQueryError = unknown

export const useGetCreditsTryClaimCredits = <TData = Awaited<ReturnType<typeof getCreditsTryClaimCredits>>, TError = unknown>(
 params?: GetCreditsTryClaimCreditsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCreditsTryClaimCredits>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCreditsTryClaimCreditsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCreditsUpdateSettingsPage = (
    params?: PostCreditsUpdateSettingsPageParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/Credits/UpdateSettingsPage`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCreditsUpdateSettingsPageMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditsUpdateSettingsPage>>, TError,{params?: PostCreditsUpdateSettingsPageParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCreditsUpdateSettingsPage>>, TError,{params?: PostCreditsUpdateSettingsPageParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCreditsUpdateSettingsPage>>, {params?: PostCreditsUpdateSettingsPageParams}> = (props) => {
          const {params} = props ?? {};

          return  postCreditsUpdateSettingsPage(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCreditsUpdateSettingsPageMutationResult = NonNullable<Awaited<ReturnType<typeof postCreditsUpdateSettingsPage>>>
    
    export type PostCreditsUpdateSettingsPageMutationError = unknown

    export const usePostCreditsUpdateSettingsPage = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCreditsUpdateSettingsPage>>, TError,{params?: PostCreditsUpdateSettingsPageParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCreditsUpdateSettingsPage>>,
        TError,
        {params?: PostCreditsUpdateSettingsPageParams},
        TContext
      > => {

      const mutationOptions = getPostCreditsUpdateSettingsPageMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspMktAzHook = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CspMkt/AzHook`, method: 'POST'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktAzHookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktAzHook>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktAzHook>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktAzHook>>, void> = () => {
          

          return  postCspMktAzHook(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktAzHookMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktAzHook>>>
    
    export type PostCspMktAzHookMutationError = unknown

    export const usePostCspMktAzHook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktAzHook>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktAzHook>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostCspMktAzHookMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCspMktGetStagedAzureSubscription = (
    params?: GetCspMktGetStagedAzureSubscriptionParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AzureMarketplaceSubscription>(
      {url: `/CspMkt/GetStagedAzureSubscription`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCspMktGetStagedAzureSubscriptionQueryKey = (params?: GetCspMktGetStagedAzureSubscriptionParams,) => {
    return [`/CspMkt/GetStagedAzureSubscription`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCspMktGetStagedAzureSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getCspMktGetStagedAzureSubscription>>, TError = unknown>(params?: GetCspMktGetStagedAzureSubscriptionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetStagedAzureSubscription>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCspMktGetStagedAzureSubscriptionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCspMktGetStagedAzureSubscription>>> = ({ signal }) => getCspMktGetStagedAzureSubscription(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetStagedAzureSubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCspMktGetStagedAzureSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getCspMktGetStagedAzureSubscription>>>
export type GetCspMktGetStagedAzureSubscriptionQueryError = unknown

export const useGetCspMktGetStagedAzureSubscription = <TData = Awaited<ReturnType<typeof getCspMktGetStagedAzureSubscription>>, TError = unknown>(
 params?: GetCspMktGetStagedAzureSubscriptionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetStagedAzureSubscription>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCspMktGetStagedAzureSubscriptionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCspMktActivateAzureSubscription = (
    params?: PostCspMktActivateAzureSubscriptionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CspMkt/ActivateAzureSubscription`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktActivateAzureSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAzureSubscription>>, TError,{params?: PostCspMktActivateAzureSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAzureSubscription>>, TError,{params?: PostCspMktActivateAzureSubscriptionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktActivateAzureSubscription>>, {params?: PostCspMktActivateAzureSubscriptionParams}> = (props) => {
          const {params} = props ?? {};

          return  postCspMktActivateAzureSubscription(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktActivateAzureSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktActivateAzureSubscription>>>
    
    export type PostCspMktActivateAzureSubscriptionMutationError = unknown

    export const usePostCspMktActivateAzureSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAzureSubscription>>, TError,{params?: PostCspMktActivateAzureSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktActivateAzureSubscription>>,
        TError,
        {params?: PostCspMktActivateAzureSubscriptionParams},
        TContext
      > => {

      const mutationOptions = getPostCspMktActivateAzureSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspMktGetPendingPaymentMethod = (
    params?: PostCspMktGetPendingPaymentMethodParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PendingPaymentMethodInfo>(
      {url: `/CspMkt/GetPendingPaymentMethod`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktGetPendingPaymentMethodMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktGetPendingPaymentMethod>>, TError,{params?: PostCspMktGetPendingPaymentMethodParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktGetPendingPaymentMethod>>, TError,{params?: PostCspMktGetPendingPaymentMethodParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktGetPendingPaymentMethod>>, {params?: PostCspMktGetPendingPaymentMethodParams}> = (props) => {
          const {params} = props ?? {};

          return  postCspMktGetPendingPaymentMethod(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktGetPendingPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktGetPendingPaymentMethod>>>
    
    export type PostCspMktGetPendingPaymentMethodMutationError = unknown

    export const usePostCspMktGetPendingPaymentMethod = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktGetPendingPaymentMethod>>, TError,{params?: PostCspMktGetPendingPaymentMethodParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktGetPendingPaymentMethod>>,
        TError,
        {params?: PostCspMktGetPendingPaymentMethodParams},
        TContext
      > => {

      const mutationOptions = getPostCspMktGetPendingPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspMktActivateAzureSubscriptionBySecret = (
    params?: PostCspMktActivateAzureSubscriptionBySecretParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CspMkt/ActivateAzureSubscriptionBySecret`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktActivateAzureSubscriptionBySecretMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAzureSubscriptionBySecret>>, TError,{params?: PostCspMktActivateAzureSubscriptionBySecretParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAzureSubscriptionBySecret>>, TError,{params?: PostCspMktActivateAzureSubscriptionBySecretParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktActivateAzureSubscriptionBySecret>>, {params?: PostCspMktActivateAzureSubscriptionBySecretParams}> = (props) => {
          const {params} = props ?? {};

          return  postCspMktActivateAzureSubscriptionBySecret(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktActivateAzureSubscriptionBySecretMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktActivateAzureSubscriptionBySecret>>>
    
    export type PostCspMktActivateAzureSubscriptionBySecretMutationError = unknown

    export const usePostCspMktActivateAzureSubscriptionBySecret = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAzureSubscriptionBySecret>>, TError,{params?: PostCspMktActivateAzureSubscriptionBySecretParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktActivateAzureSubscriptionBySecret>>,
        TError,
        {params?: PostCspMktActivateAzureSubscriptionBySecretParams},
        TContext
      > => {

      const mutationOptions = getPostCspMktActivateAzureSubscriptionBySecretMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspMktAwsMarketplaceOffer = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CspMkt/AwsMarketplaceOffer`, method: 'POST'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktAwsMarketplaceOfferMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktAwsMarketplaceOffer>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktAwsMarketplaceOffer>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktAwsMarketplaceOffer>>, void> = () => {
          

          return  postCspMktAwsMarketplaceOffer(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktAwsMarketplaceOfferMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktAwsMarketplaceOffer>>>
    
    export type PostCspMktAwsMarketplaceOfferMutationError = unknown

    export const usePostCspMktAwsMarketplaceOffer = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktAwsMarketplaceOffer>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktAwsMarketplaceOffer>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostCspMktAwsMarketplaceOfferMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCspMktGetAwsSubscriptions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsMarketplaceSubscription[]>(
      {url: `/CspMkt/GetAwsSubscriptions`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCspMktGetAwsSubscriptionsQueryKey = () => {
    return [`/CspMkt/GetAwsSubscriptions`] as const;
    }

    
export const getGetCspMktGetAwsSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getCspMktGetAwsSubscriptions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCspMktGetAwsSubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptions>>> = ({ signal }) => getCspMktGetAwsSubscriptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCspMktGetAwsSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptions>>>
export type GetCspMktGetAwsSubscriptionsQueryError = unknown

export const useGetCspMktGetAwsSubscriptions = <TData = Awaited<ReturnType<typeof getCspMktGetAwsSubscriptions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCspMktGetAwsSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCspMktGetAwsMarketplaceOffers = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsMarketplaceOffer[]>(
      {url: `/CspMkt/GetAwsMarketplaceOffers`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCspMktGetAwsMarketplaceOffersQueryKey = () => {
    return [`/CspMkt/GetAwsMarketplaceOffers`] as const;
    }

    
export const getGetCspMktGetAwsMarketplaceOffersQueryOptions = <TData = Awaited<ReturnType<typeof getCspMktGetAwsMarketplaceOffers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsMarketplaceOffers>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCspMktGetAwsMarketplaceOffersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCspMktGetAwsMarketplaceOffers>>> = ({ signal }) => getCspMktGetAwsMarketplaceOffers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsMarketplaceOffers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCspMktGetAwsMarketplaceOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getCspMktGetAwsMarketplaceOffers>>>
export type GetCspMktGetAwsMarketplaceOffersQueryError = unknown

export const useGetCspMktGetAwsMarketplaceOffers = <TData = Awaited<ReturnType<typeof getCspMktGetAwsMarketplaceOffers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsMarketplaceOffers>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCspMktGetAwsMarketplaceOffersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCspMktStagePrivateAwsSubscription = (
    createAwsMarketplacePrivateOfferRequest: CreateAwsMarketplacePrivateOfferRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AwsMarketplaceSubscription>(
      {url: `/CspMkt/StagePrivateAwsSubscription`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAwsMarketplacePrivateOfferRequest
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktStagePrivateAwsSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktStagePrivateAwsSubscription>>, TError,{data: CreateAwsMarketplacePrivateOfferRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktStagePrivateAwsSubscription>>, TError,{data: CreateAwsMarketplacePrivateOfferRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktStagePrivateAwsSubscription>>, {data: CreateAwsMarketplacePrivateOfferRequest}> = (props) => {
          const {data} = props ?? {};

          return  postCspMktStagePrivateAwsSubscription(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktStagePrivateAwsSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktStagePrivateAwsSubscription>>>
    export type PostCspMktStagePrivateAwsSubscriptionMutationBody = CreateAwsMarketplacePrivateOfferRequest
    export type PostCspMktStagePrivateAwsSubscriptionMutationError = unknown

    export const usePostCspMktStagePrivateAwsSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktStagePrivateAwsSubscription>>, TError,{data: CreateAwsMarketplacePrivateOfferRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktStagePrivateAwsSubscription>>,
        TError,
        {data: CreateAwsMarketplacePrivateOfferRequest},
        TContext
      > => {

      const mutationOptions = getPostCspMktStagePrivateAwsSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteCspMktStagePrivateAwsSubscription = (
    params?: DeleteCspMktStagePrivateAwsSubscriptionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CspMkt/StagePrivateAwsSubscription`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteCspMktStagePrivateAwsSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCspMktStagePrivateAwsSubscription>>, TError,{params?: DeleteCspMktStagePrivateAwsSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCspMktStagePrivateAwsSubscription>>, TError,{params?: DeleteCspMktStagePrivateAwsSubscriptionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCspMktStagePrivateAwsSubscription>>, {params?: DeleteCspMktStagePrivateAwsSubscriptionParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteCspMktStagePrivateAwsSubscription(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCspMktStagePrivateAwsSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCspMktStagePrivateAwsSubscription>>>
    
    export type DeleteCspMktStagePrivateAwsSubscriptionMutationError = unknown

    export const useDeleteCspMktStagePrivateAwsSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCspMktStagePrivateAwsSubscription>>, TError,{params?: DeleteCspMktStagePrivateAwsSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteCspMktStagePrivateAwsSubscription>>,
        TError,
        {params?: DeleteCspMktStagePrivateAwsSubscriptionParams},
        TContext
      > => {

      const mutationOptions = getDeleteCspMktStagePrivateAwsSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCspMktGetAwsSubscription = (
    params?: GetCspMktGetAwsSubscriptionParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsMarketplaceSubscription>(
      {url: `/CspMkt/GetAwsSubscription`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCspMktGetAwsSubscriptionQueryKey = (params?: GetCspMktGetAwsSubscriptionParams,) => {
    return [`/CspMkt/GetAwsSubscription`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCspMktGetAwsSubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getCspMktGetAwsSubscription>>, TError = unknown>(params?: GetCspMktGetAwsSubscriptionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscription>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCspMktGetAwsSubscriptionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCspMktGetAwsSubscription>>> = ({ signal }) => getCspMktGetAwsSubscription(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCspMktGetAwsSubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getCspMktGetAwsSubscription>>>
export type GetCspMktGetAwsSubscriptionQueryError = unknown

export const useGetCspMktGetAwsSubscription = <TData = Awaited<ReturnType<typeof getCspMktGetAwsSubscription>>, TError = unknown>(
 params?: GetCspMktGetAwsSubscriptionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscription>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCspMktGetAwsSubscriptionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCspMktGetAwsSubscriptionById = (
    params?: GetCspMktGetAwsSubscriptionByIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsMarketplaceSubscription>(
      {url: `/CspMkt/GetAwsSubscriptionById`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCspMktGetAwsSubscriptionByIdQueryKey = (params?: GetCspMktGetAwsSubscriptionByIdParams,) => {
    return [`/CspMkt/GetAwsSubscriptionById`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCspMktGetAwsSubscriptionByIdQueryOptions = <TData = Awaited<ReturnType<typeof getCspMktGetAwsSubscriptionById>>, TError = unknown>(params?: GetCspMktGetAwsSubscriptionByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptionById>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCspMktGetAwsSubscriptionByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptionById>>> = ({ signal }) => getCspMktGetAwsSubscriptionById(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptionById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCspMktGetAwsSubscriptionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptionById>>>
export type GetCspMktGetAwsSubscriptionByIdQueryError = unknown

export const useGetCspMktGetAwsSubscriptionById = <TData = Awaited<ReturnType<typeof getCspMktGetAwsSubscriptionById>>, TError = unknown>(
 params?: GetCspMktGetAwsSubscriptionByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCspMktGetAwsSubscriptionById>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCspMktGetAwsSubscriptionByIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCspMktActivateAwsSubscription = (
    params?: PostCspMktActivateAwsSubscriptionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CspMkt/ActivateAwsSubscription`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktActivateAwsSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAwsSubscription>>, TError,{params?: PostCspMktActivateAwsSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAwsSubscription>>, TError,{params?: PostCspMktActivateAwsSubscriptionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktActivateAwsSubscription>>, {params?: PostCspMktActivateAwsSubscriptionParams}> = (props) => {
          const {params} = props ?? {};

          return  postCspMktActivateAwsSubscription(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktActivateAwsSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktActivateAwsSubscription>>>
    
    export type PostCspMktActivateAwsSubscriptionMutationError = unknown

    export const usePostCspMktActivateAwsSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAwsSubscription>>, TError,{params?: PostCspMktActivateAwsSubscriptionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktActivateAwsSubscription>>,
        TError,
        {params?: PostCspMktActivateAwsSubscriptionParams},
        TContext
      > => {

      const mutationOptions = getPostCspMktActivateAwsSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCspMktActivateAwsPayment = (
    params?: PostCspMktActivateAwsPaymentParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CspMkt/ActivateAwsPayment`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCspMktActivateAwsPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAwsPayment>>, TError,{params?: PostCspMktActivateAwsPaymentParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAwsPayment>>, TError,{params?: PostCspMktActivateAwsPaymentParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCspMktActivateAwsPayment>>, {params?: PostCspMktActivateAwsPaymentParams}> = (props) => {
          const {params} = props ?? {};

          return  postCspMktActivateAwsPayment(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCspMktActivateAwsPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof postCspMktActivateAwsPayment>>>
    
    export type PostCspMktActivateAwsPaymentMutationError = unknown

    export const usePostCspMktActivateAwsPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCspMktActivateAwsPayment>>, TError,{params?: PostCspMktActivateAwsPaymentParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCspMktActivateAwsPayment>>,
        TError,
        {params?: PostCspMktActivateAwsPaymentParams},
        TContext
      > => {

      const mutationOptions = getPostCspMktActivateAwsPaymentMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCustomerFeedbackSendLead = (
    customerFeedbackRequest: CustomerFeedbackRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/CustomerFeedback/SendLead`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerFeedbackRequest
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCustomerFeedbackSendLeadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerFeedbackSendLead>>, TError,{data: CustomerFeedbackRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomerFeedbackSendLead>>, TError,{data: CustomerFeedbackRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomerFeedbackSendLead>>, {data: CustomerFeedbackRequest}> = (props) => {
          const {data} = props ?? {};

          return  postCustomerFeedbackSendLead(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCustomerFeedbackSendLeadMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomerFeedbackSendLead>>>
    export type PostCustomerFeedbackSendLeadMutationBody = CustomerFeedbackRequest
    export type PostCustomerFeedbackSendLeadMutationError = unknown

    export const usePostCustomerFeedbackSendLead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomerFeedbackSendLead>>, TError,{data: CustomerFeedbackRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCustomerFeedbackSendLead>>,
        TError,
        {data: CustomerFeedbackRequest},
        TContext
      > => {

      const mutationOptions = getPostCustomerFeedbackSendLeadMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getCWMetricsConfigGetCWMetricsConfig = (
    params?: GetCWMetricsConfigGetCWMetricsConfigParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CWMetricsConfigData>(
      {url: `/CWMetricsConfig/GetCWMetricsConfig`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCWMetricsConfigGetCWMetricsConfigQueryKey = (params?: GetCWMetricsConfigGetCWMetricsConfigParams,) => {
    return [`/CWMetricsConfig/GetCWMetricsConfig`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCWMetricsConfigGetCWMetricsConfigQueryOptions = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfig>>, TError = unknown>(params?: GetCWMetricsConfigGetCWMetricsConfigParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfig>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCWMetricsConfigGetCWMetricsConfigQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfig>>> = ({ signal }) => getCWMetricsConfigGetCWMetricsConfig(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfig>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCWMetricsConfigGetCWMetricsConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfig>>>
export type GetCWMetricsConfigGetCWMetricsConfigQueryError = unknown

export const useGetCWMetricsConfigGetCWMetricsConfig = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfig>>, TError = unknown>(
 params?: GetCWMetricsConfigGetCWMetricsConfigParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfig>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCWMetricsConfigGetCWMetricsConfigQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCWMetricsConfigGetCWMetricsConfigData = (
    params?: GetCWMetricsConfigGetCWMetricsConfigDataParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CWMetricsConfigData[]>(
      {url: `/CWMetricsConfig/GetCWMetricsConfigData`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCWMetricsConfigGetCWMetricsConfigDataQueryKey = (params?: GetCWMetricsConfigGetCWMetricsConfigDataParams,) => {
    return [`/CWMetricsConfig/GetCWMetricsConfigData`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCWMetricsConfigGetCWMetricsConfigDataQueryOptions = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigData>>, TError = unknown>(params?: GetCWMetricsConfigGetCWMetricsConfigDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigData>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCWMetricsConfigGetCWMetricsConfigDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigData>>> = ({ signal }) => getCWMetricsConfigGetCWMetricsConfigData(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigData>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCWMetricsConfigGetCWMetricsConfigDataQueryResult = NonNullable<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigData>>>
export type GetCWMetricsConfigGetCWMetricsConfigDataQueryError = unknown

export const useGetCWMetricsConfigGetCWMetricsConfigData = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigData>>, TError = unknown>(
 params?: GetCWMetricsConfigGetCWMetricsConfigDataParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigData>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCWMetricsConfigGetCWMetricsConfigDataQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCWMetricsConfigGetCWMetricsConfigFilters = (
    params?: GetCWMetricsConfigGetCWMetricsConfigFiltersParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsCWMetricsConfig[]>(
      {url: `/CWMetricsConfig/GetCWMetricsConfigFilters`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCWMetricsConfigGetCWMetricsConfigFiltersQueryKey = (params?: GetCWMetricsConfigGetCWMetricsConfigFiltersParams,) => {
    return [`/CWMetricsConfig/GetCWMetricsConfigFilters`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCWMetricsConfigGetCWMetricsConfigFiltersQueryOptions = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigFilters>>, TError = unknown>(params?: GetCWMetricsConfigGetCWMetricsConfigFiltersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigFilters>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCWMetricsConfigGetCWMetricsConfigFiltersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigFilters>>> = ({ signal }) => getCWMetricsConfigGetCWMetricsConfigFilters(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigFilters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCWMetricsConfigGetCWMetricsConfigFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigFilters>>>
export type GetCWMetricsConfigGetCWMetricsConfigFiltersQueryError = unknown

export const useGetCWMetricsConfigGetCWMetricsConfigFilters = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigFilters>>, TError = unknown>(
 params?: GetCWMetricsConfigGetCWMetricsConfigFiltersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCWMetricsConfigFilters>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCWMetricsConfigGetCWMetricsConfigFiltersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCWMetricsConfigGetCwMetricFiltersOrDefault = (
    params?: GetCWMetricsConfigGetCwMetricFiltersOrDefaultParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetCWMetricsConfigGetCwMetricFiltersOrDefault200One | GetCWMetricsConfigGetCwMetricFiltersOrDefault200Two | GetCWMetricsConfigGetCwMetricFiltersOrDefault200Three>(
      {url: `/CWMetricsConfig/GetCwMetricFiltersOrDefault`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetCWMetricsConfigGetCwMetricFiltersOrDefaultQueryKey = (params?: GetCWMetricsConfigGetCwMetricFiltersOrDefaultParams,) => {
    return [`/CWMetricsConfig/GetCwMetricFiltersOrDefault`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCWMetricsConfigGetCwMetricFiltersOrDefaultQueryOptions = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCwMetricFiltersOrDefault>>, TError = unknown>(params?: GetCWMetricsConfigGetCwMetricFiltersOrDefaultParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCwMetricFiltersOrDefault>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCWMetricsConfigGetCwMetricFiltersOrDefaultQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCWMetricsConfigGetCwMetricFiltersOrDefault>>> = ({ signal }) => getCWMetricsConfigGetCwMetricFiltersOrDefault(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCwMetricFiltersOrDefault>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCWMetricsConfigGetCwMetricFiltersOrDefaultQueryResult = NonNullable<Awaited<ReturnType<typeof getCWMetricsConfigGetCwMetricFiltersOrDefault>>>
export type GetCWMetricsConfigGetCwMetricFiltersOrDefaultQueryError = unknown

export const useGetCWMetricsConfigGetCwMetricFiltersOrDefault = <TData = Awaited<ReturnType<typeof getCWMetricsConfigGetCwMetricFiltersOrDefault>>, TError = unknown>(
 params?: GetCWMetricsConfigGetCwMetricFiltersOrDefaultParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCWMetricsConfigGetCwMetricFiltersOrDefault>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCWMetricsConfigGetCwMetricFiltersOrDefaultQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postCWMetricsConfigSaveCWMetricsConfig = (
    params?: PostCWMetricsConfigSaveCWMetricsConfigParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/CWMetricsConfig/SaveCWMetricsConfig`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCWMetricsConfigSaveCWMetricsConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfig>>, TError,{params?: PostCWMetricsConfigSaveCWMetricsConfigParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfig>>, TError,{params?: PostCWMetricsConfigSaveCWMetricsConfigParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfig>>, {params?: PostCWMetricsConfigSaveCWMetricsConfigParams}> = (props) => {
          const {params} = props ?? {};

          return  postCWMetricsConfigSaveCWMetricsConfig(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCWMetricsConfigSaveCWMetricsConfigMutationResult = NonNullable<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfig>>>
    
    export type PostCWMetricsConfigSaveCWMetricsConfigMutationError = unknown

    export const usePostCWMetricsConfigSaveCWMetricsConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfig>>, TError,{params?: PostCWMetricsConfigSaveCWMetricsConfigParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfig>>,
        TError,
        {params?: PostCWMetricsConfigSaveCWMetricsConfigParams},
        TContext
      > => {

      const mutationOptions = getPostCWMetricsConfigSaveCWMetricsConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postCWMetricsConfigSaveCWMetricsConfigFilters = (
    params?: PostCWMetricsConfigSaveCWMetricsConfigFiltersParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/CWMetricsConfig/SaveCWMetricsConfigFilters`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostCWMetricsConfigSaveCWMetricsConfigFiltersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfigFilters>>, TError,{params?: PostCWMetricsConfigSaveCWMetricsConfigFiltersParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfigFilters>>, TError,{params?: PostCWMetricsConfigSaveCWMetricsConfigFiltersParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfigFilters>>, {params?: PostCWMetricsConfigSaveCWMetricsConfigFiltersParams}> = (props) => {
          const {params} = props ?? {};

          return  postCWMetricsConfigSaveCWMetricsConfigFilters(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCWMetricsConfigSaveCWMetricsConfigFiltersMutationResult = NonNullable<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfigFilters>>>
    
    export type PostCWMetricsConfigSaveCWMetricsConfigFiltersMutationError = unknown

    export const usePostCWMetricsConfigSaveCWMetricsConfigFilters = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfigFilters>>, TError,{params?: PostCWMetricsConfigSaveCWMetricsConfigFiltersParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postCWMetricsConfigSaveCWMetricsConfigFilters>>,
        TError,
        {params?: PostCWMetricsConfigSaveCWMetricsConfigFiltersParams},
        TContext
      > => {

      const mutationOptions = getPostCWMetricsConfigSaveCWMetricsConfigFiltersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDashboardSave = (
    dashboardConfig: DashboardConfig,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<DashboardConfig>(
      {url: `/Dashboard/Save`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dashboardConfig
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostDashboardSaveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardSave>>, TError,{data: DashboardConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDashboardSave>>, TError,{data: DashboardConfig}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDashboardSave>>, {data: DashboardConfig}> = (props) => {
          const {data} = props ?? {};

          return  postDashboardSave(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDashboardSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postDashboardSave>>>
    export type PostDashboardSaveMutationBody = DashboardConfig
    export type PostDashboardSaveMutationError = unknown

    export const usePostDashboardSave = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardSave>>, TError,{data: DashboardConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDashboardSave>>,
        TError,
        {data: DashboardConfig},
        TContext
      > => {

      const mutationOptions = getPostDashboardSaveMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDashboardSaveMyPreferences = (
    userPreferences: UserPreferences,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<UserPreferences>(
      {url: `/Dashboard/SaveMyPreferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userPreferences
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostDashboardSaveMyPreferencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardSaveMyPreferences>>, TError,{data: UserPreferences}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDashboardSaveMyPreferences>>, TError,{data: UserPreferences}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDashboardSaveMyPreferences>>, {data: UserPreferences}> = (props) => {
          const {data} = props ?? {};

          return  postDashboardSaveMyPreferences(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDashboardSaveMyPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof postDashboardSaveMyPreferences>>>
    export type PostDashboardSaveMyPreferencesMutationBody = UserPreferences
    export type PostDashboardSaveMyPreferencesMutationError = unknown

    export const usePostDashboardSaveMyPreferences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardSaveMyPreferences>>, TError,{data: UserPreferences}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDashboardSaveMyPreferences>>,
        TError,
        {data: UserPreferences},
        TContext
      > => {

      const mutationOptions = getPostDashboardSaveMyPreferencesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getDashboardGetMyPreferences = (
    params?: GetDashboardGetMyPreferencesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<UserPreferences>(
      {url: `/Dashboard/GetMyPreferences`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetDashboardGetMyPreferencesQueryKey = (params?: GetDashboardGetMyPreferencesParams,) => {
    return [`/Dashboard/GetMyPreferences`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDashboardGetMyPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardGetMyPreferences>>, TError = unknown>(params?: GetDashboardGetMyPreferencesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetMyPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardGetMyPreferencesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardGetMyPreferences>>> = ({ signal }) => getDashboardGetMyPreferences(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetMyPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardGetMyPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardGetMyPreferences>>>
export type GetDashboardGetMyPreferencesQueryError = unknown

export const useGetDashboardGetMyPreferences = <TData = Awaited<ReturnType<typeof getDashboardGetMyPreferences>>, TError = unknown>(
 params?: GetDashboardGetMyPreferencesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetMyPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardGetMyPreferencesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDashboardGetUserPreferences = (
    params?: GetDashboardGetUserPreferencesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<UserPreferences>(
      {url: `/Dashboard/GetUserPreferences`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetDashboardGetUserPreferencesQueryKey = (params?: GetDashboardGetUserPreferencesParams,) => {
    return [`/Dashboard/GetUserPreferences`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDashboardGetUserPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardGetUserPreferences>>, TError = unknown>(params?: GetDashboardGetUserPreferencesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetUserPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardGetUserPreferencesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardGetUserPreferences>>> = ({ signal }) => getDashboardGetUserPreferences(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetUserPreferences>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardGetUserPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardGetUserPreferences>>>
export type GetDashboardGetUserPreferencesQueryError = unknown

export const useGetDashboardGetUserPreferences = <TData = Awaited<ReturnType<typeof getDashboardGetUserPreferences>>, TError = unknown>(
 params?: GetDashboardGetUserPreferencesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetUserPreferences>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardGetUserPreferencesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postDashboardShare = (
    dashboardConfig: DashboardConfig,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<DashboardConfig>(
      {url: `/Dashboard/Share`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dashboardConfig
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostDashboardShareMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardShare>>, TError,{data: DashboardConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDashboardShare>>, TError,{data: DashboardConfig}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDashboardShare>>, {data: DashboardConfig}> = (props) => {
          const {data} = props ?? {};

          return  postDashboardShare(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDashboardShareMutationResult = NonNullable<Awaited<ReturnType<typeof postDashboardShare>>>
    export type PostDashboardShareMutationBody = DashboardConfig
    export type PostDashboardShareMutationError = unknown

    export const usePostDashboardShare = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardShare>>, TError,{data: DashboardConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDashboardShare>>,
        TError,
        {data: DashboardConfig},
        TContext
      > => {

      const mutationOptions = getPostDashboardShareMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDashboardShareWithUser = (
    postDashboardShareWithUserBody: number[],
    params?: PostDashboardShareWithUserParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/Dashboard/ShareWithUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postDashboardShareWithUserBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostDashboardShareWithUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardShareWithUser>>, TError,{data: number[];params?: PostDashboardShareWithUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDashboardShareWithUser>>, TError,{data: number[];params?: PostDashboardShareWithUserParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDashboardShareWithUser>>, {data: number[];params?: PostDashboardShareWithUserParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postDashboardShareWithUser(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDashboardShareWithUserMutationResult = NonNullable<Awaited<ReturnType<typeof postDashboardShareWithUser>>>
    export type PostDashboardShareWithUserMutationBody = number[]
    export type PostDashboardShareWithUserMutationError = unknown

    export const usePostDashboardShareWithUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardShareWithUser>>, TError,{data: number[];params?: PostDashboardShareWithUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDashboardShareWithUser>>,
        TError,
        {data: number[];params?: PostDashboardShareWithUserParams},
        TContext
      > => {

      const mutationOptions = getPostDashboardShareWithUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postDashboardRemoveSharedAccess = (
    params?: PostDashboardRemoveSharedAccessParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/Dashboard/RemoveSharedAccess`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostDashboardRemoveSharedAccessMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardRemoveSharedAccess>>, TError,{params?: PostDashboardRemoveSharedAccessParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDashboardRemoveSharedAccess>>, TError,{params?: PostDashboardRemoveSharedAccessParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDashboardRemoveSharedAccess>>, {params?: PostDashboardRemoveSharedAccessParams}> = (props) => {
          const {params} = props ?? {};

          return  postDashboardRemoveSharedAccess(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDashboardRemoveSharedAccessMutationResult = NonNullable<Awaited<ReturnType<typeof postDashboardRemoveSharedAccess>>>
    
    export type PostDashboardRemoveSharedAccessMutationError = unknown

    export const usePostDashboardRemoveSharedAccess = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardRemoveSharedAccess>>, TError,{params?: PostDashboardRemoveSharedAccessParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDashboardRemoveSharedAccess>>,
        TError,
        {params?: PostDashboardRemoveSharedAccessParams},
        TContext
      > => {

      const mutationOptions = getPostDashboardRemoveSharedAccessMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getDashboardGetUsersByDashboardId = (
    params?: GetDashboardGetUsersByDashboardIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<number[]>(
      {url: `/Dashboard/GetUsersByDashboardId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetDashboardGetUsersByDashboardIdQueryKey = (params?: GetDashboardGetUsersByDashboardIdParams,) => {
    return [`/Dashboard/GetUsersByDashboardId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDashboardGetUsersByDashboardIdQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardGetUsersByDashboardId>>, TError = unknown>(params?: GetDashboardGetUsersByDashboardIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetUsersByDashboardId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardGetUsersByDashboardIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardGetUsersByDashboardId>>> = ({ signal }) => getDashboardGetUsersByDashboardId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetUsersByDashboardId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardGetUsersByDashboardIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardGetUsersByDashboardId>>>
export type GetDashboardGetUsersByDashboardIdQueryError = unknown

export const useGetDashboardGetUsersByDashboardId = <TData = Awaited<ReturnType<typeof getDashboardGetUsersByDashboardId>>, TError = unknown>(
 params?: GetDashboardGetUsersByDashboardIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetUsersByDashboardId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardGetUsersByDashboardIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDashboard = (
    params?: GetDashboardParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<DashboardConfig>(
      {url: `/Dashboard`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetDashboardQueryKey = (params?: GetDashboardParams,) => {
    return [`/Dashboard`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getDashboard>>, TError = unknown>(params?: GetDashboardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboard>>> = ({ signal }) => getDashboard(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboard>>>
export type GetDashboardQueryError = unknown

export const useGetDashboard = <TData = Awaited<ReturnType<typeof getDashboard>>, TError = unknown>(
 params?: GetDashboardParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboard>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const deleteDashboard = (
    params?: DeleteDashboardParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Dashboard`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteDashboardMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDashboard>>, TError,{params?: DeleteDashboardParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDashboard>>, TError,{params?: DeleteDashboardParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDashboard>>, {params?: DeleteDashboardParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteDashboard(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDashboardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDashboard>>>
    
    export type DeleteDashboardMutationError = unknown

    export const useDeleteDashboard = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDashboard>>, TError,{params?: DeleteDashboardParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteDashboard>>,
        TError,
        {params?: DeleteDashboardParams},
        TContext
      > => {

      const mutationOptions = getDeleteDashboardMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getDashboardGetByKey = (
    params?: GetDashboardGetByKeyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<DashboardConfig[]>(
      {url: `/Dashboard/GetByKey`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetDashboardGetByKeyQueryKey = (params?: GetDashboardGetByKeyParams,) => {
    return [`/Dashboard/GetByKey`, ...(params ? [params]: [])] as const;
    }

    
export const getGetDashboardGetByKeyQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardGetByKey>>, TError = unknown>(params?: GetDashboardGetByKeyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetByKey>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardGetByKeyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardGetByKey>>> = ({ signal }) => getDashboardGetByKey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetByKey>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardGetByKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardGetByKey>>>
export type GetDashboardGetByKeyQueryError = unknown

export const useGetDashboardGetByKey = <TData = Awaited<ReturnType<typeof getDashboardGetByKey>>, TError = unknown>(
 params?: GetDashboardGetByKeyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetByKey>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardGetByKeyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getDashboardGetOrCreateDashboardUserSettings = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<DashboardUserSettings>(
      {url: `/Dashboard/GetOrCreateDashboardUserSettings`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetDashboardGetOrCreateDashboardUserSettingsQueryKey = () => {
    return [`/Dashboard/GetOrCreateDashboardUserSettings`] as const;
    }

    
export const getGetDashboardGetOrCreateDashboardUserSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardGetOrCreateDashboardUserSettings>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetOrCreateDashboardUserSettings>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardGetOrCreateDashboardUserSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardGetOrCreateDashboardUserSettings>>> = ({ signal }) => getDashboardGetOrCreateDashboardUserSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetOrCreateDashboardUserSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardGetOrCreateDashboardUserSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardGetOrCreateDashboardUserSettings>>>
export type GetDashboardGetOrCreateDashboardUserSettingsQueryError = unknown

export const useGetDashboardGetOrCreateDashboardUserSettings = <TData = Awaited<ReturnType<typeof getDashboardGetOrCreateDashboardUserSettings>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardGetOrCreateDashboardUserSettings>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetDashboardGetOrCreateDashboardUserSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postDashboardSaveDashboardUserSettings = (
    dashboardUserSettings: DashboardUserSettings,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<DashboardUserSettings>(
      {url: `/Dashboard/SaveDashboardUserSettings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dashboardUserSettings
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostDashboardSaveDashboardUserSettingsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardSaveDashboardUserSettings>>, TError,{data: DashboardUserSettings}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postDashboardSaveDashboardUserSettings>>, TError,{data: DashboardUserSettings}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDashboardSaveDashboardUserSettings>>, {data: DashboardUserSettings}> = (props) => {
          const {data} = props ?? {};

          return  postDashboardSaveDashboardUserSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDashboardSaveDashboardUserSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof postDashboardSaveDashboardUserSettings>>>
    export type PostDashboardSaveDashboardUserSettingsMutationBody = DashboardUserSettings
    export type PostDashboardSaveDashboardUserSettingsMutationError = unknown

    export const usePostDashboardSaveDashboardUserSettings = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDashboardSaveDashboardUserSettings>>, TError,{data: DashboardUserSettings}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postDashboardSaveDashboardUserSettings>>,
        TError,
        {data: DashboardUserSettings},
        TContext
      > => {

      const mutationOptions = getPostDashboardSaveDashboardUserSettingsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getExternalApiKeyGetCompanyApiKeys = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ExternalApiKey[]>(
      {url: `/ExternalApiKey/GetCompanyApiKeys`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetExternalApiKeyGetCompanyApiKeysQueryKey = () => {
    return [`/ExternalApiKey/GetCompanyApiKeys`] as const;
    }

    
export const getGetExternalApiKeyGetCompanyApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof getExternalApiKeyGetCompanyApiKeys>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKeyGetCompanyApiKeys>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalApiKeyGetCompanyApiKeysQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalApiKeyGetCompanyApiKeys>>> = ({ signal }) => getExternalApiKeyGetCompanyApiKeys(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKeyGetCompanyApiKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExternalApiKeyGetCompanyApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalApiKeyGetCompanyApiKeys>>>
export type GetExternalApiKeyGetCompanyApiKeysQueryError = unknown

export const useGetExternalApiKeyGetCompanyApiKeys = <TData = Awaited<ReturnType<typeof getExternalApiKeyGetCompanyApiKeys>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKeyGetCompanyApiKeys>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetExternalApiKeyGetCompanyApiKeysQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getExternalApiKeyGetApiKey = (
    params?: GetExternalApiKeyGetApiKeyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ExternalApiKey>(
      {url: `/ExternalApiKey/GetApiKey`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetExternalApiKeyGetApiKeyQueryKey = (params?: GetExternalApiKeyGetApiKeyParams,) => {
    return [`/ExternalApiKey/GetApiKey`, ...(params ? [params]: [])] as const;
    }

    
export const getGetExternalApiKeyGetApiKeyQueryOptions = <TData = Awaited<ReturnType<typeof getExternalApiKeyGetApiKey>>, TError = unknown>(params?: GetExternalApiKeyGetApiKeyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKeyGetApiKey>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExternalApiKeyGetApiKeyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExternalApiKeyGetApiKey>>> = ({ signal }) => getExternalApiKeyGetApiKey(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKeyGetApiKey>>, TError, TData> & { queryKey: QueryKey }
}

export type GetExternalApiKeyGetApiKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getExternalApiKeyGetApiKey>>>
export type GetExternalApiKeyGetApiKeyQueryError = unknown

export const useGetExternalApiKeyGetApiKey = <TData = Awaited<ReturnType<typeof getExternalApiKeyGetApiKey>>, TError = unknown>(
 params?: GetExternalApiKeyGetApiKeyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getExternalApiKeyGetApiKey>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetExternalApiKeyGetApiKeyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postExternalApiKeyCreateApiKey = (
    params?: PostExternalApiKeyCreateApiKeyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ApiAccessKeyResult>(
      {url: `/ExternalApiKey/CreateApiKey`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostExternalApiKeyCreateApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExternalApiKeyCreateApiKey>>, TError,{params?: PostExternalApiKeyCreateApiKeyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postExternalApiKeyCreateApiKey>>, TError,{params?: PostExternalApiKeyCreateApiKeyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExternalApiKeyCreateApiKey>>, {params?: PostExternalApiKeyCreateApiKeyParams}> = (props) => {
          const {params} = props ?? {};

          return  postExternalApiKeyCreateApiKey(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostExternalApiKeyCreateApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof postExternalApiKeyCreateApiKey>>>
    
    export type PostExternalApiKeyCreateApiKeyMutationError = unknown

    export const usePostExternalApiKeyCreateApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExternalApiKeyCreateApiKey>>, TError,{params?: PostExternalApiKeyCreateApiKeyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postExternalApiKeyCreateApiKey>>,
        TError,
        {params?: PostExternalApiKeyCreateApiKeyParams},
        TContext
      > => {

      const mutationOptions = getPostExternalApiKeyCreateApiKeyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putExternalApiKeyRevokeApiKey = (
    params?: PutExternalApiKeyRevokeApiKeyParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/ExternalApiKey/RevokeApiKey`, method: 'PUT',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutExternalApiKeyRevokeApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExternalApiKeyRevokeApiKey>>, TError,{params?: PutExternalApiKeyRevokeApiKeyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putExternalApiKeyRevokeApiKey>>, TError,{params?: PutExternalApiKeyRevokeApiKeyParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putExternalApiKeyRevokeApiKey>>, {params?: PutExternalApiKeyRevokeApiKeyParams}> = (props) => {
          const {params} = props ?? {};

          return  putExternalApiKeyRevokeApiKey(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutExternalApiKeyRevokeApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putExternalApiKeyRevokeApiKey>>>
    
    export type PutExternalApiKeyRevokeApiKeyMutationError = unknown

    export const usePutExternalApiKeyRevokeApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExternalApiKeyRevokeApiKey>>, TError,{params?: PutExternalApiKeyRevokeApiKeyParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putExternalApiKeyRevokeApiKey>>,
        TError,
        {params?: PutExternalApiKeyRevokeApiKeyParams},
        TContext
      > => {

      const mutationOptions = getPutExternalApiKeyRevokeApiKeyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postFrontEndErrorSaveError = (
    frontEndError: FrontEndError,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/FrontEndError/SaveError`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: frontEndError
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostFrontEndErrorSaveErrorMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFrontEndErrorSaveError>>, TError,{data: FrontEndError}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postFrontEndErrorSaveError>>, TError,{data: FrontEndError}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postFrontEndErrorSaveError>>, {data: FrontEndError}> = (props) => {
          const {data} = props ?? {};

          return  postFrontEndErrorSaveError(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostFrontEndErrorSaveErrorMutationResult = NonNullable<Awaited<ReturnType<typeof postFrontEndErrorSaveError>>>
    export type PostFrontEndErrorSaveErrorMutationBody = FrontEndError
    export type PostFrontEndErrorSaveErrorMutationError = unknown

    export const usePostFrontEndErrorSaveError = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postFrontEndErrorSaveError>>, TError,{data: FrontEndError}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postFrontEndErrorSaveError>>,
        TError,
        {data: FrontEndError},
        TContext
      > => {

      const mutationOptions = getPostFrontEndErrorSaveErrorMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getIntegrationGetIntegrations = (
    params?: GetIntegrationGetIntegrationsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Integration[]>(
      {url: `/Integration/GetIntegrations`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetIntegrationGetIntegrationsQueryKey = (params?: GetIntegrationGetIntegrationsParams,) => {
    return [`/Integration/GetIntegrations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetIntegrationGetIntegrationsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationGetIntegrations>>, TError = unknown>(params?: GetIntegrationGetIntegrationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationGetIntegrations>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationGetIntegrationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationGetIntegrations>>> = ({ signal }) => getIntegrationGetIntegrations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationGetIntegrations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetIntegrationGetIntegrationsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationGetIntegrations>>>
export type GetIntegrationGetIntegrationsQueryError = unknown

export const useGetIntegrationGetIntegrations = <TData = Awaited<ReturnType<typeof getIntegrationGetIntegrations>>, TError = unknown>(
 params?: GetIntegrationGetIntegrationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getIntegrationGetIntegrations>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetIntegrationGetIntegrationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postIntegrationSaveIntegration = (
    integration: Integration,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Integration>(
      {url: `/Integration/SaveIntegration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: integration
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostIntegrationSaveIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationSaveIntegration>>, TError,{data: Integration}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationSaveIntegration>>, TError,{data: Integration}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationSaveIntegration>>, {data: Integration}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationSaveIntegration(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationSaveIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationSaveIntegration>>>
    export type PostIntegrationSaveIntegrationMutationBody = Integration
    export type PostIntegrationSaveIntegrationMutationError = unknown

    export const usePostIntegrationSaveIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationSaveIntegration>>, TError,{data: Integration}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationSaveIntegration>>,
        TError,
        {data: Integration},
        TContext
      > => {

      const mutationOptions = getPostIntegrationSaveIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postIntegrationUpdateStatus = (
    params?: PostIntegrationUpdateStatusParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Integration>(
      {url: `/Integration/UpdateStatus`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostIntegrationUpdateStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationUpdateStatus>>, TError,{params?: PostIntegrationUpdateStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationUpdateStatus>>, TError,{params?: PostIntegrationUpdateStatusParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationUpdateStatus>>, {params?: PostIntegrationUpdateStatusParams}> = (props) => {
          const {params} = props ?? {};

          return  postIntegrationUpdateStatus(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationUpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationUpdateStatus>>>
    
    export type PostIntegrationUpdateStatusMutationError = unknown

    export const usePostIntegrationUpdateStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationUpdateStatus>>, TError,{params?: PostIntegrationUpdateStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationUpdateStatus>>,
        TError,
        {params?: PostIntegrationUpdateStatusParams},
        TContext
      > => {

      const mutationOptions = getPostIntegrationUpdateStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postIntegrationSignOffIntegration = (
    params?: PostIntegrationSignOffIntegrationParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Integration>(
      {url: `/Integration/SignOffIntegration`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostIntegrationSignOffIntegrationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationSignOffIntegration>>, TError,{params?: PostIntegrationSignOffIntegrationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationSignOffIntegration>>, TError,{params?: PostIntegrationSignOffIntegrationParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationSignOffIntegration>>, {params?: PostIntegrationSignOffIntegrationParams}> = (props) => {
          const {params} = props ?? {};

          return  postIntegrationSignOffIntegration(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationSignOffIntegrationMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationSignOffIntegration>>>
    
    export type PostIntegrationSignOffIntegrationMutationError = unknown

    export const usePostIntegrationSignOffIntegration = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationSignOffIntegration>>, TError,{params?: PostIntegrationSignOffIntegrationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationSignOffIntegration>>,
        TError,
        {params?: PostIntegrationSignOffIntegrationParams},
        TContext
      > => {

      const mutationOptions = getPostIntegrationSignOffIntegrationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getInvoiceGetInvoices = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<InvoiceDetail[]>(
      {url: `/Invoice/GetInvoices`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetInvoiceGetInvoicesQueryKey = () => {
    return [`/Invoice/GetInvoices`] as const;
    }

    
export const getGetInvoiceGetInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceGetInvoices>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceGetInvoices>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceGetInvoicesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceGetInvoices>>> = ({ signal }) => getInvoiceGetInvoices(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceGetInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceGetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceGetInvoices>>>
export type GetInvoiceGetInvoicesQueryError = unknown

export const useGetInvoiceGetInvoices = <TData = Awaited<ReturnType<typeof getInvoiceGetInvoices>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceGetInvoices>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceGetInvoicesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getInvoiceDownloadInvoice = (
    params?: GetInvoiceDownloadInvoiceParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/Invoice/DownloadInvoice`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetInvoiceDownloadInvoiceQueryKey = (params?: GetInvoiceDownloadInvoiceParams,) => {
    return [`/Invoice/DownloadInvoice`, ...(params ? [params]: [])] as const;
    }

    
export const getGetInvoiceDownloadInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceDownloadInvoice>>, TError = unknown>(params?: GetInvoiceDownloadInvoiceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDownloadInvoice>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceDownloadInvoiceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceDownloadInvoice>>> = ({ signal }) => getInvoiceDownloadInvoice(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDownloadInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceDownloadInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceDownloadInvoice>>>
export type GetInvoiceDownloadInvoiceQueryError = unknown

export const useGetInvoiceDownloadInvoice = <TData = Awaited<ReturnType<typeof getInvoiceDownloadInvoice>>, TError = unknown>(
 params?: GetInvoiceDownloadInvoiceParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDownloadInvoice>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetInvoiceDownloadInvoiceQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postInvoiceCreateEstimate = (
    estimateRequest: EstimateRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<InvoiceDetail>(
      {url: `/Invoice/CreateEstimate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: estimateRequest
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostInvoiceCreateEstimateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceCreateEstimate>>, TError,{data: EstimateRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoiceCreateEstimate>>, TError,{data: EstimateRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoiceCreateEstimate>>, {data: EstimateRequest}> = (props) => {
          const {data} = props ?? {};

          return  postInvoiceCreateEstimate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoiceCreateEstimateMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoiceCreateEstimate>>>
    export type PostInvoiceCreateEstimateMutationBody = EstimateRequest
    export type PostInvoiceCreateEstimateMutationError = unknown

    export const usePostInvoiceCreateEstimate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoiceCreateEstimate>>, TError,{data: EstimateRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postInvoiceCreateEstimate>>,
        TError,
        {data: EstimateRequest},
        TContext
      > => {

      const mutationOptions = getPostInvoiceCreateEstimateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMspGetMspByCompanyId = (
    params?: GetMspGetMspByCompanyIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Msp>(
      {url: `/Msp/GetMspByCompanyId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetMspByCompanyIdQueryKey = (params?: GetMspGetMspByCompanyIdParams,) => {
    return [`/Msp/GetMspByCompanyId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspGetMspByCompanyIdQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetMspByCompanyId>>, TError = unknown>(params?: GetMspGetMspByCompanyIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspByCompanyId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetMspByCompanyIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetMspByCompanyId>>> = ({ signal }) => getMspGetMspByCompanyId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspByCompanyId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetMspByCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetMspByCompanyId>>>
export type GetMspGetMspByCompanyIdQueryError = unknown

export const useGetMspGetMspByCompanyId = <TData = Awaited<ReturnType<typeof getMspGetMspByCompanyId>>, TError = unknown>(
 params?: GetMspGetMspByCompanyIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspByCompanyId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetMspByCompanyIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspGetCompaniesForMsp = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company[]>(
      {url: `/Msp/GetCompaniesForMsp`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetCompaniesForMspQueryKey = () => {
    return [`/Msp/GetCompaniesForMsp`] as const;
    }

    
export const getGetMspGetCompaniesForMspQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetCompaniesForMsp>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetCompaniesForMsp>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetCompaniesForMspQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetCompaniesForMsp>>> = ({ signal }) => getMspGetCompaniesForMsp(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetCompaniesForMsp>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetCompaniesForMspQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetCompaniesForMsp>>>
export type GetMspGetCompaniesForMspQueryError = unknown

export const useGetMspGetCompaniesForMsp = <TData = Awaited<ReturnType<typeof getMspGetCompaniesForMsp>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetCompaniesForMsp>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetCompaniesForMspQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspGetMspSubscriptionType = (
    params?: GetMspGetMspSubscriptionTypeParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspSubscriptionType>(
      {url: `/Msp/GetMspSubscriptionType`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetMspSubscriptionTypeQueryKey = (params?: GetMspGetMspSubscriptionTypeParams,) => {
    return [`/Msp/GetMspSubscriptionType`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspGetMspSubscriptionTypeQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetMspSubscriptionType>>, TError = unknown>(params?: GetMspGetMspSubscriptionTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspSubscriptionType>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetMspSubscriptionTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetMspSubscriptionType>>> = ({ signal }) => getMspGetMspSubscriptionType(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspSubscriptionType>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetMspSubscriptionTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetMspSubscriptionType>>>
export type GetMspGetMspSubscriptionTypeQueryError = unknown

export const useGetMspGetMspSubscriptionType = <TData = Awaited<ReturnType<typeof getMspGetMspSubscriptionType>>, TError = unknown>(
 params?: GetMspGetMspSubscriptionTypeParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspSubscriptionType>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetMspSubscriptionTypeQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspGetMspChildCompanySubscription = (
    params?: GetMspGetMspChildCompanySubscriptionParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanySubscriptionType>(
      {url: `/Msp/GetMspChildCompanySubscription`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetMspChildCompanySubscriptionQueryKey = (params?: GetMspGetMspChildCompanySubscriptionParams,) => {
    return [`/Msp/GetMspChildCompanySubscription`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspGetMspChildCompanySubscriptionQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetMspChildCompanySubscription>>, TError = unknown>(params?: GetMspGetMspChildCompanySubscriptionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspChildCompanySubscription>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetMspChildCompanySubscriptionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetMspChildCompanySubscription>>> = ({ signal }) => getMspGetMspChildCompanySubscription(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspChildCompanySubscription>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetMspChildCompanySubscriptionQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetMspChildCompanySubscription>>>
export type GetMspGetMspChildCompanySubscriptionQueryError = unknown

export const useGetMspGetMspChildCompanySubscription = <TData = Awaited<ReturnType<typeof getMspGetMspChildCompanySubscription>>, TError = unknown>(
 params?: GetMspGetMspChildCompanySubscriptionParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspChildCompanySubscription>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetMspChildCompanySubscriptionQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspGetMspCreditPackagesByCompany = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspCreditPackage[]>(
      {url: `/Msp/GetMspCreditPackagesByCompany`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetMspCreditPackagesByCompanyQueryKey = () => {
    return [`/Msp/GetMspCreditPackagesByCompany`] as const;
    }

    
export const getGetMspGetMspCreditPackagesByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetMspCreditPackagesByCompany>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspCreditPackagesByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetMspCreditPackagesByCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetMspCreditPackagesByCompany>>> = ({ signal }) => getMspGetMspCreditPackagesByCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspCreditPackagesByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetMspCreditPackagesByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetMspCreditPackagesByCompany>>>
export type GetMspGetMspCreditPackagesByCompanyQueryError = unknown

export const useGetMspGetMspCreditPackagesByCompany = <TData = Awaited<ReturnType<typeof getMspGetMspCreditPackagesByCompany>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspCreditPackagesByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetMspCreditPackagesByCompanyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspGetMyMsp = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company>(
      {url: `/Msp/GetMyMsp`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetMyMspQueryKey = () => {
    return [`/Msp/GetMyMsp`] as const;
    }

    
export const getGetMspGetMyMspQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetMyMsp>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMyMsp>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetMyMspQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetMyMsp>>> = ({ signal }) => getMspGetMyMsp(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetMyMsp>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetMyMspQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetMyMsp>>>
export type GetMspGetMyMspQueryError = unknown

export const useGetMspGetMyMsp = <TData = Awaited<ReturnType<typeof getMspGetMyMsp>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMyMsp>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetMyMspQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMspSaveMspUserCompanies = (
    postMspSaveMspUserCompaniesBody: number[],
    params?: PostMspSaveMspUserCompaniesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Msp/SaveMspUserCompanies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMspSaveMspUserCompaniesBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostMspSaveMspUserCompaniesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspSaveMspUserCompanies>>, TError,{data: number[];params?: PostMspSaveMspUserCompaniesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMspSaveMspUserCompanies>>, TError,{data: number[];params?: PostMspSaveMspUserCompaniesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMspSaveMspUserCompanies>>, {data: number[];params?: PostMspSaveMspUserCompaniesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postMspSaveMspUserCompanies(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMspSaveMspUserCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postMspSaveMspUserCompanies>>>
    export type PostMspSaveMspUserCompaniesMutationBody = number[]
    export type PostMspSaveMspUserCompaniesMutationError = unknown

    export const usePostMspSaveMspUserCompanies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspSaveMspUserCompanies>>, TError,{data: number[];params?: PostMspSaveMspUserCompaniesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMspSaveMspUserCompanies>>,
        TError,
        {data: number[];params?: PostMspSaveMspUserCompaniesParams},
        TContext
      > => {

      const mutationOptions = getPostMspSaveMspUserCompaniesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMspGetMspUserCompanies = (
    params?: GetMspGetMspUserCompaniesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<number[]>(
      {url: `/Msp/GetMspUserCompanies`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetMspUserCompaniesQueryKey = (params?: GetMspGetMspUserCompaniesParams,) => {
    return [`/Msp/GetMspUserCompanies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspGetMspUserCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetMspUserCompanies>>, TError = unknown>(params?: GetMspGetMspUserCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspUserCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetMspUserCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetMspUserCompanies>>> = ({ signal }) => getMspGetMspUserCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspUserCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetMspUserCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetMspUserCompanies>>>
export type GetMspGetMspUserCompaniesQueryError = unknown

export const useGetMspGetMspUserCompanies = <TData = Awaited<ReturnType<typeof getMspGetMspUserCompanies>>, TError = unknown>(
 params?: GetMspGetMspUserCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspUserCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetMspUserCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspGetMspsForCompany = (
    params?: GetMspGetMspsForCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company[]>(
      {url: `/Msp/GetMspsForCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspGetMspsForCompanyQueryKey = (params?: GetMspGetMspsForCompanyParams,) => {
    return [`/Msp/GetMspsForCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspGetMspsForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getMspGetMspsForCompany>>, TError = unknown>(params?: GetMspGetMspsForCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspsForCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspGetMspsForCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspGetMspsForCompany>>> = ({ signal }) => getMspGetMspsForCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspsForCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspGetMspsForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getMspGetMspsForCompany>>>
export type GetMspGetMspsForCompanyQueryError = unknown

export const useGetMspGetMspsForCompany = <TData = Awaited<ReturnType<typeof getMspGetMspsForCompany>>, TError = unknown>(
 params?: GetMspGetMspsForCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspGetMspsForCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspGetMspsForCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspCompensationGetMspCompensation = (
    params?: GetMspCompensationGetMspCompensationParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspCompensation>(
      {url: `/MspCompensation/GetMspCompensation`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspCompensationGetMspCompensationQueryKey = (params?: GetMspCompensationGetMspCompensationParams,) => {
    return [`/MspCompensation/GetMspCompensation`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspCompensationGetMspCompensationQueryOptions = <TData = Awaited<ReturnType<typeof getMspCompensationGetMspCompensation>>, TError = unknown>(params?: GetMspCompensationGetMspCompensationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationGetMspCompensation>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspCompensationGetMspCompensationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspCompensationGetMspCompensation>>> = ({ signal }) => getMspCompensationGetMspCompensation(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationGetMspCompensation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspCompensationGetMspCompensationQueryResult = NonNullable<Awaited<ReturnType<typeof getMspCompensationGetMspCompensation>>>
export type GetMspCompensationGetMspCompensationQueryError = unknown

export const useGetMspCompensationGetMspCompensation = <TData = Awaited<ReturnType<typeof getMspCompensationGetMspCompensation>>, TError = unknown>(
 params?: GetMspCompensationGetMspCompensationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationGetMspCompensation>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspCompensationGetMspCompensationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMspCompensationSaveMspCompensation = (
    mspCompensation: MspCompensation,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MspCompensation>(
      {url: `/MspCompensation/SaveMspCompensation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mspCompensation
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostMspCompensationSaveMspCompensationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationSaveMspCompensation>>, TError,{data: MspCompensation}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationSaveMspCompensation>>, TError,{data: MspCompensation}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMspCompensationSaveMspCompensation>>, {data: MspCompensation}> = (props) => {
          const {data} = props ?? {};

          return  postMspCompensationSaveMspCompensation(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMspCompensationSaveMspCompensationMutationResult = NonNullable<Awaited<ReturnType<typeof postMspCompensationSaveMspCompensation>>>
    export type PostMspCompensationSaveMspCompensationMutationBody = MspCompensation
    export type PostMspCompensationSaveMspCompensationMutationError = unknown

    export const usePostMspCompensationSaveMspCompensation = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationSaveMspCompensation>>, TError,{data: MspCompensation}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMspCompensationSaveMspCompensation>>,
        TError,
        {data: MspCompensation},
        TContext
      > => {

      const mutationOptions = getPostMspCompensationSaveMspCompensationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMspCompensationCategoryGetMspCompensationCategory = (
    params?: GetMspCompensationCategoryGetMspCompensationCategoryParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspCompensationCategory>(
      {url: `/MspCompensationCategory/GetMspCompensationCategory`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspCompensationCategoryGetMspCompensationCategoryQueryKey = (params?: GetMspCompensationCategoryGetMspCompensationCategoryParams,) => {
    return [`/MspCompensationCategory/GetMspCompensationCategory`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspCompensationCategoryGetMspCompensationCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategory>>, TError = unknown>(params?: GetMspCompensationCategoryGetMspCompensationCategoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategory>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspCompensationCategoryGetMspCompensationCategoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategory>>> = ({ signal }) => getMspCompensationCategoryGetMspCompensationCategory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspCompensationCategoryGetMspCompensationCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategory>>>
export type GetMspCompensationCategoryGetMspCompensationCategoryQueryError = unknown

export const useGetMspCompensationCategoryGetMspCompensationCategory = <TData = Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategory>>, TError = unknown>(
 params?: GetMspCompensationCategoryGetMspCompensationCategoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategory>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspCompensationCategoryGetMspCompensationCategoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspCompensationCategoryGetMspCompensationCategories = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspCompensationCategory[]>(
      {url: `/MspCompensationCategory/GetMspCompensationCategories`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspCompensationCategoryGetMspCompensationCategoriesQueryKey = () => {
    return [`/MspCompensationCategory/GetMspCompensationCategories`] as const;
    }

    
export const getGetMspCompensationCategoryGetMspCompensationCategoriesQueryOptions = <TData = Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategories>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategories>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspCompensationCategoryGetMspCompensationCategoriesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategories>>> = ({ signal }) => getMspCompensationCategoryGetMspCompensationCategories(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategories>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspCompensationCategoryGetMspCompensationCategoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategories>>>
export type GetMspCompensationCategoryGetMspCompensationCategoriesQueryError = unknown

export const useGetMspCompensationCategoryGetMspCompensationCategories = <TData = Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategories>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationCategoryGetMspCompensationCategories>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspCompensationCategoryGetMspCompensationCategoriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMspCompensationCategorySaveMspCompensationCategory = (
    mspCompensationCategory: MspCompensationCategory,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MspCompensationCategory>(
      {url: `/MspCompensationCategory/SaveMspCompensationCategory`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mspCompensationCategory
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostMspCompensationCategorySaveMspCompensationCategoryMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationCategorySaveMspCompensationCategory>>, TError,{data: MspCompensationCategory}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationCategorySaveMspCompensationCategory>>, TError,{data: MspCompensationCategory}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMspCompensationCategorySaveMspCompensationCategory>>, {data: MspCompensationCategory}> = (props) => {
          const {data} = props ?? {};

          return  postMspCompensationCategorySaveMspCompensationCategory(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMspCompensationCategorySaveMspCompensationCategoryMutationResult = NonNullable<Awaited<ReturnType<typeof postMspCompensationCategorySaveMspCompensationCategory>>>
    export type PostMspCompensationCategorySaveMspCompensationCategoryMutationBody = MspCompensationCategory
    export type PostMspCompensationCategorySaveMspCompensationCategoryMutationError = unknown

    export const usePostMspCompensationCategorySaveMspCompensationCategory = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationCategorySaveMspCompensationCategory>>, TError,{data: MspCompensationCategory}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMspCompensationCategorySaveMspCompensationCategory>>,
        TError,
        {data: MspCompensationCategory},
        TContext
      > => {

      const mutationOptions = getPostMspCompensationCategorySaveMspCompensationCategoryMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMspCompensationLineItemGetMspCompensationLineItem = (
    params?: GetMspCompensationLineItemGetMspCompensationLineItemParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspCompensationLineItem>(
      {url: `/MspCompensationLineItem/GetMspCompensationLineItem`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspCompensationLineItemGetMspCompensationLineItemQueryKey = (params?: GetMspCompensationLineItemGetMspCompensationLineItemParams,) => {
    return [`/MspCompensationLineItem/GetMspCompensationLineItem`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspCompensationLineItemGetMspCompensationLineItemQueryOptions = <TData = Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItem>>, TError = unknown>(params?: GetMspCompensationLineItemGetMspCompensationLineItemParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItem>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspCompensationLineItemGetMspCompensationLineItemQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItem>>> = ({ signal }) => getMspCompensationLineItemGetMspCompensationLineItem(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItem>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspCompensationLineItemGetMspCompensationLineItemQueryResult = NonNullable<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItem>>>
export type GetMspCompensationLineItemGetMspCompensationLineItemQueryError = unknown

export const useGetMspCompensationLineItemGetMspCompensationLineItem = <TData = Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItem>>, TError = unknown>(
 params?: GetMspCompensationLineItemGetMspCompensationLineItemParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItem>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspCompensationLineItemGetMspCompensationLineItemQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspCompensationLineItemGetMspCompensationLineItemsByCategory = (
    params?: GetMspCompensationLineItemGetMspCompensationLineItemsByCategoryParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspCompensationLineItem[]>(
      {url: `/MspCompensationLineItem/GetMspCompensationLineItemsByCategory`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspCompensationLineItemGetMspCompensationLineItemsByCategoryQueryKey = (params?: GetMspCompensationLineItemGetMspCompensationLineItemsByCategoryParams,) => {
    return [`/MspCompensationLineItem/GetMspCompensationLineItemsByCategory`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspCompensationLineItemGetMspCompensationLineItemsByCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItemsByCategory>>, TError = unknown>(params?: GetMspCompensationLineItemGetMspCompensationLineItemsByCategoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItemsByCategory>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspCompensationLineItemGetMspCompensationLineItemsByCategoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItemsByCategory>>> = ({ signal }) => getMspCompensationLineItemGetMspCompensationLineItemsByCategory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItemsByCategory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspCompensationLineItemGetMspCompensationLineItemsByCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItemsByCategory>>>
export type GetMspCompensationLineItemGetMspCompensationLineItemsByCategoryQueryError = unknown

export const useGetMspCompensationLineItemGetMspCompensationLineItemsByCategory = <TData = Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItemsByCategory>>, TError = unknown>(
 params?: GetMspCompensationLineItemGetMspCompensationLineItemsByCategoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspCompensationLineItemGetMspCompensationLineItemsByCategory>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspCompensationLineItemGetMspCompensationLineItemsByCategoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMspCompensationLineItemSaveMspCompensationLineItem = (
    mspCompensationLineItem: MspCompensationLineItem,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MspCompensationLineItem>(
      {url: `/MspCompensationLineItem/SaveMspCompensationLineItem`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mspCompensationLineItem
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostMspCompensationLineItemSaveMspCompensationLineItemMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationLineItemSaveMspCompensationLineItem>>, TError,{data: MspCompensationLineItem}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationLineItemSaveMspCompensationLineItem>>, TError,{data: MspCompensationLineItem}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMspCompensationLineItemSaveMspCompensationLineItem>>, {data: MspCompensationLineItem}> = (props) => {
          const {data} = props ?? {};

          return  postMspCompensationLineItemSaveMspCompensationLineItem(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMspCompensationLineItemSaveMspCompensationLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof postMspCompensationLineItemSaveMspCompensationLineItem>>>
    export type PostMspCompensationLineItemSaveMspCompensationLineItemMutationBody = MspCompensationLineItem
    export type PostMspCompensationLineItemSaveMspCompensationLineItemMutationError = unknown

    export const usePostMspCompensationLineItemSaveMspCompensationLineItem = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspCompensationLineItemSaveMspCompensationLineItem>>, TError,{data: MspCompensationLineItem}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMspCompensationLineItemSaveMspCompensationLineItem>>,
        TError,
        {data: MspCompensationLineItem},
        TContext
      > => {

      const mutationOptions = getPostMspCompensationLineItemSaveMspCompensationLineItemMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMspConfigGetMspConfigById = (
    params?: GetMspConfigGetMspConfigByIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspConfig>(
      {url: `/MspConfig/GetMspConfigById`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspConfigGetMspConfigByIdQueryKey = (params?: GetMspConfigGetMspConfigByIdParams,) => {
    return [`/MspConfig/GetMspConfigById`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspConfigGetMspConfigByIdQueryOptions = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigById>>, TError = unknown>(params?: GetMspConfigGetMspConfigByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigById>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspConfigGetMspConfigByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspConfigGetMspConfigById>>> = ({ signal }) => getMspConfigGetMspConfigById(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspConfigGetMspConfigByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMspConfigGetMspConfigById>>>
export type GetMspConfigGetMspConfigByIdQueryError = unknown

export const useGetMspConfigGetMspConfigById = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigById>>, TError = unknown>(
 params?: GetMspConfigGetMspConfigByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigById>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspConfigGetMspConfigByIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspConfigGetMspConfigByCompany = (
    params?: GetMspConfigGetMspConfigByCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspConfig>(
      {url: `/MspConfig/GetMspConfigByCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspConfigGetMspConfigByCompanyQueryKey = (params?: GetMspConfigGetMspConfigByCompanyParams,) => {
    return [`/MspConfig/GetMspConfigByCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspConfigGetMspConfigByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigByCompany>>, TError = unknown>(params?: GetMspConfigGetMspConfigByCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspConfigGetMspConfigByCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspConfigGetMspConfigByCompany>>> = ({ signal }) => getMspConfigGetMspConfigByCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspConfigGetMspConfigByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getMspConfigGetMspConfigByCompany>>>
export type GetMspConfigGetMspConfigByCompanyQueryError = unknown

export const useGetMspConfigGetMspConfigByCompany = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigByCompany>>, TError = unknown>(
 params?: GetMspConfigGetMspConfigByCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspConfigGetMspConfigByCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspConfigGetMspConfigByHost = (
    params?: GetMspConfigGetMspConfigByHostParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspConfig>(
      {url: `/MspConfig/GetMspConfigByHost`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspConfigGetMspConfigByHostQueryKey = (params?: GetMspConfigGetMspConfigByHostParams,) => {
    return [`/MspConfig/GetMspConfigByHost`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspConfigGetMspConfigByHostQueryOptions = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigByHost>>, TError = unknown>(params?: GetMspConfigGetMspConfigByHostParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByHost>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspConfigGetMspConfigByHostQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspConfigGetMspConfigByHost>>> = ({ signal }) => getMspConfigGetMspConfigByHost(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByHost>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspConfigGetMspConfigByHostQueryResult = NonNullable<Awaited<ReturnType<typeof getMspConfigGetMspConfigByHost>>>
export type GetMspConfigGetMspConfigByHostQueryError = unknown

export const useGetMspConfigGetMspConfigByHost = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigByHost>>, TError = unknown>(
 params?: GetMspConfigGetMspConfigByHostParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByHost>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspConfigGetMspConfigByHostQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getMspConfigGetMspConfigForCompany = (
    params?: GetMspConfigGetMspConfigForCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspConfig>(
      {url: `/MspConfig/GetMspConfigForCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspConfigGetMspConfigForCompanyQueryKey = (params?: GetMspConfigGetMspConfigForCompanyParams,) => {
    return [`/MspConfig/GetMspConfigForCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspConfigGetMspConfigForCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigForCompany>>, TError = unknown>(params?: GetMspConfigGetMspConfigForCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigForCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspConfigGetMspConfigForCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspConfigGetMspConfigForCompany>>> = ({ signal }) => getMspConfigGetMspConfigForCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigForCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspConfigGetMspConfigForCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getMspConfigGetMspConfigForCompany>>>
export type GetMspConfigGetMspConfigForCompanyQueryError = unknown

export const useGetMspConfigGetMspConfigForCompany = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigForCompany>>, TError = unknown>(
 params?: GetMspConfigGetMspConfigForCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigForCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspConfigGetMspConfigForCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postMspConfigSaveMspConfig = (
    mspConfig: MspConfig,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<MspConfig>(
      {url: `/MspConfig/SaveMspConfig`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mspConfig
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostMspConfigSaveMspConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspConfigSaveMspConfig>>, TError,{data: MspConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postMspConfigSaveMspConfig>>, TError,{data: MspConfig}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMspConfigSaveMspConfig>>, {data: MspConfig}> = (props) => {
          const {data} = props ?? {};

          return  postMspConfigSaveMspConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMspConfigSaveMspConfigMutationResult = NonNullable<Awaited<ReturnType<typeof postMspConfigSaveMspConfig>>>
    export type PostMspConfigSaveMspConfigMutationBody = MspConfig
    export type PostMspConfigSaveMspConfigMutationError = unknown

    export const usePostMspConfigSaveMspConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMspConfigSaveMspConfig>>, TError,{data: MspConfig}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postMspConfigSaveMspConfig>>,
        TError,
        {data: MspConfig},
        TContext
      > => {

      const mutationOptions = getPostMspConfigSaveMspConfigMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getMspConfigGetMspConfigByMspCompanyId = (
    params?: GetMspConfigGetMspConfigByMspCompanyIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<MspConfig>(
      {url: `/MspConfig/GetMspConfigByMspCompanyId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetMspConfigGetMspConfigByMspCompanyIdQueryKey = (params?: GetMspConfigGetMspConfigByMspCompanyIdParams,) => {
    return [`/MspConfig/GetMspConfigByMspCompanyId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetMspConfigGetMspConfigByMspCompanyIdQueryOptions = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigByMspCompanyId>>, TError = unknown>(params?: GetMspConfigGetMspConfigByMspCompanyIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByMspCompanyId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMspConfigGetMspConfigByMspCompanyIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMspConfigGetMspConfigByMspCompanyId>>> = ({ signal }) => getMspConfigGetMspConfigByMspCompanyId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByMspCompanyId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMspConfigGetMspConfigByMspCompanyIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMspConfigGetMspConfigByMspCompanyId>>>
export type GetMspConfigGetMspConfigByMspCompanyIdQueryError = unknown

export const useGetMspConfigGetMspConfigByMspCompanyId = <TData = Awaited<ReturnType<typeof getMspConfigGetMspConfigByMspCompanyId>>, TError = unknown>(
 params?: GetMspConfigGetMspConfigByMspCompanyIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMspConfigGetMspConfigByMspCompanyId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetMspConfigGetMspConfigByMspCompanyIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNewSubscriptionUpdateCompanyInfo = (
    companyInfo: CompanyInfo,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/NewSubscription/UpdateCompanyInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyInfo
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostNewSubscriptionUpdateCompanyInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateCompanyInfo>>, TError,{data: CompanyInfo}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateCompanyInfo>>, TError,{data: CompanyInfo}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNewSubscriptionUpdateCompanyInfo>>, {data: CompanyInfo}> = (props) => {
          const {data} = props ?? {};

          return  postNewSubscriptionUpdateCompanyInfo(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNewSubscriptionUpdateCompanyInfoMutationResult = NonNullable<Awaited<ReturnType<typeof postNewSubscriptionUpdateCompanyInfo>>>
    export type PostNewSubscriptionUpdateCompanyInfoMutationBody = CompanyInfo
    export type PostNewSubscriptionUpdateCompanyInfoMutationError = unknown

    export const usePostNewSubscriptionUpdateCompanyInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateCompanyInfo>>, TError,{data: CompanyInfo}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNewSubscriptionUpdateCompanyInfo>>,
        TError,
        {data: CompanyInfo},
        TContext
      > => {

      const mutationOptions = getPostNewSubscriptionUpdateCompanyInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNewSubscriptionUpdateCustomerCompanyInfo = (
    companyInfo: CompanyInfo,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/NewSubscription/UpdateCustomerCompanyInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyInfo
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostNewSubscriptionUpdateCustomerCompanyInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateCustomerCompanyInfo>>, TError,{data: CompanyInfo}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateCustomerCompanyInfo>>, TError,{data: CompanyInfo}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNewSubscriptionUpdateCustomerCompanyInfo>>, {data: CompanyInfo}> = (props) => {
          const {data} = props ?? {};

          return  postNewSubscriptionUpdateCustomerCompanyInfo(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNewSubscriptionUpdateCustomerCompanyInfoMutationResult = NonNullable<Awaited<ReturnType<typeof postNewSubscriptionUpdateCustomerCompanyInfo>>>
    export type PostNewSubscriptionUpdateCustomerCompanyInfoMutationBody = CompanyInfo
    export type PostNewSubscriptionUpdateCustomerCompanyInfoMutationError = unknown

    export const usePostNewSubscriptionUpdateCustomerCompanyInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateCustomerCompanyInfo>>, TError,{data: CompanyInfo}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNewSubscriptionUpdateCustomerCompanyInfo>>,
        TError,
        {data: CompanyInfo},
        TContext
      > => {

      const mutationOptions = getPostNewSubscriptionUpdateCustomerCompanyInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getNewSubscriptionGetCompanyInfo = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyInfo>(
      {url: `/NewSubscription/GetCompanyInfo`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetNewSubscriptionGetCompanyInfoQueryKey = () => {
    return [`/NewSubscription/GetCompanyInfo`] as const;
    }

    
export const getGetNewSubscriptionGetCompanyInfoQueryOptions = <TData = Awaited<ReturnType<typeof getNewSubscriptionGetCompanyInfo>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNewSubscriptionGetCompanyInfo>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNewSubscriptionGetCompanyInfoQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNewSubscriptionGetCompanyInfo>>> = ({ signal }) => getNewSubscriptionGetCompanyInfo(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNewSubscriptionGetCompanyInfo>>, TError, TData> & { queryKey: QueryKey }
}

export type GetNewSubscriptionGetCompanyInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getNewSubscriptionGetCompanyInfo>>>
export type GetNewSubscriptionGetCompanyInfoQueryError = unknown

export const useGetNewSubscriptionGetCompanyInfo = <TData = Awaited<ReturnType<typeof getNewSubscriptionGetCompanyInfo>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getNewSubscriptionGetCompanyInfo>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetNewSubscriptionGetCompanyInfoQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postNewSubscriptionUpdateMspCompanyInfo = (
    companyInfo: CompanyInfo,
    params?: PostNewSubscriptionUpdateMspCompanyInfoParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/NewSubscription/UpdateMspCompanyInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyInfo,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostNewSubscriptionUpdateMspCompanyInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCompanyInfo>>, TError,{data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCompanyInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCompanyInfo>>, TError,{data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCompanyInfoParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCompanyInfo>>, {data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCompanyInfoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postNewSubscriptionUpdateMspCompanyInfo(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNewSubscriptionUpdateMspCompanyInfoMutationResult = NonNullable<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCompanyInfo>>>
    export type PostNewSubscriptionUpdateMspCompanyInfoMutationBody = CompanyInfo
    export type PostNewSubscriptionUpdateMspCompanyInfoMutationError = unknown

    export const usePostNewSubscriptionUpdateMspCompanyInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCompanyInfo>>, TError,{data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCompanyInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCompanyInfo>>,
        TError,
        {data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCompanyInfoParams},
        TContext
      > => {

      const mutationOptions = getPostNewSubscriptionUpdateMspCompanyInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postNewSubscriptionUpdateMspCustomerCompanyInfo = (
    companyInfo: CompanyInfo,
    params?: PostNewSubscriptionUpdateMspCustomerCompanyInfoParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/NewSubscription/UpdateMspCustomerCompanyInfo`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyInfo,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostNewSubscriptionUpdateMspCustomerCompanyInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCustomerCompanyInfo>>, TError,{data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCustomerCompanyInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCustomerCompanyInfo>>, TError,{data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCustomerCompanyInfoParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCustomerCompanyInfo>>, {data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCustomerCompanyInfoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postNewSubscriptionUpdateMspCustomerCompanyInfo(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNewSubscriptionUpdateMspCustomerCompanyInfoMutationResult = NonNullable<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCustomerCompanyInfo>>>
    export type PostNewSubscriptionUpdateMspCustomerCompanyInfoMutationBody = CompanyInfo
    export type PostNewSubscriptionUpdateMspCustomerCompanyInfoMutationError = unknown

    export const usePostNewSubscriptionUpdateMspCustomerCompanyInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCustomerCompanyInfo>>, TError,{data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCustomerCompanyInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postNewSubscriptionUpdateMspCustomerCompanyInfo>>,
        TError,
        {data: CompanyInfo;params?: PostNewSubscriptionUpdateMspCustomerCompanyInfoParams},
        TContext
      > => {

      const mutationOptions = getPostNewSubscriptionUpdateMspCustomerCompanyInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getOrganizationGetOrganizations = (
    params?: GetOrganizationGetOrganizationsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Organization[]>(
      {url: `/Organization/GetOrganizations`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetOrganizationGetOrganizationsQueryKey = (params?: GetOrganizationGetOrganizationsParams,) => {
    return [`/Organization/GetOrganizations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOrganizationGetOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationGetOrganizations>>, TError = unknown>(params?: GetOrganizationGetOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationGetOrganizationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationGetOrganizations>>> = ({ signal }) => getOrganizationGetOrganizations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationGetOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationGetOrganizations>>>
export type GetOrganizationGetOrganizationsQueryError = unknown

export const useGetOrganizationGetOrganizations = <TData = Awaited<ReturnType<typeof getOrganizationGetOrganizations>>, TError = unknown>(
 params?: GetOrganizationGetOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationGetOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationGetChildOrganizations = (
    params?: GetOrganizationGetChildOrganizationsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Organization[]>(
      {url: `/Organization/GetChildOrganizations`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetOrganizationGetChildOrganizationsQueryKey = (params?: GetOrganizationGetChildOrganizationsParams,) => {
    return [`/Organization/GetChildOrganizations`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOrganizationGetChildOrganizationsQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationGetChildOrganizations>>, TError = unknown>(params?: GetOrganizationGetChildOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetChildOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationGetChildOrganizationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationGetChildOrganizations>>> = ({ signal }) => getOrganizationGetChildOrganizations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetChildOrganizations>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationGetChildOrganizationsQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationGetChildOrganizations>>>
export type GetOrganizationGetChildOrganizationsQueryError = unknown

export const useGetOrganizationGetChildOrganizations = <TData = Awaited<ReturnType<typeof getOrganizationGetChildOrganizations>>, TError = unknown>(
 params?: GetOrganizationGetChildOrganizationsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetChildOrganizations>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationGetChildOrganizationsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationGetOrganization = (
    params?: GetOrganizationGetOrganizationParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Organization>(
      {url: `/Organization/GetOrganization`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetOrganizationGetOrganizationQueryKey = (params?: GetOrganizationGetOrganizationParams,) => {
    return [`/Organization/GetOrganization`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOrganizationGetOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationGetOrganization>>, TError = unknown>(params?: GetOrganizationGetOrganizationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganization>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationGetOrganizationQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationGetOrganization>>> = ({ signal }) => getOrganizationGetOrganization(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganization>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationGetOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationGetOrganization>>>
export type GetOrganizationGetOrganizationQueryError = unknown

export const useGetOrganizationGetOrganization = <TData = Awaited<ReturnType<typeof getOrganizationGetOrganization>>, TError = unknown>(
 params?: GetOrganizationGetOrganizationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganization>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationGetOrganizationQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getOrganizationGetOrganizationByAWSId = (
    params?: GetOrganizationGetOrganizationByAWSIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Organization>(
      {url: `/Organization/GetOrganizationByAWSId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetOrganizationGetOrganizationByAWSIdQueryKey = (params?: GetOrganizationGetOrganizationByAWSIdParams,) => {
    return [`/Organization/GetOrganizationByAWSId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetOrganizationGetOrganizationByAWSIdQueryOptions = <TData = Awaited<ReturnType<typeof getOrganizationGetOrganizationByAWSId>>, TError = unknown>(params?: GetOrganizationGetOrganizationByAWSIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganizationByAWSId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganizationGetOrganizationByAWSIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganizationGetOrganizationByAWSId>>> = ({ signal }) => getOrganizationGetOrganizationByAWSId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganizationByAWSId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrganizationGetOrganizationByAWSIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOrganizationGetOrganizationByAWSId>>>
export type GetOrganizationGetOrganizationByAWSIdQueryError = unknown

export const useGetOrganizationGetOrganizationByAWSId = <TData = Awaited<ReturnType<typeof getOrganizationGetOrganizationByAWSId>>, TError = unknown>(
 params?: GetOrganizationGetOrganizationByAWSIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrganizationGetOrganizationByAWSId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrganizationGetOrganizationByAWSIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postOrganizationUpdateOrganization = (
    params?: PostOrganizationUpdateOrganizationParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Organization/UpdateOrganization`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostOrganizationUpdateOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrganizationUpdateOrganization>>, TError,{params?: PostOrganizationUpdateOrganizationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postOrganizationUpdateOrganization>>, TError,{params?: PostOrganizationUpdateOrganizationParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postOrganizationUpdateOrganization>>, {params?: PostOrganizationUpdateOrganizationParams}> = (props) => {
          const {params} = props ?? {};

          return  postOrganizationUpdateOrganization(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostOrganizationUpdateOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof postOrganizationUpdateOrganization>>>
    
    export type PostOrganizationUpdateOrganizationMutationError = unknown

    export const usePostOrganizationUpdateOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postOrganizationUpdateOrganization>>, TError,{params?: PostOrganizationUpdateOrganizationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postOrganizationUpdateOrganization>>,
        TError,
        {params?: PostOrganizationUpdateOrganizationParams},
        TContext
      > => {

      const mutationOptions = getPostOrganizationUpdateOrganizationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteOrganizationDeleteOrganization = (
    params?: DeleteOrganizationDeleteOrganizationParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Organization/DeleteOrganization`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteOrganizationDeleteOrganizationMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationDeleteOrganization>>, TError,{params?: DeleteOrganizationDeleteOrganizationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationDeleteOrganization>>, TError,{params?: DeleteOrganizationDeleteOrganizationParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteOrganizationDeleteOrganization>>, {params?: DeleteOrganizationDeleteOrganizationParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteOrganizationDeleteOrganization(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganizationDeleteOrganizationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteOrganizationDeleteOrganization>>>
    
    export type DeleteOrganizationDeleteOrganizationMutationError = unknown

    export const useDeleteOrganizationDeleteOrganization = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteOrganizationDeleteOrganization>>, TError,{params?: DeleteOrganizationDeleteOrganizationParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteOrganizationDeleteOrganization>>,
        TError,
        {params?: DeleteOrganizationDeleteOrganizationParams},
        TContext
      > => {

      const mutationOptions = getDeleteOrganizationDeleteOrganizationMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getPaymentGetPaymentSources = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<PaymentSource[]>(
      {url: `/Payment/GetPaymentSources`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetPaymentGetPaymentSourcesQueryKey = () => {
    return [`/Payment/GetPaymentSources`] as const;
    }

    
export const getGetPaymentGetPaymentSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentGetPaymentSources>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPaymentSources>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentGetPaymentSourcesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentGetPaymentSources>>> = ({ signal }) => getPaymentGetPaymentSources(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPaymentSources>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentGetPaymentSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentGetPaymentSources>>>
export type GetPaymentGetPaymentSourcesQueryError = unknown

export const useGetPaymentGetPaymentSources = <TData = Awaited<ReturnType<typeof getPaymentGetPaymentSources>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPaymentSources>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPaymentGetPaymentSourcesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPaymentGetPrimaryPayment = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<PaymentSource>(
      {url: `/Payment/GetPrimaryPayment`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetPaymentGetPrimaryPaymentQueryKey = () => {
    return [`/Payment/GetPrimaryPayment`] as const;
    }

    
export const getGetPaymentGetPrimaryPaymentQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentGetPrimaryPayment>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPrimaryPayment>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentGetPrimaryPaymentQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentGetPrimaryPayment>>> = ({ signal }) => getPaymentGetPrimaryPayment(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPrimaryPayment>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentGetPrimaryPaymentQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentGetPrimaryPayment>>>
export type GetPaymentGetPrimaryPaymentQueryError = unknown

export const useGetPaymentGetPrimaryPayment = <TData = Awaited<ReturnType<typeof getPaymentGetPrimaryPayment>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPrimaryPayment>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPaymentGetPrimaryPaymentQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postPaymentAddPaymentSource = (
    card: Card,
    params?: PostPaymentAddPaymentSourceParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/Payment/AddPaymentSource`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: card,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostPaymentAddPaymentSourceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentAddPaymentSource>>, TError,{data: Card;params?: PostPaymentAddPaymentSourceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postPaymentAddPaymentSource>>, TError,{data: Card;params?: PostPaymentAddPaymentSourceParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPaymentAddPaymentSource>>, {data: Card;params?: PostPaymentAddPaymentSourceParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postPaymentAddPaymentSource(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPaymentAddPaymentSourceMutationResult = NonNullable<Awaited<ReturnType<typeof postPaymentAddPaymentSource>>>
    export type PostPaymentAddPaymentSourceMutationBody = Card
    export type PostPaymentAddPaymentSourceMutationError = unknown

    export const usePostPaymentAddPaymentSource = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentAddPaymentSource>>, TError,{data: Card;params?: PostPaymentAddPaymentSourceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postPaymentAddPaymentSource>>,
        TError,
        {data: Card;params?: PostPaymentAddPaymentSourceParams},
        TContext
      > => {

      const mutationOptions = getPostPaymentAddPaymentSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postPaymentDeletePaymentSource = (
    params?: PostPaymentDeletePaymentSourceParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<boolean>(
      {url: `/Payment/DeletePaymentSource`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostPaymentDeletePaymentSourceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentDeletePaymentSource>>, TError,{params?: PostPaymentDeletePaymentSourceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postPaymentDeletePaymentSource>>, TError,{params?: PostPaymentDeletePaymentSourceParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPaymentDeletePaymentSource>>, {params?: PostPaymentDeletePaymentSourceParams}> = (props) => {
          const {params} = props ?? {};

          return  postPaymentDeletePaymentSource(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPaymentDeletePaymentSourceMutationResult = NonNullable<Awaited<ReturnType<typeof postPaymentDeletePaymentSource>>>
    
    export type PostPaymentDeletePaymentSourceMutationError = unknown

    export const usePostPaymentDeletePaymentSource = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentDeletePaymentSource>>, TError,{params?: PostPaymentDeletePaymentSourceParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postPaymentDeletePaymentSource>>,
        TError,
        {params?: PostPaymentDeletePaymentSourceParams},
        TContext
      > => {

      const mutationOptions = getPostPaymentDeletePaymentSourceMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getPaymentGetAwsPublicOfferUrl = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsMarketplaceOffer>(
      {url: `/Payment/GetAwsPublicOfferUrl`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetPaymentGetAwsPublicOfferUrlQueryKey = () => {
    return [`/Payment/GetAwsPublicOfferUrl`] as const;
    }

    
export const getGetPaymentGetAwsPublicOfferUrlQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentGetAwsPublicOfferUrl>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetAwsPublicOfferUrl>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentGetAwsPublicOfferUrlQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentGetAwsPublicOfferUrl>>> = ({ signal }) => getPaymentGetAwsPublicOfferUrl(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetAwsPublicOfferUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentGetAwsPublicOfferUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentGetAwsPublicOfferUrl>>>
export type GetPaymentGetAwsPublicOfferUrlQueryError = unknown

export const useGetPaymentGetAwsPublicOfferUrl = <TData = Awaited<ReturnType<typeof getPaymentGetAwsPublicOfferUrl>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetAwsPublicOfferUrl>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPaymentGetAwsPublicOfferUrlQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getPaymentGetAzurePublicOfferUrl = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AzureMarketplaceOffer>(
      {url: `/Payment/GetAzurePublicOfferUrl`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetPaymentGetAzurePublicOfferUrlQueryKey = () => {
    return [`/Payment/GetAzurePublicOfferUrl`] as const;
    }

    
export const getGetPaymentGetAzurePublicOfferUrlQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentGetAzurePublicOfferUrl>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetAzurePublicOfferUrl>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentGetAzurePublicOfferUrlQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentGetAzurePublicOfferUrl>>> = ({ signal }) => getPaymentGetAzurePublicOfferUrl(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetAzurePublicOfferUrl>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentGetAzurePublicOfferUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentGetAzurePublicOfferUrl>>>
export type GetPaymentGetAzurePublicOfferUrlQueryError = unknown

export const useGetPaymentGetAzurePublicOfferUrl = <TData = Awaited<ReturnType<typeof getPaymentGetAzurePublicOfferUrl>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetAzurePublicOfferUrl>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPaymentGetAzurePublicOfferUrlQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const putPaymentCreatePendingPaymentMethod = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PendingPaymentMethodSecret>(
      {url: `/Payment/CreatePendingPaymentMethod`, method: 'PUT'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutPaymentCreatePendingPaymentMethodMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPaymentCreatePendingPaymentMethod>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putPaymentCreatePendingPaymentMethod>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPaymentCreatePendingPaymentMethod>>, void> = () => {
          

          return  putPaymentCreatePendingPaymentMethod(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPaymentCreatePendingPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof putPaymentCreatePendingPaymentMethod>>>
    
    export type PutPaymentCreatePendingPaymentMethodMutationError = unknown

    export const usePutPaymentCreatePendingPaymentMethod = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPaymentCreatePendingPaymentMethod>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putPaymentCreatePendingPaymentMethod>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPutPaymentCreatePendingPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getPaymentGetPendingPaymentMethod = (
    params?: GetPaymentGetPendingPaymentMethodParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<PendingPaymentMethodSecret>(
      {url: `/Payment/GetPendingPaymentMethod`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetPaymentGetPendingPaymentMethodQueryKey = (params?: GetPaymentGetPendingPaymentMethodParams,) => {
    return [`/Payment/GetPendingPaymentMethod`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPaymentGetPendingPaymentMethodQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentGetPendingPaymentMethod>>, TError = unknown>(params?: GetPaymentGetPendingPaymentMethodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPendingPaymentMethod>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentGetPendingPaymentMethodQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentGetPendingPaymentMethod>>> = ({ signal }) => getPaymentGetPendingPaymentMethod(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPendingPaymentMethod>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPaymentGetPendingPaymentMethodQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentGetPendingPaymentMethod>>>
export type GetPaymentGetPendingPaymentMethodQueryError = unknown

export const useGetPaymentGetPendingPaymentMethod = <TData = Awaited<ReturnType<typeof getPaymentGetPendingPaymentMethod>>, TError = unknown>(
 params?: GetPaymentGetPendingPaymentMethodParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPaymentGetPendingPaymentMethod>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPaymentGetPendingPaymentMethodQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postPaymentUsePendingPaymentMethod = (
    params?: PostPaymentUsePendingPaymentMethodParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<PendingPaymentMethodSecret>(
      {url: `/Payment/UsePendingPaymentMethod`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostPaymentUsePendingPaymentMethodMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentUsePendingPaymentMethod>>, TError,{params?: PostPaymentUsePendingPaymentMethodParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postPaymentUsePendingPaymentMethod>>, TError,{params?: PostPaymentUsePendingPaymentMethodParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPaymentUsePendingPaymentMethod>>, {params?: PostPaymentUsePendingPaymentMethodParams}> = (props) => {
          const {params} = props ?? {};

          return  postPaymentUsePendingPaymentMethod(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPaymentUsePendingPaymentMethodMutationResult = NonNullable<Awaited<ReturnType<typeof postPaymentUsePendingPaymentMethod>>>
    
    export type PostPaymentUsePendingPaymentMethodMutationError = unknown

    export const usePostPaymentUsePendingPaymentMethod = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPaymentUsePendingPaymentMethod>>, TError,{params?: PostPaymentUsePendingPaymentMethodParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postPaymentUsePendingPaymentMethod>>,
        TError,
        {params?: PostPaymentUsePendingPaymentMethodParams},
        TContext
      > => {

      const mutationOptions = getPostPaymentUsePendingPaymentMethodMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRbacSaveUserRoles = (
    bulkUserRoleChange: BulkUserRoleChange,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Rbac/SaveUserRoles`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkUserRoleChange
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacSaveUserRolesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveUserRoles>>, TError,{data: BulkUserRoleChange}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveUserRoles>>, TError,{data: BulkUserRoleChange}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacSaveUserRoles>>, {data: BulkUserRoleChange}> = (props) => {
          const {data} = props ?? {};

          return  postRbacSaveUserRoles(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacSaveUserRolesMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacSaveUserRoles>>>
    export type PostRbacSaveUserRolesMutationBody = BulkUserRoleChange
    export type PostRbacSaveUserRolesMutationError = unknown

    export const usePostRbacSaveUserRoles = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveUserRoles>>, TError,{data: BulkUserRoleChange}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacSaveUserRoles>>,
        TError,
        {data: BulkUserRoleChange},
        TContext
      > => {

      const mutationOptions = getPostRbacSaveUserRolesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRbacSaveRolePermissions = (
    rolePermission: RolePermission[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Rbac/SaveRolePermissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rolePermission
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacSaveRolePermissionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveRolePermissions>>, TError,{data: RolePermission[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveRolePermissions>>, TError,{data: RolePermission[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacSaveRolePermissions>>, {data: RolePermission[]}> = (props) => {
          const {data} = props ?? {};

          return  postRbacSaveRolePermissions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacSaveRolePermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacSaveRolePermissions>>>
    export type PostRbacSaveRolePermissionsMutationBody = RolePermission[]
    export type PostRbacSaveRolePermissionsMutationError = unknown

    export const usePostRbacSaveRolePermissions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveRolePermissions>>, TError,{data: RolePermission[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacSaveRolePermissions>>,
        TError,
        {data: RolePermission[]},
        TContext
      > => {

      const mutationOptions = getPostRbacSaveRolePermissionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRbacSaveRole = (
    role: Role,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Role>(
      {url: `/Rbac/SaveRole`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: role
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacSaveRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveRole>>, TError,{data: Role}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveRole>>, TError,{data: Role}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacSaveRole>>, {data: Role}> = (props) => {
          const {data} = props ?? {};

          return  postRbacSaveRole(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacSaveRoleMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacSaveRole>>>
    export type PostRbacSaveRoleMutationBody = Role
    export type PostRbacSaveRoleMutationError = unknown

    export const usePostRbacSaveRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacSaveRole>>, TError,{data: Role}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacSaveRole>>,
        TError,
        {data: Role},
        TContext
      > => {

      const mutationOptions = getPostRbacSaveRoleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteRbacDeleteRole = (
    params?: DeleteRbacDeleteRoleParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Rbac/DeleteRole`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteRbacDeleteRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRbacDeleteRole>>, TError,{params?: DeleteRbacDeleteRoleParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRbacDeleteRole>>, TError,{params?: DeleteRbacDeleteRoleParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRbacDeleteRole>>, {params?: DeleteRbacDeleteRoleParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteRbacDeleteRole(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteRbacDeleteRoleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRbacDeleteRole>>>
    
    export type DeleteRbacDeleteRoleMutationError = unknown

    export const useDeleteRbacDeleteRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRbacDeleteRole>>, TError,{params?: DeleteRbacDeleteRoleParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteRbacDeleteRole>>,
        TError,
        {params?: DeleteRbacDeleteRoleParams},
        TContext
      > => {

      const mutationOptions = getDeleteRbacDeleteRoleMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getRbacGetUserRolesByUserId = (
    params?: GetRbacGetUserRolesByUserIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyUserRole[]>(
      {url: `/Rbac/GetUserRolesByUserId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetUserRolesByUserIdQueryKey = (params?: GetRbacGetUserRolesByUserIdParams,) => {
    return [`/Rbac/GetUserRolesByUserId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRbacGetUserRolesByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetUserRolesByUserId>>, TError = unknown>(params?: GetRbacGetUserRolesByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetUserRolesByUserId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetUserRolesByUserIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetUserRolesByUserId>>> = ({ signal }) => getRbacGetUserRolesByUserId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetUserRolesByUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetUserRolesByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetUserRolesByUserId>>>
export type GetRbacGetUserRolesByUserIdQueryError = unknown

export const useGetRbacGetUserRolesByUserId = <TData = Awaited<ReturnType<typeof getRbacGetUserRolesByUserId>>, TError = unknown>(
 params?: GetRbacGetUserRolesByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetUserRolesByUserId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetUserRolesByUserIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetRolesByUserId = (
    params?: GetRbacGetRolesByUserIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Role[]>(
      {url: `/Rbac/GetRolesByUserId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetRolesByUserIdQueryKey = (params?: GetRbacGetRolesByUserIdParams,) => {
    return [`/Rbac/GetRolesByUserId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRbacGetRolesByUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetRolesByUserId>>, TError = unknown>(params?: GetRbacGetRolesByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolesByUserId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetRolesByUserIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetRolesByUserId>>> = ({ signal }) => getRbacGetRolesByUserId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolesByUserId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetRolesByUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetRolesByUserId>>>
export type GetRbacGetRolesByUserIdQueryError = unknown

export const useGetRbacGetRolesByUserId = <TData = Awaited<ReturnType<typeof getRbacGetRolesByUserId>>, TError = unknown>(
 params?: GetRbacGetRolesByUserIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolesByUserId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetRolesByUserIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetRolePermissions = (
    params?: GetRbacGetRolePermissionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<RolePermission[]>(
      {url: `/Rbac/GetRolePermissions`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetRolePermissionsQueryKey = (params?: GetRbacGetRolePermissionsParams,) => {
    return [`/Rbac/GetRolePermissions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRbacGetRolePermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetRolePermissions>>, TError = unknown>(params?: GetRbacGetRolePermissionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolePermissions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetRolePermissionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetRolePermissions>>> = ({ signal }) => getRbacGetRolePermissions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolePermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetRolePermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetRolePermissions>>>
export type GetRbacGetRolePermissionsQueryError = unknown

export const useGetRbacGetRolePermissions = <TData = Awaited<ReturnType<typeof getRbacGetRolePermissions>>, TError = unknown>(
 params?: GetRbacGetRolePermissionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolePermissions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetRolePermissionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetUserAccessRules = (
    params?: GetRbacGetUserAccessRulesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<IQueryExpr[]>(
      {url: `/Rbac/GetUserAccessRules`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetUserAccessRulesQueryKey = (params?: GetRbacGetUserAccessRulesParams,) => {
    return [`/Rbac/GetUserAccessRules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRbacGetUserAccessRulesQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetUserAccessRules>>, TError = unknown>(params?: GetRbacGetUserAccessRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetUserAccessRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetUserAccessRulesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetUserAccessRules>>> = ({ signal }) => getRbacGetUserAccessRules(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetUserAccessRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetUserAccessRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetUserAccessRules>>>
export type GetRbacGetUserAccessRulesQueryError = unknown

export const useGetRbacGetUserAccessRules = <TData = Awaited<ReturnType<typeof getRbacGetUserAccessRules>>, TError = unknown>(
 params?: GetRbacGetUserAccessRulesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetUserAccessRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetUserAccessRulesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetCompanyRolePermissions = (
    params?: GetRbacGetCompanyRolePermissionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<RolePermission[]>(
      {url: `/Rbac/GetCompanyRolePermissions`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetCompanyRolePermissionsQueryKey = (params?: GetRbacGetCompanyRolePermissionsParams,) => {
    return [`/Rbac/GetCompanyRolePermissions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRbacGetCompanyRolePermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetCompanyRolePermissions>>, TError = unknown>(params?: GetRbacGetCompanyRolePermissionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetCompanyRolePermissions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetCompanyRolePermissionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetCompanyRolePermissions>>> = ({ signal }) => getRbacGetCompanyRolePermissions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetCompanyRolePermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetCompanyRolePermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetCompanyRolePermissions>>>
export type GetRbacGetCompanyRolePermissionsQueryError = unknown

export const useGetRbacGetCompanyRolePermissions = <TData = Awaited<ReturnType<typeof getRbacGetCompanyRolePermissions>>, TError = unknown>(
 params?: GetRbacGetCompanyRolePermissionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetCompanyRolePermissions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetCompanyRolePermissionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postRbacGetRolePermissionsBulk = (
    postRbacGetRolePermissionsBulkBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<RolePermission[]>(
      {url: `/Rbac/GetRolePermissionsBulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postRbacGetRolePermissionsBulkBody
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacGetRolePermissionsBulkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacGetRolePermissionsBulk>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacGetRolePermissionsBulk>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacGetRolePermissionsBulk>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postRbacGetRolePermissionsBulk(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacGetRolePermissionsBulkMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacGetRolePermissionsBulk>>>
    export type PostRbacGetRolePermissionsBulkMutationBody = number[]
    export type PostRbacGetRolePermissionsBulkMutationError = unknown

    export const usePostRbacGetRolePermissionsBulk = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacGetRolePermissionsBulk>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacGetRolePermissionsBulk>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostRbacGetRolePermissionsBulkMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getRbacGetPermissions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Permission[]>(
      {url: `/Rbac/GetPermissions`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetPermissionsQueryKey = () => {
    return [`/Rbac/GetPermissions`] as const;
    }

    
export const getGetRbacGetPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetPermissions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetPermissions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetPermissions>>> = ({ signal }) => getRbacGetPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetPermissions>>>
export type GetRbacGetPermissionsQueryError = unknown

export const useGetRbacGetPermissions = <TData = Awaited<ReturnType<typeof getRbacGetPermissions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetPermissions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetRoles = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Role[]>(
      {url: `/Rbac/GetRoles`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetRolesQueryKey = () => {
    return [`/Rbac/GetRoles`] as const;
    }

    
export const getGetRbacGetRolesQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetRoles>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRoles>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetRoles>>> = ({ signal }) => getRbacGetRoles(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetRoles>>>
export type GetRbacGetRolesQueryError = unknown

export const useGetRbacGetRoles = <TData = Awaited<ReturnType<typeof getRbacGetRoles>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRoles>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetRolesByCompany = (
    params?: GetRbacGetRolesByCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Role[]>(
      {url: `/Rbac/GetRolesByCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetRolesByCompanyQueryKey = (params?: GetRbacGetRolesByCompanyParams,) => {
    return [`/Rbac/GetRolesByCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRbacGetRolesByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetRolesByCompany>>, TError = unknown>(params?: GetRbacGetRolesByCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolesByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetRolesByCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetRolesByCompany>>> = ({ signal }) => getRbacGetRolesByCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolesByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetRolesByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetRolesByCompany>>>
export type GetRbacGetRolesByCompanyQueryError = unknown

export const useGetRbacGetRolesByCompany = <TData = Awaited<ReturnType<typeof getRbacGetRolesByCompany>>, TError = unknown>(
 params?: GetRbacGetRolesByCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRolesByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetRolesByCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetRole = (
    params?: GetRbacGetRoleParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Role>(
      {url: `/Rbac/GetRole`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetRoleQueryKey = (params?: GetRbacGetRoleParams,) => {
    return [`/Rbac/GetRole`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRbacGetRoleQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetRole>>, TError = unknown>(params?: GetRbacGetRoleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRole>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetRoleQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetRole>>> = ({ signal }) => getRbacGetRole(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRole>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetRoleQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetRole>>>
export type GetRbacGetRoleQueryError = unknown

export const useGetRbacGetRole = <TData = Awaited<ReturnType<typeof getRbacGetRole>>, TError = unknown>(
 params?: GetRbacGetRoleParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetRole>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetRoleQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getRbacGetCompanyRoles = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyRoleListItem[]>(
      {url: `/Rbac/GetCompanyRoles`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetRbacGetCompanyRolesQueryKey = () => {
    return [`/Rbac/GetCompanyRoles`] as const;
    }

    
export const getGetRbacGetCompanyRolesQueryOptions = <TData = Awaited<ReturnType<typeof getRbacGetCompanyRoles>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetCompanyRoles>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRbacGetCompanyRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRbacGetCompanyRoles>>> = ({ signal }) => getRbacGetCompanyRoles(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRbacGetCompanyRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRbacGetCompanyRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getRbacGetCompanyRoles>>>
export type GetRbacGetCompanyRolesQueryError = unknown

export const useGetRbacGetCompanyRoles = <TData = Awaited<ReturnType<typeof getRbacGetCompanyRoles>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRbacGetCompanyRoles>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRbacGetCompanyRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postRbacBulkAssignMspUsers = (
    bulkAssignMspUsers: BulkAssignMspUsers,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Rbac/BulkAssignMspUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkAssignMspUsers
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacBulkAssignMspUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkAssignMspUsers>>, TError,{data: BulkAssignMspUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkAssignMspUsers>>, TError,{data: BulkAssignMspUsers}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacBulkAssignMspUsers>>, {data: BulkAssignMspUsers}> = (props) => {
          const {data} = props ?? {};

          return  postRbacBulkAssignMspUsers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacBulkAssignMspUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacBulkAssignMspUsers>>>
    export type PostRbacBulkAssignMspUsersMutationBody = BulkAssignMspUsers
    export type PostRbacBulkAssignMspUsersMutationError = unknown

    export const usePostRbacBulkAssignMspUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkAssignMspUsers>>, TError,{data: BulkAssignMspUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacBulkAssignMspUsers>>,
        TError,
        {data: BulkAssignMspUsers},
        TContext
      > => {

      const mutationOptions = getPostRbacBulkAssignMspUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRbacBulkAssignSupportUsers = (
    bulkAssignSupportUsers: BulkAssignSupportUsers,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Rbac/BulkAssignSupportUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkAssignSupportUsers
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacBulkAssignSupportUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkAssignSupportUsers>>, TError,{data: BulkAssignSupportUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkAssignSupportUsers>>, TError,{data: BulkAssignSupportUsers}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacBulkAssignSupportUsers>>, {data: BulkAssignSupportUsers}> = (props) => {
          const {data} = props ?? {};

          return  postRbacBulkAssignSupportUsers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacBulkAssignSupportUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacBulkAssignSupportUsers>>>
    export type PostRbacBulkAssignSupportUsersMutationBody = BulkAssignSupportUsers
    export type PostRbacBulkAssignSupportUsersMutationError = unknown

    export const usePostRbacBulkAssignSupportUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkAssignSupportUsers>>, TError,{data: BulkAssignSupportUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacBulkAssignSupportUsers>>,
        TError,
        {data: BulkAssignSupportUsers},
        TContext
      > => {

      const mutationOptions = getPostRbacBulkAssignSupportUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRbacBulkRemoveMspUsers = (
    bulkRemoveMspUsers: BulkRemoveMspUsers,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Rbac/BulkRemoveMspUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkRemoveMspUsers
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacBulkRemoveMspUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkRemoveMspUsers>>, TError,{data: BulkRemoveMspUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkRemoveMspUsers>>, TError,{data: BulkRemoveMspUsers}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacBulkRemoveMspUsers>>, {data: BulkRemoveMspUsers}> = (props) => {
          const {data} = props ?? {};

          return  postRbacBulkRemoveMspUsers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacBulkRemoveMspUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacBulkRemoveMspUsers>>>
    export type PostRbacBulkRemoveMspUsersMutationBody = BulkRemoveMspUsers
    export type PostRbacBulkRemoveMspUsersMutationError = unknown

    export const usePostRbacBulkRemoveMspUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkRemoveMspUsers>>, TError,{data: BulkRemoveMspUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacBulkRemoveMspUsers>>,
        TError,
        {data: BulkRemoveMspUsers},
        TContext
      > => {

      const mutationOptions = getPostRbacBulkRemoveMspUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postRbacBulkRemoveSupportUsers = (
    bulkAssignSupportUsers: BulkAssignSupportUsers,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Rbac/BulkRemoveSupportUsers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkAssignSupportUsers
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostRbacBulkRemoveSupportUsersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkRemoveSupportUsers>>, TError,{data: BulkAssignSupportUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkRemoveSupportUsers>>, TError,{data: BulkAssignSupportUsers}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postRbacBulkRemoveSupportUsers>>, {data: BulkAssignSupportUsers}> = (props) => {
          const {data} = props ?? {};

          return  postRbacBulkRemoveSupportUsers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostRbacBulkRemoveSupportUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postRbacBulkRemoveSupportUsers>>>
    export type PostRbacBulkRemoveSupportUsersMutationBody = BulkAssignSupportUsers
    export type PostRbacBulkRemoveSupportUsersMutationError = unknown

    export const usePostRbacBulkRemoveSupportUsers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postRbacBulkRemoveSupportUsers>>, TError,{data: BulkAssignSupportUsers}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postRbacBulkRemoveSupportUsers>>,
        TError,
        {data: BulkAssignSupportUsers},
        TContext
      > => {

      const mutationOptions = getPostRbacBulkRemoveSupportUsersMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getResourcesGetResourceSyncBlacklist = (
    params?: GetResourcesGetResourceSyncBlacklistParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<AwsResourceSyncBlacklist[]>(
      {url: `/Resources/GetResourceSyncBlacklist`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetResourcesGetResourceSyncBlacklistQueryKey = (params?: GetResourcesGetResourceSyncBlacklistParams,) => {
    return [`/Resources/GetResourceSyncBlacklist`, ...(params ? [params]: [])] as const;
    }

    
export const getGetResourcesGetResourceSyncBlacklistQueryOptions = <TData = Awaited<ReturnType<typeof getResourcesGetResourceSyncBlacklist>>, TError = unknown>(params?: GetResourcesGetResourceSyncBlacklistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetResourceSyncBlacklist>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetResourcesGetResourceSyncBlacklistQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getResourcesGetResourceSyncBlacklist>>> = ({ signal }) => getResourcesGetResourceSyncBlacklist(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetResourceSyncBlacklist>>, TError, TData> & { queryKey: QueryKey }
}

export type GetResourcesGetResourceSyncBlacklistQueryResult = NonNullable<Awaited<ReturnType<typeof getResourcesGetResourceSyncBlacklist>>>
export type GetResourcesGetResourceSyncBlacklistQueryError = unknown

export const useGetResourcesGetResourceSyncBlacklist = <TData = Awaited<ReturnType<typeof getResourcesGetResourceSyncBlacklist>>, TError = unknown>(
 params?: GetResourcesGetResourceSyncBlacklistParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getResourcesGetResourceSyncBlacklist>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetResourcesGetResourceSyncBlacklistQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postResourcesSaveResourceSyncBlacklist = (
    awsResourceSyncBlacklist: AwsResourceSyncBlacklist[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<AwsResourceSyncBlacklist[]>(
      {url: `/Resources/SaveResourceSyncBlacklist`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: awsResourceSyncBlacklist
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostResourcesSaveResourceSyncBlacklistMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesSaveResourceSyncBlacklist>>, TError,{data: AwsResourceSyncBlacklist[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postResourcesSaveResourceSyncBlacklist>>, TError,{data: AwsResourceSyncBlacklist[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postResourcesSaveResourceSyncBlacklist>>, {data: AwsResourceSyncBlacklist[]}> = (props) => {
          const {data} = props ?? {};

          return  postResourcesSaveResourceSyncBlacklist(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostResourcesSaveResourceSyncBlacklistMutationResult = NonNullable<Awaited<ReturnType<typeof postResourcesSaveResourceSyncBlacklist>>>
    export type PostResourcesSaveResourceSyncBlacklistMutationBody = AwsResourceSyncBlacklist[]
    export type PostResourcesSaveResourceSyncBlacklistMutationError = unknown

    export const usePostResourcesSaveResourceSyncBlacklist = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postResourcesSaveResourceSyncBlacklist>>, TError,{data: AwsResourceSyncBlacklist[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postResourcesSaveResourceSyncBlacklist>>,
        TError,
        {data: AwsResourceSyncBlacklist[]},
        TContext
      > => {

      const mutationOptions = getPostResourcesSaveResourceSyncBlacklistMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getServiceActionGetServiceActions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<ServiceAction[]>(
      {url: `/ServiceAction/GetServiceActions`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetServiceActionGetServiceActionsQueryKey = () => {
    return [`/ServiceAction/GetServiceActions`] as const;
    }

    
export const getGetServiceActionGetServiceActionsQueryOptions = <TData = Awaited<ReturnType<typeof getServiceActionGetServiceActions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceActionGetServiceActions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetServiceActionGetServiceActionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getServiceActionGetServiceActions>>> = ({ signal }) => getServiceActionGetServiceActions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getServiceActionGetServiceActions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetServiceActionGetServiceActionsQueryResult = NonNullable<Awaited<ReturnType<typeof getServiceActionGetServiceActions>>>
export type GetServiceActionGetServiceActionsQueryError = unknown

export const useGetServiceActionGetServiceActions = <TData = Awaited<ReturnType<typeof getServiceActionGetServiceActions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getServiceActionGetServiceActions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetServiceActionGetServiceActionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postServiceActionSaveServiceAction = (
    params?: PostServiceActionSaveServiceActionParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<ServiceAction>(
      {url: `/ServiceAction/SaveServiceAction`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostServiceActionSaveServiceActionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceActionSaveServiceAction>>, TError,{params?: PostServiceActionSaveServiceActionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postServiceActionSaveServiceAction>>, TError,{params?: PostServiceActionSaveServiceActionParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postServiceActionSaveServiceAction>>, {params?: PostServiceActionSaveServiceActionParams}> = (props) => {
          const {params} = props ?? {};

          return  postServiceActionSaveServiceAction(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostServiceActionSaveServiceActionMutationResult = NonNullable<Awaited<ReturnType<typeof postServiceActionSaveServiceAction>>>
    
    export type PostServiceActionSaveServiceActionMutationError = unknown

    export const usePostServiceActionSaveServiceAction = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postServiceActionSaveServiceAction>>, TError,{params?: PostServiceActionSaveServiceActionParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postServiceActionSaveServiceAction>>,
        TError,
        {params?: PostServiceActionSaveServiceActionParams},
        TContext
      > => {

      const mutationOptions = getPostServiceActionSaveServiceActionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postStagedCompanyConvert = (
    params?: PostStagedCompanyConvertParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<Company>(
      {url: `/StagedCompany/Convert`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostStagedCompanyConvertMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStagedCompanyConvert>>, TError,{params?: PostStagedCompanyConvertParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postStagedCompanyConvert>>, TError,{params?: PostStagedCompanyConvertParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postStagedCompanyConvert>>, {params?: PostStagedCompanyConvertParams}> = (props) => {
          const {params} = props ?? {};

          return  postStagedCompanyConvert(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostStagedCompanyConvertMutationResult = NonNullable<Awaited<ReturnType<typeof postStagedCompanyConvert>>>
    
    export type PostStagedCompanyConvertMutationError = unknown

    export const usePostStagedCompanyConvert = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postStagedCompanyConvert>>, TError,{params?: PostStagedCompanyConvertParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postStagedCompanyConvert>>,
        TError,
        {params?: PostStagedCompanyConvertParams},
        TContext
      > => {

      const mutationOptions = getPostStagedCompanyConvertMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getStagedCompanyGetConnectionStatus = (
    params?: GetStagedCompanyGetConnectionStatusParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<StagedCompanyConnectionStatus[]>(
      {url: `/StagedCompany/GetConnectionStatus`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetStagedCompanyGetConnectionStatusQueryKey = (params?: GetStagedCompanyGetConnectionStatusParams,) => {
    return [`/StagedCompany/GetConnectionStatus`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStagedCompanyGetConnectionStatusQueryOptions = <TData = Awaited<ReturnType<typeof getStagedCompanyGetConnectionStatus>>, TError = unknown>(params?: GetStagedCompanyGetConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStagedCompanyGetConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStagedCompanyGetConnectionStatusQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStagedCompanyGetConnectionStatus>>> = ({ signal }) => getStagedCompanyGetConnectionStatus(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStagedCompanyGetConnectionStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStagedCompanyGetConnectionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getStagedCompanyGetConnectionStatus>>>
export type GetStagedCompanyGetConnectionStatusQueryError = unknown

export const useGetStagedCompanyGetConnectionStatus = <TData = Awaited<ReturnType<typeof getStagedCompanyGetConnectionStatus>>, TError = unknown>(
 params?: GetStagedCompanyGetConnectionStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStagedCompanyGetConnectionStatus>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStagedCompanyGetConnectionStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getStagedCompanyGetById = (
    params?: GetStagedCompanyGetByIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<StagedCompany>(
      {url: `/StagedCompany/GetById`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetStagedCompanyGetByIdQueryKey = (params?: GetStagedCompanyGetByIdParams,) => {
    return [`/StagedCompany/GetById`, ...(params ? [params]: [])] as const;
    }

    
export const getGetStagedCompanyGetByIdQueryOptions = <TData = Awaited<ReturnType<typeof getStagedCompanyGetById>>, TError = unknown>(params?: GetStagedCompanyGetByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStagedCompanyGetById>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStagedCompanyGetByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStagedCompanyGetById>>> = ({ signal }) => getStagedCompanyGetById(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStagedCompanyGetById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStagedCompanyGetByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getStagedCompanyGetById>>>
export type GetStagedCompanyGetByIdQueryError = unknown

export const useGetStagedCompanyGetById = <TData = Awaited<ReturnType<typeof getStagedCompanyGetById>>, TError = unknown>(
 params?: GetStagedCompanyGetByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStagedCompanyGetById>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetStagedCompanyGetByIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSubscriptionGetSubscriptionTypes = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SubscriptionType[]>(
      {url: `/Subscription/GetSubscriptionTypes`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetSubscriptionGetSubscriptionTypesQueryKey = () => {
    return [`/Subscription/GetSubscriptionTypes`] as const;
    }

    
export const getGetSubscriptionGetSubscriptionTypesQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionGetSubscriptionTypes>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionTypes>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionGetSubscriptionTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionTypes>>> = ({ signal }) => getSubscriptionGetSubscriptionTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionTypes>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionGetSubscriptionTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionTypes>>>
export type GetSubscriptionGetSubscriptionTypesQueryError = unknown

export const useGetSubscriptionGetSubscriptionTypes = <TData = Awaited<ReturnType<typeof getSubscriptionGetSubscriptionTypes>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionTypes>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionGetSubscriptionTypesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSubscriptionGetAllSubscriptionsByCompany = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SubscriptionDetail[]>(
      {url: `/Subscription/GetAllSubscriptionsByCompany`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetSubscriptionGetAllSubscriptionsByCompanyQueryKey = () => {
    return [`/Subscription/GetAllSubscriptionsByCompany`] as const;
    }

    
export const getGetSubscriptionGetAllSubscriptionsByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionGetAllSubscriptionsByCompany>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetAllSubscriptionsByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionGetAllSubscriptionsByCompanyQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionGetAllSubscriptionsByCompany>>> = ({ signal }) => getSubscriptionGetAllSubscriptionsByCompany(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetAllSubscriptionsByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionGetAllSubscriptionsByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionGetAllSubscriptionsByCompany>>>
export type GetSubscriptionGetAllSubscriptionsByCompanyQueryError = unknown

export const useGetSubscriptionGetAllSubscriptionsByCompany = <TData = Awaited<ReturnType<typeof getSubscriptionGetAllSubscriptionsByCompany>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetAllSubscriptionsByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionGetAllSubscriptionsByCompanyQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSubscriptionGetSubscriptionOptions = (
    params?: GetSubscriptionGetSubscriptionOptionsParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SubscriptionOptions>(
      {url: `/Subscription/GetSubscriptionOptions`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetSubscriptionGetSubscriptionOptionsQueryKey = (params?: GetSubscriptionGetSubscriptionOptionsParams,) => {
    return [`/Subscription/GetSubscriptionOptions`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSubscriptionGetSubscriptionOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionGetSubscriptionOptions>>, TError = unknown>(params?: GetSubscriptionGetSubscriptionOptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionOptions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionGetSubscriptionOptionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionOptions>>> = ({ signal }) => getSubscriptionGetSubscriptionOptions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionGetSubscriptionOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionOptions>>>
export type GetSubscriptionGetSubscriptionOptionsQueryError = unknown

export const useGetSubscriptionGetSubscriptionOptions = <TData = Awaited<ReturnType<typeof getSubscriptionGetSubscriptionOptions>>, TError = unknown>(
 params?: GetSubscriptionGetSubscriptionOptionsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetSubscriptionOptions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionGetSubscriptionOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSubscriptionGetCreditRates = (
    params?: GetSubscriptionGetCreditRatesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CreditRates>(
      {url: `/Subscription/GetCreditRates`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetSubscriptionGetCreditRatesQueryKey = (params?: GetSubscriptionGetCreditRatesParams,) => {
    return [`/Subscription/GetCreditRates`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSubscriptionGetCreditRatesQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionGetCreditRates>>, TError = unknown>(params?: GetSubscriptionGetCreditRatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetCreditRates>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionGetCreditRatesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionGetCreditRates>>> = ({ signal }) => getSubscriptionGetCreditRates(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetCreditRates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionGetCreditRatesQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionGetCreditRates>>>
export type GetSubscriptionGetCreditRatesQueryError = unknown

export const useGetSubscriptionGetCreditRates = <TData = Awaited<ReturnType<typeof getSubscriptionGetCreditRates>>, TError = unknown>(
 params?: GetSubscriptionGetCreditRatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetCreditRates>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionGetCreditRatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSubscriptionGetAppAccessByCompany = (
    params?: GetSubscriptionGetAppAccessByCompanyParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<string[]>(
      {url: `/Subscription/GetAppAccessByCompany`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetSubscriptionGetAppAccessByCompanyQueryKey = (params?: GetSubscriptionGetAppAccessByCompanyParams,) => {
    return [`/Subscription/GetAppAccessByCompany`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSubscriptionGetAppAccessByCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionGetAppAccessByCompany>>, TError = unknown>(params?: GetSubscriptionGetAppAccessByCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetAppAccessByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionGetAppAccessByCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionGetAppAccessByCompany>>> = ({ signal }) => getSubscriptionGetAppAccessByCompany(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetAppAccessByCompany>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionGetAppAccessByCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionGetAppAccessByCompany>>>
export type GetSubscriptionGetAppAccessByCompanyQueryError = unknown

export const useGetSubscriptionGetAppAccessByCompany = <TData = Awaited<ReturnType<typeof getSubscriptionGetAppAccessByCompany>>, TError = unknown>(
 params?: GetSubscriptionGetAppAccessByCompanyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionGetAppAccessByCompany>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionGetAppAccessByCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupportGetSupportedCompanies = (
    params?: GetSupportGetSupportedCompaniesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<number[]>(
      {url: `/Support/GetSupportedCompanies`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetSupportGetSupportedCompaniesQueryKey = (params?: GetSupportGetSupportedCompaniesParams,) => {
    return [`/Support/GetSupportedCompanies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetSupportGetSupportedCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getSupportGetSupportedCompanies>>, TError = unknown>(params?: GetSupportGetSupportedCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportGetSupportedCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportGetSupportedCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportGetSupportedCompanies>>> = ({ signal }) => getSupportGetSupportedCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportGetSupportedCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupportGetSupportedCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportGetSupportedCompanies>>>
export type GetSupportGetSupportedCompaniesQueryError = unknown

export const useGetSupportGetSupportedCompanies = <TData = Awaited<ReturnType<typeof getSupportGetSupportedCompanies>>, TError = unknown>(
 params?: GetSupportGetSupportedCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportGetSupportedCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupportGetSupportedCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSupportGetExternalSupportCompanies = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Int32StringKeyValuePair[]>(
      {url: `/Support/GetExternalSupportCompanies`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetSupportGetExternalSupportCompaniesQueryKey = () => {
    return [`/Support/GetExternalSupportCompanies`] as const;
    }

    
export const getGetSupportGetExternalSupportCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getSupportGetExternalSupportCompanies>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportGetExternalSupportCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSupportGetExternalSupportCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSupportGetExternalSupportCompanies>>> = ({ signal }) => getSupportGetExternalSupportCompanies(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSupportGetExternalSupportCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSupportGetExternalSupportCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getSupportGetExternalSupportCompanies>>>
export type GetSupportGetExternalSupportCompaniesQueryError = unknown

export const useGetSupportGetExternalSupportCompanies = <TData = Awaited<ReturnType<typeof getSupportGetExternalSupportCompanies>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSupportGetExternalSupportCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSupportGetExternalSupportCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postSupportBulkAssignSupportCompanies = (
    bulkAssignSupportCompanies: BulkAssignSupportCompanies,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/Support/BulkAssignSupportCompanies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: bulkAssignSupportCompanies
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostSupportBulkAssignSupportCompaniesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupportBulkAssignSupportCompanies>>, TError,{data: BulkAssignSupportCompanies}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postSupportBulkAssignSupportCompanies>>, TError,{data: BulkAssignSupportCompanies}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSupportBulkAssignSupportCompanies>>, {data: BulkAssignSupportCompanies}> = (props) => {
          const {data} = props ?? {};

          return  postSupportBulkAssignSupportCompanies(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSupportBulkAssignSupportCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postSupportBulkAssignSupportCompanies>>>
    export type PostSupportBulkAssignSupportCompaniesMutationBody = BulkAssignSupportCompanies
    export type PostSupportBulkAssignSupportCompaniesMutationError = unknown

    export const usePostSupportBulkAssignSupportCompanies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSupportBulkAssignSupportCompanies>>, TError,{data: BulkAssignSupportCompanies}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postSupportBulkAssignSupportCompanies>>,
        TError,
        {data: BulkAssignSupportCompanies},
        TContext
      > => {

      const mutationOptions = getPostSupportBulkAssignSupportCompaniesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTestErrorNonServiceEx = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TestError/NonServiceEx`, method: 'POST'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostTestErrorNonServiceExMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorNonServiceEx>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTestErrorNonServiceEx>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTestErrorNonServiceEx>>, void> = () => {
          

          return  postTestErrorNonServiceEx(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTestErrorNonServiceExMutationResult = NonNullable<Awaited<ReturnType<typeof postTestErrorNonServiceEx>>>
    
    export type PostTestErrorNonServiceExMutationError = unknown

    export const usePostTestErrorNonServiceEx = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorNonServiceEx>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTestErrorNonServiceEx>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTestErrorNonServiceExMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTestErrorServiceExInternal = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TestError/ServiceExInternal`, method: 'POST'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostTestErrorServiceExInternalMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExInternal>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExInternal>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTestErrorServiceExInternal>>, void> = () => {
          

          return  postTestErrorServiceExInternal(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTestErrorServiceExInternalMutationResult = NonNullable<Awaited<ReturnType<typeof postTestErrorServiceExInternal>>>
    
    export type PostTestErrorServiceExInternalMutationError = unknown

    export const usePostTestErrorServiceExInternal = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExInternal>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTestErrorServiceExInternal>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTestErrorServiceExInternalMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTestErrorServiceExUnknown = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TestError/ServiceExUnknown`, method: 'POST'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostTestErrorServiceExUnknownMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExUnknown>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExUnknown>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTestErrorServiceExUnknown>>, void> = () => {
          

          return  postTestErrorServiceExUnknown(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTestErrorServiceExUnknownMutationResult = NonNullable<Awaited<ReturnType<typeof postTestErrorServiceExUnknown>>>
    
    export type PostTestErrorServiceExUnknownMutationError = unknown

    export const usePostTestErrorServiceExUnknown = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExUnknown>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTestErrorServiceExUnknown>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTestErrorServiceExUnknownMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTestErrorServiceExNotFound = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TestError/ServiceExNotFound`, method: 'POST'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostTestErrorServiceExNotFoundMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExNotFound>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExNotFound>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTestErrorServiceExNotFound>>, void> = () => {
          

          return  postTestErrorServiceExNotFound(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTestErrorServiceExNotFoundMutationResult = NonNullable<Awaited<ReturnType<typeof postTestErrorServiceExNotFound>>>
    
    export type PostTestErrorServiceExNotFoundMutationError = unknown

    export const usePostTestErrorServiceExNotFound = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExNotFound>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTestErrorServiceExNotFound>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTestErrorServiceExNotFoundMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postTestErrorServiceExBadRequest = (
    
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/TestError/ServiceExBadRequest`, method: 'POST'
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostTestErrorServiceExBadRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExBadRequest>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExBadRequest>>, TError,void, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTestErrorServiceExBadRequest>>, void> = () => {
          

          return  postTestErrorServiceExBadRequest(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTestErrorServiceExBadRequestMutationResult = NonNullable<Awaited<ReturnType<typeof postTestErrorServiceExBadRequest>>>
    
    export type PostTestErrorServiceExBadRequestMutationError = unknown

    export const usePostTestErrorServiceExBadRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTestErrorServiceExBadRequest>>, TError,void, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postTestErrorServiceExBadRequest>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostTestErrorServiceExBadRequestMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserGetUserByExternalId = (
    params?: GetUserGetUserByExternalIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<User>(
      {url: `/User/GetUserByExternalId`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetUserByExternalIdQueryKey = (params?: GetUserGetUserByExternalIdParams,) => {
    return [`/User/GetUserByExternalId`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserGetUserByExternalIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetUserByExternalId>>, TError = unknown>(params?: GetUserGetUserByExternalIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserByExternalId>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetUserByExternalIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetUserByExternalId>>> = ({ signal }) => getUserGetUserByExternalId(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserByExternalId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetUserByExternalIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetUserByExternalId>>>
export type GetUserGetUserByExternalIdQueryError = unknown

export const useGetUserGetUserByExternalId = <TData = Awaited<ReturnType<typeof getUserGetUserByExternalId>>, TError = unknown>(
 params?: GetUserGetUserByExternalIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserByExternalId>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetUserByExternalIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserGetOrCreateApiClientUser = (
    getOrCreateApiClientUserRequest: GetOrCreateApiClientUserRequest,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<GetOrCreateApiClientUserResponse>(
      {url: `/User/GetOrCreateApiClientUser`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: getOrCreateApiClientUserRequest
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserGetOrCreateApiClientUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGetOrCreateApiClientUser>>, TError,{data: GetOrCreateApiClientUserRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserGetOrCreateApiClientUser>>, TError,{data: GetOrCreateApiClientUserRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserGetOrCreateApiClientUser>>, {data: GetOrCreateApiClientUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUserGetOrCreateApiClientUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserGetOrCreateApiClientUserMutationResult = NonNullable<Awaited<ReturnType<typeof postUserGetOrCreateApiClientUser>>>
    export type PostUserGetOrCreateApiClientUserMutationBody = GetOrCreateApiClientUserRequest
    export type PostUserGetOrCreateApiClientUserMutationError = unknown

    export const usePostUserGetOrCreateApiClientUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGetOrCreateApiClientUser>>, TError,{data: GetOrCreateApiClientUserRequest}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserGetOrCreateApiClientUser>>,
        TError,
        {data: GetOrCreateApiClientUserRequest},
        TContext
      > => {

      const mutationOptions = getPostUserGetOrCreateApiClientUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserGetApiClientUsersByCompanyId = (
    params?: PostUserGetApiClientUsersByCompanyIdParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<User[]>(
      {url: `/User/GetApiClientUsersByCompanyId`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserGetApiClientUsersByCompanyIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGetApiClientUsersByCompanyId>>, TError,{params?: PostUserGetApiClientUsersByCompanyIdParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserGetApiClientUsersByCompanyId>>, TError,{params?: PostUserGetApiClientUsersByCompanyIdParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserGetApiClientUsersByCompanyId>>, {params?: PostUserGetApiClientUsersByCompanyIdParams}> = (props) => {
          const {params} = props ?? {};

          return  postUserGetApiClientUsersByCompanyId(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserGetApiClientUsersByCompanyIdMutationResult = NonNullable<Awaited<ReturnType<typeof postUserGetApiClientUsersByCompanyId>>>
    
    export type PostUserGetApiClientUsersByCompanyIdMutationError = unknown

    export const usePostUserGetApiClientUsersByCompanyId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserGetApiClientUsersByCompanyId>>, TError,{params?: PostUserGetApiClientUsersByCompanyIdParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserGetApiClientUsersByCompanyId>>,
        TError,
        {params?: PostUserGetApiClientUsersByCompanyIdParams},
        TContext
      > => {

      const mutationOptions = getPostUserGetApiClientUsersByCompanyIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserCreateUserByEmailAddress = (
    params?: PostUserCreateUserByEmailAddressParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<User>(
      {url: `/User/CreateUserByEmailAddress`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserCreateUserByEmailAddressMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserCreateUserByEmailAddress>>, TError,{params?: PostUserCreateUserByEmailAddressParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserCreateUserByEmailAddress>>, TError,{params?: PostUserCreateUserByEmailAddressParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserCreateUserByEmailAddress>>, {params?: PostUserCreateUserByEmailAddressParams}> = (props) => {
          const {params} = props ?? {};

          return  postUserCreateUserByEmailAddress(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserCreateUserByEmailAddressMutationResult = NonNullable<Awaited<ReturnType<typeof postUserCreateUserByEmailAddress>>>
    
    export type PostUserCreateUserByEmailAddressMutationError = unknown

    export const usePostUserCreateUserByEmailAddress = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserCreateUserByEmailAddress>>, TError,{params?: PostUserCreateUserByEmailAddressParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserCreateUserByEmailAddress>>,
        TError,
        {params?: PostUserCreateUserByEmailAddressParams},
        TContext
      > => {

      const mutationOptions = getPostUserCreateUserByEmailAddressMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserGetMyCompanies = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company[]>(
      {url: `/User/GetMyCompanies`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetMyCompaniesQueryKey = () => {
    return [`/User/GetMyCompanies`] as const;
    }

    
export const getGetUserGetMyCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetMyCompanies>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetMyCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetMyCompanies>>> = ({ signal }) => getUserGetMyCompanies(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetMyCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetMyCompanies>>>
export type GetUserGetMyCompaniesQueryError = unknown

export const useGetUserGetMyCompanies = <TData = Awaited<ReturnType<typeof getUserGetMyCompanies>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetMyCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetUserCompanies = (
    params?: GetUserGetUserCompaniesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company[]>(
      {url: `/User/GetUserCompanies`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetUserCompaniesQueryKey = (params?: GetUserGetUserCompaniesParams,) => {
    return [`/User/GetUserCompanies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserGetUserCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetUserCompanies>>, TError = unknown>(params?: GetUserGetUserCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetUserCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetUserCompanies>>> = ({ signal }) => getUserGetUserCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetUserCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetUserCompanies>>>
export type GetUserGetUserCompaniesQueryError = unknown

export const useGetUserGetUserCompanies = <TData = Awaited<ReturnType<typeof getUserGetUserCompanies>>, TError = unknown>(
 params?: GetUserGetUserCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetUserCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetSupportUserCompanies = (
    params?: GetUserGetSupportUserCompaniesParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company[]>(
      {url: `/User/GetSupportUserCompanies`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetSupportUserCompaniesQueryKey = (params?: GetUserGetSupportUserCompaniesParams,) => {
    return [`/User/GetSupportUserCompanies`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserGetSupportUserCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetSupportUserCompanies>>, TError = unknown>(params?: GetUserGetSupportUserCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetSupportUserCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetSupportUserCompaniesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetSupportUserCompanies>>> = ({ signal }) => getUserGetSupportUserCompanies(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetSupportUserCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetSupportUserCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetSupportUserCompanies>>>
export type GetUserGetSupportUserCompaniesQueryError = unknown

export const useGetUserGetSupportUserCompanies = <TData = Awaited<ReturnType<typeof getUserGetSupportUserCompanies>>, TError = unknown>(
 params?: GetUserGetSupportUserCompaniesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetSupportUserCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetSupportUserCompaniesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetMyMspCompanies = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<Company[]>(
      {url: `/User/GetMyMspCompanies`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetMyMspCompaniesQueryKey = () => {
    return [`/User/GetMyMspCompanies`] as const;
    }

    
export const getGetUserGetMyMspCompaniesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetMyMspCompanies>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyMspCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetMyMspCompaniesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetMyMspCompanies>>> = ({ signal }) => getUserGetMyMspCompanies(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyMspCompanies>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetMyMspCompaniesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetMyMspCompanies>>>
export type GetUserGetMyMspCompaniesQueryError = unknown

export const useGetUserGetMyMspCompanies = <TData = Awaited<ReturnType<typeof getUserGetMyMspCompanies>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyMspCompanies>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetMyMspCompaniesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserUpdateMyProfile = (
    user: User,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<User>(
      {url: `/User/UpdateMyProfile`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: user
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserUpdateMyProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUpdateMyProfile>>, TError,{data: User}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserUpdateMyProfile>>, TError,{data: User}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserUpdateMyProfile>>, {data: User}> = (props) => {
          const {data} = props ?? {};

          return  postUserUpdateMyProfile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserUpdateMyProfileMutationResult = NonNullable<Awaited<ReturnType<typeof postUserUpdateMyProfile>>>
    export type PostUserUpdateMyProfileMutationBody = User
    export type PostUserUpdateMyProfileMutationError = unknown

    export const usePostUserUpdateMyProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserUpdateMyProfile>>, TError,{data: User}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserUpdateMyProfile>>,
        TError,
        {data: User},
        TContext
      > => {

      const mutationOptions = getPostUserUpdateMyProfileMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserGetMyProfile = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<User>(
      {url: `/User/GetMyProfile`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetMyProfileQueryKey = () => {
    return [`/User/GetMyProfile`] as const;
    }

    
export const getGetUserGetMyProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetMyProfile>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyProfile>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetMyProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetMyProfile>>> = ({ signal }) => getUserGetMyProfile(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyProfile>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetMyProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetMyProfile>>>
export type GetUserGetMyProfileQueryError = unknown

export const useGetUserGetMyProfile = <TData = Awaited<ReturnType<typeof getUserGetMyProfile>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyProfile>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetMyProfileQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetMyPermissions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<EffectivePermissions[]>(
      {url: `/User/GetMyPermissions`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetMyPermissionsQueryKey = () => {
    return [`/User/GetMyPermissions`] as const;
    }

    
export const getGetUserGetMyPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetMyPermissions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyPermissions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetMyPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetMyPermissions>>> = ({ signal }) => getUserGetMyPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetMyPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetMyPermissions>>>
export type GetUserGetMyPermissionsQueryError = unknown

export const useGetUserGetMyPermissions = <TData = Awaited<ReturnType<typeof getUserGetMyPermissions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyPermissions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetMyPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetMyAccessRules = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<IQueryExpr[]>(
      {url: `/User/GetMyAccessRules`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetMyAccessRulesQueryKey = () => {
    return [`/User/GetMyAccessRules`] as const;
    }

    
export const getGetUserGetMyAccessRulesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetMyAccessRules>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyAccessRules>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetMyAccessRulesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetMyAccessRules>>> = ({ signal }) => getUserGetMyAccessRules(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyAccessRules>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetMyAccessRulesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetMyAccessRules>>>
export type GetUserGetMyAccessRulesQueryError = unknown

export const useGetUserGetMyAccessRules = <TData = Awaited<ReturnType<typeof getUserGetMyAccessRules>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyAccessRules>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetMyAccessRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetMyRoles = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<CompanyUserRole[]>(
      {url: `/User/GetMyRoles`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetMyRolesQueryKey = () => {
    return [`/User/GetMyRoles`] as const;
    }

    
export const getGetUserGetMyRolesQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetMyRoles>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyRoles>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetMyRolesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetMyRoles>>> = ({ signal }) => getUserGetMyRoles(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyRoles>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetMyRolesQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetMyRoles>>>
export type GetUserGetMyRolesQueryError = unknown

export const useGetUserGetMyRoles = <TData = Awaited<ReturnType<typeof getUserGetMyRoles>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMyRoles>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetMyRolesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserLogin = (
    params?: GetUserLoginParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/User/Login`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserLoginQueryKey = (params?: GetUserLoginParams,) => {
    return [`/User/Login`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserLoginQueryOptions = <TData = Awaited<ReturnType<typeof getUserLogin>>, TError = unknown>(params?: GetUserLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLogin>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLoginQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLogin>>> = ({ signal }) => getUserLogin(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserLogin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserLoginQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLogin>>>
export type GetUserLoginQueryError = unknown

export const useGetUserLogin = <TData = Awaited<ReturnType<typeof getUserLogin>>, TError = unknown>(
 params?: GetUserLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLogin>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserLoginQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserAzLogin = (
    params?: GetUserAzLoginParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/User/AzLogin`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserAzLoginQueryKey = (params?: GetUserAzLoginParams,) => {
    return [`/User/AzLogin`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserAzLoginQueryOptions = <TData = Awaited<ReturnType<typeof getUserAzLogin>>, TError = unknown>(params?: GetUserAzLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAzLogin>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAzLoginQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAzLogin>>> = ({ signal }) => getUserAzLogin(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAzLogin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserAzLoginQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAzLogin>>>
export type GetUserAzLoginQueryError = unknown

export const useGetUserAzLogin = <TData = Awaited<ReturnType<typeof getUserAzLogin>>, TError = unknown>(
 params?: GetUserAzLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAzLogin>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserAzLoginQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserLogout = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/User/Logout`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserLogoutQueryKey = () => {
    return [`/User/Logout`] as const;
    }

    
export const getGetUserLogoutQueryOptions = <TData = Awaited<ReturnType<typeof getUserLogout>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLogout>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLogoutQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLogout>>> = ({ signal }) => getUserLogout(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserLogout>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLogout>>>
export type GetUserLogoutQueryError = unknown

export const useGetUserLogout = <TData = Awaited<ReturnType<typeof getUserLogout>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLogout>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserLogoutQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserEmailVerified = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<EmailVerified>(
      {url: `/User/EmailVerified`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserEmailVerifiedQueryKey = () => {
    return [`/User/EmailVerified`] as const;
    }

    
export const getGetUserEmailVerifiedQueryOptions = <TData = Awaited<ReturnType<typeof getUserEmailVerified>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserEmailVerified>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserEmailVerifiedQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserEmailVerified>>> = ({ signal }) => getUserEmailVerified(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserEmailVerified>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserEmailVerifiedQueryResult = NonNullable<Awaited<ReturnType<typeof getUserEmailVerified>>>
export type GetUserEmailVerifiedQueryError = unknown

export const useGetUserEmailVerified = <TData = Awaited<ReturnType<typeof getUserEmailVerified>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserEmailVerified>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserEmailVerifiedQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserAuth0ResendEmailValidation = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<string>(
      {url: `/User/Auth0ResendEmailValidation`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserAuth0ResendEmailValidationQueryKey = () => {
    return [`/User/Auth0ResendEmailValidation`] as const;
    }

    
export const getGetUserAuth0ResendEmailValidationQueryOptions = <TData = Awaited<ReturnType<typeof getUserAuth0ResendEmailValidation>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAuth0ResendEmailValidation>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAuth0ResendEmailValidationQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAuth0ResendEmailValidation>>> = ({ signal }) => getUserAuth0ResendEmailValidation(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAuth0ResendEmailValidation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserAuth0ResendEmailValidationQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAuth0ResendEmailValidation>>>
export type GetUserAuth0ResendEmailValidationQueryError = unknown

export const useGetUserAuth0ResendEmailValidation = <TData = Awaited<ReturnType<typeof getUserAuth0ResendEmailValidation>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserAuth0ResendEmailValidation>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserAuth0ResendEmailValidationQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserBearerLogin = (
    params?: GetUserBearerLoginParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/User/BearerLogin`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserBearerLoginQueryKey = (params?: GetUserBearerLoginParams,) => {
    return [`/User/BearerLogin`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserBearerLoginQueryOptions = <TData = Awaited<ReturnType<typeof getUserBearerLogin>>, TError = unknown>(params?: GetUserBearerLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserBearerLogin>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserBearerLoginQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserBearerLogin>>> = ({ signal }) => getUserBearerLogin(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserBearerLogin>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserBearerLoginQueryResult = NonNullable<Awaited<ReturnType<typeof getUserBearerLogin>>>
export type GetUserBearerLoginQueryError = unknown

export const useGetUserBearerLogin = <TData = Awaited<ReturnType<typeof getUserBearerLogin>>, TError = unknown>(
 params?: GetUserBearerLoginParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserBearerLogin>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserBearerLoginQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserLoginCallback = (
    params?: GetUserLoginCallbackParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/User/LoginCallback`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserLoginCallbackQueryKey = (params?: GetUserLoginCallbackParams,) => {
    return [`/User/LoginCallback`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserLoginCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getUserLoginCallback>>, TError = unknown>(params?: GetUserLoginCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLoginCallback>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserLoginCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserLoginCallback>>> = ({ signal }) => getUserLoginCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserLoginCallback>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserLoginCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getUserLoginCallback>>>
export type GetUserLoginCallbackQueryError = unknown

export const useGetUserLoginCallback = <TData = Awaited<ReturnType<typeof getUserLoginCallback>>, TError = unknown>(
 params?: GetUserLoginCallbackParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserLoginCallback>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserLoginCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserPingActivity = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<void>(
      {url: `/User/PingActivity`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserPingActivityQueryKey = () => {
    return [`/User/PingActivity`] as const;
    }

    
export const getGetUserPingActivityQueryOptions = <TData = Awaited<ReturnType<typeof getUserPingActivity>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserPingActivity>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPingActivityQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPingActivity>>> = ({ signal }) => getUserPingActivity(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPingActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserPingActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPingActivity>>>
export type GetUserPingActivityQueryError = unknown

export const useGetUserPingActivity = <TData = Awaited<ReturnType<typeof getUserPingActivity>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserPingActivity>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserPingActivityQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserQueryUserActivity = (
    params?: GetUserQueryUserActivityParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<UserActivityQueryResult[]>(
      {url: `/User/QueryUserActivity`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserQueryUserActivityQueryKey = (params?: GetUserQueryUserActivityParams,) => {
    return [`/User/QueryUserActivity`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserQueryUserActivityQueryOptions = <TData = Awaited<ReturnType<typeof getUserQueryUserActivity>>, TError = unknown>(params?: GetUserQueryUserActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserQueryUserActivity>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryUserActivityQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserQueryUserActivity>>> = ({ signal }) => getUserQueryUserActivity(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserQueryUserActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserQueryUserActivityQueryResult = NonNullable<Awaited<ReturnType<typeof getUserQueryUserActivity>>>
export type GetUserQueryUserActivityQueryError = unknown

export const useGetUserQueryUserActivity = <TData = Awaited<ReturnType<typeof getUserQueryUserActivity>>, TError = unknown>(
 params?: GetUserQueryUserActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserQueryUserActivity>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserQueryUserActivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetCompanyUsers = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<UserListItem[]>(
      {url: `/User/GetCompanyUsers`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetCompanyUsersQueryKey = () => {
    return [`/User/GetCompanyUsers`] as const;
    }

    
export const getGetUserGetCompanyUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetCompanyUsers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetCompanyUsers>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetCompanyUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetCompanyUsers>>> = ({ signal }) => getUserGetCompanyUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetCompanyUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetCompanyUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetCompanyUsers>>>
export type GetUserGetCompanyUsersQueryError = unknown

export const useGetUserGetCompanyUsers = <TData = Awaited<ReturnType<typeof getUserGetCompanyUsers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetCompanyUsers>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetCompanyUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserGetMspSupportUsers = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<SupportUserListItem[]>(
      {url: `/User/GetMspSupportUsers`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetMspSupportUsersQueryKey = () => {
    return [`/User/GetMspSupportUsers`] as const;
    }

    
export const getGetUserGetMspSupportUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetMspSupportUsers>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMspSupportUsers>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetMspSupportUsersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetMspSupportUsers>>> = ({ signal }) => getUserGetMspSupportUsers(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetMspSupportUsers>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetMspSupportUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetMspSupportUsers>>>
export type GetUserGetMspSupportUsersQueryError = unknown

export const useGetUserGetMspSupportUsers = <TData = Awaited<ReturnType<typeof getUserGetMspSupportUsers>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetMspSupportUsers>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetMspSupportUsersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserSaveUserStatus = (
    params?: PostUserSaveUserStatusParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<CompanyUser>(
      {url: `/User/SaveUserStatus`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserSaveUserStatusMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSaveUserStatus>>, TError,{params?: PostUserSaveUserStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserSaveUserStatus>>, TError,{params?: PostUserSaveUserStatusParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserSaveUserStatus>>, {params?: PostUserSaveUserStatusParams}> = (props) => {
          const {params} = props ?? {};

          return  postUserSaveUserStatus(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserSaveUserStatusMutationResult = NonNullable<Awaited<ReturnType<typeof postUserSaveUserStatus>>>
    
    export type PostUserSaveUserStatusMutationError = unknown

    export const usePostUserSaveUserStatus = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSaveUserStatus>>, TError,{params?: PostUserSaveUserStatusParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserSaveUserStatus>>,
        TError,
        {params?: PostUserSaveUserStatusParams},
        TContext
      > => {

      const mutationOptions = getPostUserSaveUserStatusMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserSaveUserIncludeFutureCompanies = (
    params?: PostUserSaveUserIncludeFutureCompaniesParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<User>(
      {url: `/User/SaveUserIncludeFutureCompanies`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserSaveUserIncludeFutureCompaniesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSaveUserIncludeFutureCompanies>>, TError,{params?: PostUserSaveUserIncludeFutureCompaniesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserSaveUserIncludeFutureCompanies>>, TError,{params?: PostUserSaveUserIncludeFutureCompaniesParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserSaveUserIncludeFutureCompanies>>, {params?: PostUserSaveUserIncludeFutureCompaniesParams}> = (props) => {
          const {params} = props ?? {};

          return  postUserSaveUserIncludeFutureCompanies(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserSaveUserIncludeFutureCompaniesMutationResult = NonNullable<Awaited<ReturnType<typeof postUserSaveUserIncludeFutureCompanies>>>
    
    export type PostUserSaveUserIncludeFutureCompaniesMutationError = unknown

    export const usePostUserSaveUserIncludeFutureCompanies = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSaveUserIncludeFutureCompanies>>, TError,{params?: PostUserSaveUserIncludeFutureCompaniesParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserSaveUserIncludeFutureCompanies>>,
        TError,
        {params?: PostUserSaveUserIncludeFutureCompaniesParams},
        TContext
      > => {

      const mutationOptions = getPostUserSaveUserIncludeFutureCompaniesMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const putUserSaveUserInfo = (
    user: User,
    params?: PutUserSaveUserInfoParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<User>(
      {url: `/User/SaveUserInfo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: user,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPutUserSaveUserInfoMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserSaveUserInfo>>, TError,{data: User;params?: PutUserSaveUserInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof putUserSaveUserInfo>>, TError,{data: User;params?: PutUserSaveUserInfoParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUserSaveUserInfo>>, {data: User;params?: PutUserSaveUserInfoParams}> = (props) => {
          const {data,params} = props ?? {};

          return  putUserSaveUserInfo(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUserSaveUserInfoMutationResult = NonNullable<Awaited<ReturnType<typeof putUserSaveUserInfo>>>
    export type PutUserSaveUserInfoMutationBody = User
    export type PutUserSaveUserInfoMutationError = unknown

    export const usePutUserSaveUserInfo = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUserSaveUserInfo>>, TError,{data: User;params?: PutUserSaveUserInfoParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof putUserSaveUserInfo>>,
        TError,
        {data: User;params?: PutUserSaveUserInfoParams},
        TContext
      > => {

      const mutationOptions = getPutUserSaveUserInfoMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const deleteUserDeleteUser = (
    params?: DeleteUserDeleteUserParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/User/DeleteUser`, method: 'DELETE',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getDeleteUserDeleteUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserDeleteUser>>, TError,{params?: DeleteUserDeleteUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUserDeleteUser>>, TError,{params?: DeleteUserDeleteUserParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUserDeleteUser>>, {params?: DeleteUserDeleteUserParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteUserDeleteUser(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUserDeleteUser>>>
    
    export type DeleteUserDeleteUserMutationError = unknown

    export const useDeleteUserDeleteUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUserDeleteUser>>, TError,{params?: DeleteUserDeleteUserParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteUserDeleteUser>>,
        TError,
        {params?: DeleteUserDeleteUserParams},
        TContext
      > => {

      const mutationOptions = getDeleteUserDeleteUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserGetUserById = (
    params?: GetUserGetUserByIdParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<User>(
      {url: `/User/GetUserById`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetUserByIdQueryKey = (params?: GetUserGetUserByIdParams,) => {
    return [`/User/GetUserById`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserGetUserByIdQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetUserById>>, TError = unknown>(params?: GetUserGetUserByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserById>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetUserByIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetUserById>>> = ({ signal }) => getUserGetUserById(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetUserByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetUserById>>>
export type GetUserGetUserByIdQueryError = unknown

export const useGetUserGetUserById = <TData = Awaited<ReturnType<typeof getUserGetUserById>>, TError = unknown>(
 params?: GetUserGetUserByIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetUserById>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetUserByIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserHasAcceptedTOS = (
    params?: GetUserHasAcceptedTOSParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<TOSAccepted>(
      {url: `/User/HasAcceptedTOS`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserHasAcceptedTOSQueryKey = (params?: GetUserHasAcceptedTOSParams,) => {
    return [`/User/HasAcceptedTOS`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserHasAcceptedTOSQueryOptions = <TData = Awaited<ReturnType<typeof getUserHasAcceptedTOS>>, TError = unknown>(params?: GetUserHasAcceptedTOSParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserHasAcceptedTOS>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserHasAcceptedTOSQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserHasAcceptedTOS>>> = ({ signal }) => getUserHasAcceptedTOS(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserHasAcceptedTOS>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserHasAcceptedTOSQueryResult = NonNullable<Awaited<ReturnType<typeof getUserHasAcceptedTOS>>>
export type GetUserHasAcceptedTOSQueryError = unknown

export const useGetUserHasAcceptedTOS = <TData = Awaited<ReturnType<typeof getUserHasAcceptedTOS>>, TError = unknown>(
 params?: GetUserHasAcceptedTOSParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserHasAcceptedTOS>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserHasAcceptedTOSQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserSaveTermsOfSvcAgreement = (
    params?: PostUserSaveTermsOfSvcAgreementParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/User/SaveTermsOfSvcAgreement`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserSaveTermsOfSvcAgreementMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSaveTermsOfSvcAgreement>>, TError,{params?: PostUserSaveTermsOfSvcAgreementParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserSaveTermsOfSvcAgreement>>, TError,{params?: PostUserSaveTermsOfSvcAgreementParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserSaveTermsOfSvcAgreement>>, {params?: PostUserSaveTermsOfSvcAgreementParams}> = (props) => {
          const {params} = props ?? {};

          return  postUserSaveTermsOfSvcAgreement(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserSaveTermsOfSvcAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof postUserSaveTermsOfSvcAgreement>>>
    
    export type PostUserSaveTermsOfSvcAgreementMutationError = unknown

    export const usePostUserSaveTermsOfSvcAgreement = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserSaveTermsOfSvcAgreement>>, TError,{params?: PostUserSaveTermsOfSvcAgreementParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserSaveTermsOfSvcAgreement>>,
        TError,
        {params?: PostUserSaveTermsOfSvcAgreementParams},
        TContext
      > => {

      const mutationOptions = getPostUserSaveTermsOfSvcAgreementMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const getUserGetCompanyTypesByUser = (
    params?: GetUserGetCompanyTypesByUserParams,
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<GetUserGetCompanyTypesByUser200OneItem[] | GetUserGetCompanyTypesByUser200TwoItem[] | GetUserGetCompanyTypesByUser200ThreeItem[]>(
      {url: `/User/GetCompanyTypesByUser`, method: 'GET',
        params, signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserGetCompanyTypesByUserQueryKey = (params?: GetUserGetCompanyTypesByUserParams,) => {
    return [`/User/GetCompanyTypesByUser`, ...(params ? [params]: [])] as const;
    }

    
export const getGetUserGetCompanyTypesByUserQueryOptions = <TData = Awaited<ReturnType<typeof getUserGetCompanyTypesByUser>>, TError = unknown>(params?: GetUserGetCompanyTypesByUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetCompanyTypesByUser>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserGetCompanyTypesByUserQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserGetCompanyTypesByUser>>> = ({ signal }) => getUserGetCompanyTypesByUser(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserGetCompanyTypesByUser>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserGetCompanyTypesByUserQueryResult = NonNullable<Awaited<ReturnType<typeof getUserGetCompanyTypesByUser>>>
export type GetUserGetCompanyTypesByUserQueryError = unknown

export const useGetUserGetCompanyTypesByUser = <TData = Awaited<ReturnType<typeof getUserGetCompanyTypesByUser>>, TError = unknown>(
 params?: GetUserGetCompanyTypesByUserParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserGetCompanyTypesByUser>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserGetCompanyTypesByUserQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getUserFacingPermissionGetUserFacingPermissions = (
    
 options?: SecondParameter<typeof request>,signal?: AbortSignal
) => {
      
      
      return request<UserFacingPermissionInfo[]>(
      {url: `/UserFacingPermission/GetUserFacingPermissions`, method: 'GET', signal
    },
      { type: 'Customers',  ...options});
    }
  

export const getGetUserFacingPermissionGetUserFacingPermissionsQueryKey = () => {
    return [`/UserFacingPermission/GetUserFacingPermissions`] as const;
    }

    
export const getGetUserFacingPermissionGetUserFacingPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getUserFacingPermissionGetUserFacingPermissions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserFacingPermissionGetUserFacingPermissions>>, TError, TData>, request?: SecondParameter<typeof request>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserFacingPermissionGetUserFacingPermissionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserFacingPermissionGetUserFacingPermissions>>> = ({ signal }) => getUserFacingPermissionGetUserFacingPermissions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserFacingPermissionGetUserFacingPermissions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetUserFacingPermissionGetUserFacingPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getUserFacingPermissionGetUserFacingPermissions>>>
export type GetUserFacingPermissionGetUserFacingPermissionsQueryError = unknown

export const useGetUserFacingPermissionGetUserFacingPermissions = <TData = Awaited<ReturnType<typeof getUserFacingPermissionGetUserFacingPermissions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getUserFacingPermissionGetUserFacingPermissions>>, TError, TData>, request?: SecondParameter<typeof request>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetUserFacingPermissionGetUserFacingPermissionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const postUserFacingPermissionGetRoleUserFacingPermissions = (
    postUserFacingPermissionGetRoleUserFacingPermissionsBody: number[],
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<RoleUserFacingPermission[]>(
      {url: `/UserFacingPermission/GetRoleUserFacingPermissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserFacingPermissionGetRoleUserFacingPermissionsBody
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserFacingPermissionGetRoleUserFacingPermissionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionGetRoleUserFacingPermissions>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionGetRoleUserFacingPermissions>>, TError,{data: number[]}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFacingPermissionGetRoleUserFacingPermissions>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  postUserFacingPermissionGetRoleUserFacingPermissions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserFacingPermissionGetRoleUserFacingPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFacingPermissionGetRoleUserFacingPermissions>>>
    export type PostUserFacingPermissionGetRoleUserFacingPermissionsMutationBody = number[]
    export type PostUserFacingPermissionGetRoleUserFacingPermissionsMutationError = unknown

    export const usePostUserFacingPermissionGetRoleUserFacingPermissions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionGetRoleUserFacingPermissions>>, TError,{data: number[]}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserFacingPermissionGetRoleUserFacingPermissions>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getPostUserFacingPermissionGetRoleUserFacingPermissionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserFacingPermissionSaveRoleUserFacingPermissions = (
    postUserFacingPermissionSaveRoleUserFacingPermissionsBody: number[],
    params?: PostUserFacingPermissionSaveRoleUserFacingPermissionsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<void>(
      {url: `/UserFacingPermission/SaveRoleUserFacingPermissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postUserFacingPermissionSaveRoleUserFacingPermissionsBody,
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserFacingPermissionSaveRoleUserFacingPermissionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionSaveRoleUserFacingPermissions>>, TError,{data: number[];params?: PostUserFacingPermissionSaveRoleUserFacingPermissionsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionSaveRoleUserFacingPermissions>>, TError,{data: number[];params?: PostUserFacingPermissionSaveRoleUserFacingPermissionsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFacingPermissionSaveRoleUserFacingPermissions>>, {data: number[];params?: PostUserFacingPermissionSaveRoleUserFacingPermissionsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  postUserFacingPermissionSaveRoleUserFacingPermissions(data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserFacingPermissionSaveRoleUserFacingPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFacingPermissionSaveRoleUserFacingPermissions>>>
    export type PostUserFacingPermissionSaveRoleUserFacingPermissionsMutationBody = number[]
    export type PostUserFacingPermissionSaveRoleUserFacingPermissionsMutationError = unknown

    export const usePostUserFacingPermissionSaveRoleUserFacingPermissions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionSaveRoleUserFacingPermissions>>, TError,{data: number[];params?: PostUserFacingPermissionSaveRoleUserFacingPermissionsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserFacingPermissionSaveRoleUserFacingPermissions>>,
        TError,
        {data: number[];params?: PostUserFacingPermissionSaveRoleUserFacingPermissionsParams},
        TContext
      > => {

      const mutationOptions = getPostUserFacingPermissionSaveRoleUserFacingPermissionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
export const postUserFacingPermissionApplyRoleUfPermissions = (
    params?: PostUserFacingPermissionApplyRoleUfPermissionsParams,
 options?: SecondParameter<typeof request>,) => {
      
      
      return request<RoleUserFacingPermission[]>(
      {url: `/UserFacingPermission/ApplyRoleUfPermissions`, method: 'POST',
        params
    },
      { type: 'Customers',  ...options});
    }
  


export const getPostUserFacingPermissionApplyRoleUfPermissionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionApplyRoleUfPermissions>>, TError,{params?: PostUserFacingPermissionApplyRoleUfPermissionsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionApplyRoleUfPermissions>>, TError,{params?: PostUserFacingPermissionApplyRoleUfPermissionsParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUserFacingPermissionApplyRoleUfPermissions>>, {params?: PostUserFacingPermissionApplyRoleUfPermissionsParams}> = (props) => {
          const {params} = props ?? {};

          return  postUserFacingPermissionApplyRoleUfPermissions(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUserFacingPermissionApplyRoleUfPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postUserFacingPermissionApplyRoleUfPermissions>>>
    
    export type PostUserFacingPermissionApplyRoleUfPermissionsMutationError = unknown

    export const usePostUserFacingPermissionApplyRoleUfPermissions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUserFacingPermissionApplyRoleUfPermissions>>, TError,{params?: PostUserFacingPermissionApplyRoleUfPermissionsParams}, TContext>, request?: SecondParameter<typeof request>}
): UseMutationResult<
        Awaited<ReturnType<typeof postUserFacingPermissionApplyRoleUfPermissions>>,
        TError,
        {params?: PostUserFacingPermissionApplyRoleUfPermissionsParams},
        TContext
      > => {

      const mutationOptions = getPostUserFacingPermissionApplyRoleUfPermissionsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    
